(function () {
function $2892d4b3a4bd7b1c$export$5d0cc2edc113f064() {
    let requestVerificationToken = $("body").data("antiforgery-token");
    $.ajaxSetup({
        cache: false,
        headers: {
            "RequestVerificationToken": requestVerificationToken
        }
    });
}
function $2892d4b3a4bd7b1c$export$80f0146779479e00() {
    $(document).ajaxStart(function() {
        $("#loading").show();
    });
    $(document).ajaxStop(function() {
        $("#loading").hide();
    });
}


function $6ba8f3756a604e1e$var$fixAdOnScroll() {
    let width = $(document).width();
    let isTablet = width <= 976 && width > 768;
    let isMobile = width <= 768;
    if (isTablet || isMobile) {
        let $leaderboard = $(".leaderboard-container");
        if ($(window).scrollTop() > 100) {
            if (!$leaderboard.hasClass("ad-scroll-fix")) $leaderboard.addClass("ad-scroll-fix");
        } else $leaderboard.removeClass("ad-scroll-fix");
    }
}
function $6ba8f3756a604e1e$export$a391e9e11dfa825a() {
    //$(document).on('load', fixAdOnScroll);
    //$(document).on('resize', fixAdOnScroll);
    $(document).on("scroll", $6ba8f3756a604e1e$var$fixAdOnScroll);
}


function $02ccdfd5868f53aa$var$setHeroAds() {
    if (window.desktop != null) {
        let $body = $("body");
        let width = $(document).width();
        let heroContainer = $(".hero-takeover-container");
        $body.addClass("hero-takeover-active");
        const isTablet = width <= 976 && width > 767;
        const isMobile = width <= 767;
        if (isTablet) heroContainer.html($02ccdfd5868f53aa$var$getHtml(window.tablet, window.clickTag));
        else if (isMobile) {
            heroContainer.html($02ccdfd5868f53aa$var$getHtml(window.mobile, window.clickTag));
            $(".site-content-top").css("height", "400px");
        } else {
            heroContainer.html($02ccdfd5868f53aa$var$getHtml(window.desktop, window.clickTag));
            $(".site-content-top").css("height", "500px");
        }
    }
}
function $02ccdfd5868f53aa$var$getHtml(file, link) {
    return $("<a href='" + link + "' target='_blank'>" + '<div class="overlay-ad advert" style="background:url(\'' + file + "') center top no-repeat;\">" + "</div>" + "</a>");
}
function $02ccdfd5868f53aa$export$b2bb814f390b8ca1() {
    $(window).resize(function() {
        $02ccdfd5868f53aa$var$setHeroAds();
    });
    window.setHeroTakeover = function(desktop, tablet, mobile, clickTag) {
        window.desktop = desktop;
        window.tablet = tablet;
        window.mobile = mobile;
        window.clickTag = clickTag;
        $(window).resize();
    };
}


let $c26879fdf7f36150$var$data;
function $c26879fdf7f36150$var$markAsLoading() {
    $("#car-launch-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $c26879fdf7f36150$var$reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/car-launch/running-costs/query", State.data, function(response) {
        $("#car-launch-query-container").replaceWith(response);
    });
}
function $c26879fdf7f36150$var$setOperatingCycle() {
    $.get("/cap-operating-cycles/miles/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Miles").val(response);
    });
    $.get("/cap-operating-cycles/years/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Years").val(response);
    });
}
function $c26879fdf7f36150$var$buildUpQueryString(data) {
    let queryString = "";
    const operatingCycleDefault = $("#OperatingCycleId option").eq(0).val();
    if (data.OperatingCycleId != operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Years=" + data.Years + "&Miles=" + data.Miles + "&ModelGroupId=" + data.ModelGroupId + "&DerivativeId=" + data.DerivativeId;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.imageId) > 0) queryString += "image=" + data.imageId;
    else queryString += "image=";
    if (data.ModelYear !== "") queryString += "&ModelYear=" + data.ModelYear;
    return "?" + queryString;
}
function $c26879fdf7f36150$var$getData(page) {
    const operatingCycleId = $("#OperatingCycleId").val();
    const miles = $("#Miles").val();
    const years = $("#Years").val();
    const modelGroupId = $("#ModelGroupId").val();
    const imageId = $("#Image").val();
    const derivativeId = $("#DerivativeId").val();
    const modelYear = $("#ModelYear").val();
    return {
        OperatingCycleId: operatingCycleId,
        Miles: miles,
        Years: years,
        DerivativeId: derivativeId,
        imageId: imageId,
        ModelGroupId: modelGroupId,
        ModelYear: modelYear
    };
}
function $c26879fdf7f36150$var$updateRunningCostsLogic(page) {
    const data = $c26879fdf7f36150$var$getData(page);
    History.pushState(data, $("title").html(), location.pathname + $c26879fdf7f36150$var$buildUpQueryString(data));
}
function $c26879fdf7f36150$var$onImageSliderChange(event) {
    const image = $(event.target.currSlide.content).data("image-id");
    console.log(image);
    $("#Image").val(image);
    window.updateRunningCosts();
}
function $c26879fdf7f36150$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown == "OperatingCycleId") {
        const derivativeId = $("#DerivativeId").val();
        if (parseInt(derivativeId) > 0) {
            const id = $(this).val();
            $.get("/cap-operating-cycles/miles/" + id, function(response) {
                $("#Miles").val(response);
                $.get("/cap-operating-cycles/years/" + id, function(response) {
                    $("#Years").val(response);
                    window.updateRunningCosts();
                });
            });
        } else alert("please select a derivative first");
    } else if (currentDropdown == "DerivativeId") {
        $("#DerivativeId").val($(this).val());
        window.updateRunningCosts();
    }
}
function $c26879fdf7f36150$export$a6a4a29a790aae85() {
    if ($("[data-car-launch-running-costs]").length) {
        window.updateRunningCosts = function() {
            $c26879fdf7f36150$var$updateRunningCostsLogic(1);
        };
        window.loadCarLaunchGallery = function() {
            const sliders = $("[data-car-launch-slider-gallery]");
            if (sliders.length == 0) return;
            sliders.each(function(index, element) {
                const $element = $(element);
                if ($element.data("royalSlider") != null) return;
                const slider = $element.royalSlider({
                    arrowsNavAutoHide: false,
                    imageScaleMode: "fit-if-smaller",
                    imageScalePadding: 0,
                    autoScaleSlider: true,
                    autoScaleSliderWidth: 750,
                    autoScaleSliderHeight: 563,
                    globalCaption: true,
                    controlNavigationSpacing: 0,
                    controlNavigation: "none",
                    loop: true,
                    numImagesToPreload: 1,
                    keyboardNavEnabled: true,
                    usePreloader: false,
                    slidesSpacing: 0,
                    minSlideOffset: 0,
                    thumbs: {
                        arrowsAutoHide: true,
                        spacing: 0
                    }
                });
                const sliderData = slider.data("royalSlider");
                $c26879fdf7f36150$var$data = sliders.data("car-launch-slider-query-string");
                if ($c26879fdf7f36150$var$data.image) for(let i = 0; i < sliderData.slides.length; i++){
                    const slide = sliderData.slides[i];
                    if (slide.content.data("image-id") == $c26879fdf7f36150$var$data.image) {
                        // as per http://help.dimsemenov.com/discussions/problems/1373-gotosilent-version-93
                        sliderData.st.transitionSpeed = 0;
                        sliderData.goTo(slide.id);
                        setTimeout(function() {
                            sliderData.st.transitionSpeed = 600;
                        }, 10);
                    }
                }
                sliderData.ev.on("rsAfterSlideChange", $c26879fdf7f36150$var$onImageSliderChange);
                window.gallerySliderData = sliderData;
                const siblings = $element.siblings("[data-slider-caption-container]");
                const caption = $element.find(".rsGCaption");
                caption.appendTo(siblings);
            });
            $(".rsNav.rsThumbs.rsThumbsHor").attr("style", "height:auto");
        };
        window.loadCarLaunchGallery();
        $c26879fdf7f36150$var$setOperatingCycle();
        $(document).on("change", "[data-car-launch-running-costs] select", $c26879fdf7f36150$var$onChangeFilters);
    //History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
    //    markAsLoading();
    //    reloadQuery();
    //    const State = History.getState();
    //    setTimeout(
    //        function () {
    //            $.get('/car-launch/running-costs/results', State.data, function (response) {
    //                $('#car-launch-results-container').replaceWith(response);
    //            });
    //        }, 500);
    //});
    }
}


function $0931948934220f52$var$onChangeFilters(event) {
    var currentDropdown = $(this).attr("name");
    if (currentDropdown == "ManufacturerId") $.get("/cap-manufacturer-url/" + $(this).val(), function(response) {
        $("#ManufacturerName").val(response);
        window.updateResults();
    });
}
function $0931948934220f52$var$getData() {
    var manufacturerId = $("#ManufacturerId").val();
    var manufacturerName = $("#ManufacturerName").val();
    return {
        ManufacturerId: manufacturerId,
        ManufacturerName: manufacturerName
    };
}
function $0931948934220f52$var$buildUpQueryString(data) {
    return "?Manufacturer=" + data.ManufacturerName;
}
function $0931948934220f52$var$updateResultsLogic() {
    var data = $0931948934220f52$var$getData();
    History.pushState(data, $("title").html(), location.pathname + $0931948934220f52$var$buildUpQueryString(data));
}
function $0931948934220f52$var$reloadQuery() {
    var State = History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/car-launch-calendar/query", State.data, function(response) {
        $("#car-launch-calendar-query-container").replaceWith(response);
    });
}
function $0931948934220f52$var$markAsLoading() {
    $("#car-launches-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $0931948934220f52$export$30c8b39afd1a4d2b() {
    //dropdown changes
    $(document).on("change", "[data-car-launch-calendar] select", $0931948934220f52$var$onChangeFilters);
    if ($("[data-car-launch-calendar]").length) window.updateResults = function() {
        $0931948934220f52$var$updateResultsLogic();
    };
} //(function ($) {
 //    function getForm() {
 //        return $("[data-car-launch-calendar-form]");
 //    }
 //    function submitForm() {
 //        var form = getForm();
 //        form.submit();
 //    }
 //    $(function () {
 //        $(document).on("change", "#Year", submitForm);
 //    });
 //})(jQuery);


function $c0e2aeb39b8be769$export$d0990ca26e3a22f3() {
    $(document).on("change", "form[data-car-review-search] select", function(e) {
        $c0e2aeb39b8be769$var$markAsLoading();
        $c0e2aeb39b8be769$var$submitForm(e);
    });
}
function $c0e2aeb39b8be769$var$markAsLoading() {
    let container = $("#car-reviews-search-loading-container");
    container.height(50); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $c0e2aeb39b8be769$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}


var $06aa7a5ca72b8734$var$data;
function $06aa7a5ca72b8734$var$updateUrl(event) {
    var history = window.History;
    var stateData = $.extend({}, $06aa7a5ca72b8734$var$data);
    stateData.image = $(event.target.currSlide.content).data("image-id");
    history.pushState(stateData, $("title").html(), location.pathname + "?" + $.param(stateData));
    var movePosition = 0;
    var nextArticle = event.target.slider.parents("[data-more-article]");
    if (nextArticle.text() == "") {
        movePosition = event.target.slider.parents(".main-content-wrapper").find("#gallery-container").offset().top;
        if (movePosition > 237) movePosition = 237;
    } else movePosition = nextArticle.find(".main-content-wrapper").find("#gallery-container").offset().top;
    $("html, body").animate({
        scrollTop: movePosition
    }, "slow");
}
function $06aa7a5ca72b8734$var$loadGallery() {
    var sliders = $("[data-car-launch-slider-gallery]");
    if (sliders.length == 0) return;
    sliders.each(function(index, element) {
        var $element = $(element);
        if ($element.data("royalSlider") != null) return;
        var slider = $element.royalSlider({
            arrowsNavAutoHide: false,
            imageScaleMode: "fit-if-smaller",
            imageScalePadding: 0,
            autoScaleSlider: true,
            autoScaleSliderWidth: 750,
            autoScaleSliderHeight: 563,
            globalCaption: true,
            controlNavigationSpacing: 0,
            controlNavigation: "none",
            loop: true,
            numImagesToPreload: 1,
            keyboardNavEnabled: true,
            usePreloader: false,
            slidesSpacing: 0,
            minSlideOffset: 0,
            thumbs: {
                arrowsAutoHide: true,
                spacing: 0
            }
        });
        var sliderData = slider.data("royalSlider");
        $06aa7a5ca72b8734$var$data = sliders.data("car-launch-slider-query-string");
        if ($06aa7a5ca72b8734$var$data.image) for(var i = 0; i < sliderData.slides.length; i++){
            var slide = sliderData.slides[i];
            if (slide.content.data("image-id") == $06aa7a5ca72b8734$var$data.image) {
                // as per http://help.dimsemenov.com/discussions/problems/1373-gotosilent-version-93
                sliderData.st.transitionSpeed = 0;
                sliderData.goTo(slide.id);
                setTimeout(function() {
                    sliderData.st.transitionSpeed = 600;
                }, 10);
            }
        }
        sliderData.ev.on("rsAfterSlideChange", $06aa7a5ca72b8734$var$updateUrl);
        window.gallerySliderData = sliderData;
        var siblings = $element.siblings("[data-slider-caption-container]");
        var caption = $element.find(".rsGCaption");
        caption.appendTo(siblings);
    });
    $(".rsNav.rsThumbs.rsThumbsHor").attr("style", "height:auto");
}
function $06aa7a5ca72b8734$export$4480b153ba60206d() {
    if ($("[data-car-launch-gallery]").length) {
        window.loadGallery = $06aa7a5ca72b8734$var$loadGallery;
        $06aa7a5ca72b8734$var$loadGallery();
    }
}


function $593cd257706de00c$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $593cd257706de00c$export$53c248b281253aba() {}


function $728b06aeb66604b2$var$changeManufacturer() {
    var manufacturerName = $("#ManufacturerId").val();
    $.get("/cars/landing-page/query?ManufacturerName=" + manufacturerName, function(response) {
        $("[data-car-landing-page-query]").replaceWith(response);
    });
//window.location = $("#ManufacturerId").val();
}
function $728b06aeb66604b2$var$changeModel() {
    var modelName = $("#ModelId").val();
    $("#ModelName").val(modelName);
}
function $728b06aeb66604b2$export$a09f327970c84284() {
    if ($("[data-cars-landing-page]").length) {
        $(document).on("change", "#ManufacturerId", $728b06aeb66604b2$var$changeManufacturer);
        $(document).on("change", "#ModelId", $728b06aeb66604b2$var$changeModel);
        $("#ManufacturerId").trigger("change");
    }
}


function $aca60e5b2e026969$var$getForm() {
    return $("[data-car-stats-form]");
}
function $aca60e5b2e026969$var$submitForm() {
    const form = $aca60e5b2e026969$var$getForm();
    form.submit();
}
function $aca60e5b2e026969$var$addToCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-add-id");
    $aca60e5b2e026969$var$addVehicle(data);
}
function $aca60e5b2e026969$var$addVehicle(id) {
    $.get("/compare-list/handle/add/" + id, function(response) {
        if (response == 0) {
            const form = $aca60e5b2e026969$var$getForm();
            form.submit();
        } else if (response == 1) alert("Maximum of 5 vehicles.");
        else if (response == 2) alert("Already added to the compare list. Please select another vehicle.");
        else alert("Error");
    });
}
function $aca60e5b2e026969$var$removeFromCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-remove-id");
    $aca60e5b2e026969$var$removeVehicle(data);
}
function $aca60e5b2e026969$var$removeVehicle(id) {
    $.get("/compare-list/handle/remove/" + id, function(response) {
        const form = $aca60e5b2e026969$var$getForm();
        form.submit();
    });
}
function $aca60e5b2e026969$export$ce72890db155540c() {
    if ($("[data-car-stats-page]").length) {
        $(document).on("change", "#OperatingCycleId", $aca60e5b2e026969$var$submitForm);
        $(document).on("click", "[data-compare-list-add-id]", $aca60e5b2e026969$var$addToCompareList);
        $(document).on("click", "[data-compare-list-remove-id]", $aca60e5b2e026969$var$removeFromCompareList);
    }
}


function $94302a5ffb81bfa2$var$getForm() {
    return $("[data-air-index-vehicle-form]");
}
function $94302a5ffb81bfa2$var$submitForm() {
    const form = $94302a5ffb81bfa2$var$getForm();
    form.submit();
}
function $94302a5ffb81bfa2$var$addToCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-add-id");
    $94302a5ffb81bfa2$var$addVehicle(data);
}
function $94302a5ffb81bfa2$var$addVehicle(id) {
    $.get("/emissions-data/compare-list/handle/add/" + id, function(response) {
        if (response == 0) {
            const form = $94302a5ffb81bfa2$var$getForm();
            form.submit();
        } else if (response == 1) alert("Maximum of 5 vehicles.");
        else if (response == 2) alert("Already added to the compare list. Please select another vehicle.");
        else alert("Error");
    });
}
function $94302a5ffb81bfa2$var$removeFromCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-remove-id");
    $94302a5ffb81bfa2$var$removeVehicle(data);
}
function $94302a5ffb81bfa2$var$removeVehicle(id) {
    $.get("/emissions-data/compare-list/handle/remove/" + id, function(response) {
        const form = $94302a5ffb81bfa2$var$getForm();
        form.submit();
    });
}
function $94302a5ffb81bfa2$export$a364db890d354a0c() {
    if ($("[data-air-index-vehicle-page]").length) {
        $(document).on("click", "[data-compare-list-add-id]", $94302a5ffb81bfa2$var$addToCompareList);
        $(document).on("click", "[data-compare-list-remove-id]", $94302a5ffb81bfa2$var$removeFromCompareList);
    }
}


function $d700ac7e948a3f2e$export$d9879cc485083cbe() {
    const commentingBox = `commentingBox${$("[data-main-content]").data("main-content")}`;
    window.commentBox = function() {
        if (window.isViewportGreaterThanOrEqualTo("lg")) $(".comment-box .panel-collapse.collapse").removeClass();
        else {
            const commentingClass = $(`#${commentingBox}`).attr("class");
            if (commentingClass == "") $(`#${commentingBox}`).addClass("panel-collapse collapse");
            else if (commentingClass == "collapse in") $(`#${commentingBox}`).removeClass().addClass("panel-collapse collapse");
        }
    };
    window.commentBoxDesktop = function() {
        if (window.isViewportGreaterThanOrEqualTo("lg")) {
            const commentingClass = $(`#${commentingBox}`).attr("class");
            if (commentingClass == "") $(`#${commentingBox}`).removeClass().addClass("collapse in");
            else if (commentingClass == "collapse in") $(`#${commentingBox}`).removeClass().addClass("collapse");
            else if (commentingClass == "collapse") $(`#${commentingBox}`).removeClass().addClass("collapse in");
        }
    };
    window.commentBox();
    $(window).resize(function() {
        window.commentBox();
    });
    $(document).on("click", ".comment-box .panel-heading a", window.commentBoxDesktop);
}


const $fee793ddf9b673e0$var$History = window.History; // Note: We are using a capital H instead of a lower h
let $fee793ddf9b673e0$var$compareListSortBy;
let $fee793ddf9b673e0$var$compareListSortDesc;
function $fee793ddf9b673e0$var$getData() {
    const sortBy = $fee793ddf9b673e0$var$compareListSortBy;
    const sortDesc = $fee793ddf9b673e0$var$compareListSortDesc;
    return {
        SortBy: sortBy,
        SortDesc: sortDesc
    };
}
function $fee793ddf9b673e0$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    return "?" + queryString;
}
function $fee793ddf9b673e0$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("compare-list-sort");
    if ($fee793ddf9b673e0$var$compareListSortBy !== newSortBy) $fee793ddf9b673e0$var$compareListSortDesc = "false";
    else $fee793ddf9b673e0$var$compareListSortDesc = "true";
    $fee793ddf9b673e0$var$compareListSortBy = newSortBy;
    const data = $fee793ddf9b673e0$var$getData();
    $fee793ddf9b673e0$var$History.pushState(data, $("title").html(), location.pathname + $fee793ddf9b673e0$var$buildUpQueryString(data));
}
function $fee793ddf9b673e0$export$c95db721723386e7() {
    if (!$("[data-compare-list]").length) return;
    $fee793ddf9b673e0$var$compareListSortBy = $("#SortBy").val();
    $fee793ddf9b673e0$var$compareListSortDesc = $("#SortDesc").val();
    $(document).on("click", "[data-compare-list-sort]", $fee793ddf9b673e0$var$sortResults);
    $(`[data-compare-list-sort=${$fee793ddf9b673e0$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
    if ($fee793ddf9b673e0$var$compareListSortDesc.toLowerCase() === "true") $("[data-compare-list-sort=" + $fee793ddf9b673e0$var$compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    $(document).on("click", "[data-remove-from-list]", function(event) {
        const id = $(this).attr("data-remove-from-list");
        $.get("/compare-list/handle/remove/" + id, function(response) {});
    });
//History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
//    const State = History.getState();
//    $.get('/compare-list/results/' + $('#RunningCostIds').val(), State.data, function (response) {
//        $('#compare-list-results-container').replaceWith(response);
//        $(`[data-compare-list-sort=${compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
//        if (compareListSortDesc.toLowerCase() === "true") {
//            $("[data-compare-list-sort=" + compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
//        }
//    });
//});
}


const $a14a535463e27110$var$History = window.History; // Note: We are using a capital H instead of a lower h
let $a14a535463e27110$var$compareListSortBy;
let $a14a535463e27110$var$compareListSortDesc;
function $a14a535463e27110$var$getData() {
    const sortBy = $a14a535463e27110$var$compareListSortBy;
    const sortDesc = $a14a535463e27110$var$compareListSortDesc;
    return {
        SortBy: sortBy,
        SortDesc: sortDesc
    };
}
function $a14a535463e27110$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    return "?" + queryString;
}
function $a14a535463e27110$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("air-index-compare-list-sort");
    if ($a14a535463e27110$var$compareListSortBy !== newSortBy) $a14a535463e27110$var$compareListSortDesc = "false";
    else $a14a535463e27110$var$compareListSortDesc = "true";
    $a14a535463e27110$var$compareListSortBy = newSortBy;
    const data = $a14a535463e27110$var$getData();
    $a14a535463e27110$var$History.pushState(data, $("title").html(), location.pathname + $a14a535463e27110$var$buildUpQueryString(data));
}
function $a14a535463e27110$export$2d8fba0164856121() {
    if (!$("[data-air-index-compare-list]").length) return;
    $a14a535463e27110$var$compareListSortBy = $("#SortBy").val();
    $a14a535463e27110$var$compareListSortDesc = $("#SortDesc").val();
    $(document).on("click", "[data-air-index-compare-list-sort]", $a14a535463e27110$var$sortResults);
    $(`[data-air-index-compare-list-sort=${$a14a535463e27110$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
    if ($a14a535463e27110$var$compareListSortDesc.toLowerCase() === "true") $("[data-air-index-compare-list-sort=" + $a14a535463e27110$var$compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    $(document).on("click", "[data-air-index-remove-from-list]", function(event) {
        const id = $(this).attr("data-air-index-remove-from-list");
        $.get("/emissions-data/compare-list/handle/remove/" + id, function(response) {});
    });
    $a14a535463e27110$var$History.Adapter.bind(window, "statechange", function() {
        const State = $a14a535463e27110$var$History.getState();
        $.get("/emissions-data/compare-list/results/" + $("#AirIndexVehicleIds").val(), State.data, function(response) {
            $("#compare-list-results-container").replaceWith(response);
            $(`[data-air-index-compare-list-sort=${$a14a535463e27110$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
            if ($a14a535463e27110$var$compareListSortDesc.toLowerCase() === "true") $("[data-compare-list-sort=" + $a14a535463e27110$var$compareListSortBy + "]").attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
        });
    });
}


/*!
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ (function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else factory(jQuery);
})(function($) {
    "use strict";
    var instances = [], matchers = [], defaultOptions = {
        precision: 100,
        elapse: false,
        defer: false
    };
    matchers.push(/^[0-9]*$/.source);
    matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    matchers.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    matchers = new RegExp(matchers.join("|"));
    function parseDateString(dateString) {
        if (dateString instanceof Date) return dateString;
        if (String(dateString).match(matchers)) {
            if (String(dateString).match(/^[0-9]*$/)) dateString = Number(dateString);
            if (String(dateString).match(/\-/)) dateString = String(dateString).replace(/\-/g, "/");
            return new Date(dateString);
        } else throw new Error("Couldn't cast `" + dateString + "` to a date object.");
    }
    var DIRECTIVE_KEY_MAP = {
        Y: "years",
        m: "months",
        n: "daysToMonth",
        d: "daysToWeek",
        w: "weeks",
        W: "weeksToMonth",
        H: "hours",
        M: "minutes",
        S: "seconds",
        D: "totalDays",
        I: "totalHours",
        N: "totalMinutes",
        T: "totalSeconds"
    };
    function escapedRegExp(str) {
        var sanitize = str.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        return new RegExp(sanitize);
    }
    function strftime(offsetObject) {
        return function(format) {
            var directives = format.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
            if (directives) for(var i = 0, len = directives.length; i < len; ++i){
                var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/), regexp = escapedRegExp(directive[0]), modifier = directive[1] || "", plural = directive[3] || "", value = null;
                directive = directive[2];
                if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
                    value = DIRECTIVE_KEY_MAP[directive];
                    value = Number(offsetObject[value]);
                }
                if (value !== null) {
                    if (modifier === "!") value = pluralize(plural, value);
                    if (modifier === "") {
                        if (value < 10) value = "0" + value.toString();
                    }
                    format = format.replace(regexp, value.toString());
                }
            }
            format = format.replace(/%%/, "%");
            return format;
        };
    }
    function pluralize(format, count) {
        var plural = "s", singular = "";
        if (format) {
            format = format.replace(/(:|;|\s)/gi, "").split(/\,/);
            if (format.length === 1) plural = format[0];
            else {
                singular = format[0];
                plural = format[1];
            }
        }
        if (Math.abs(count) > 1) return plural;
        else return singular;
    }
    var Countdown = function(el, finalDate, options) {
        this.el = el;
        this.$el = $(el);
        this.interval = null;
        this.offset = {};
        this.options = $.extend({}, defaultOptions);
        this.instanceNumber = instances.length;
        instances.push(this);
        this.$el.data("countdown-instance", this.instanceNumber);
        if (options) {
            if (typeof options === "function") {
                this.$el.on("update.countdown", options);
                this.$el.on("stoped.countdown", options);
                this.$el.on("finish.countdown", options);
            } else this.options = $.extend({}, defaultOptions, options);
        }
        this.setFinalDate(finalDate);
        if (this.options.defer === false) this.start();
    };
    $.extend(Countdown.prototype, {
        start: function() {
            if (this.interval !== null) clearInterval(this.interval);
            var self = this;
            this.update();
            this.interval = setInterval(function() {
                self.update.call(self);
            }, this.options.precision);
        },
        stop: function() {
            clearInterval(this.interval);
            this.interval = null;
            this.dispatchEvent("stoped");
        },
        toggle: function() {
            if (this.interval) this.stop();
            else this.start();
        },
        pause: function() {
            this.stop();
        },
        resume: function() {
            this.start();
        },
        remove: function() {
            this.stop.call(this);
            instances[this.instanceNumber] = null;
            delete this.$el.data().countdownInstance;
        },
        setFinalDate: function(value) {
            this.finalDate = parseDateString(value);
        },
        update: function() {
            if (this.$el.closest("html").length === 0) {
                this.remove();
                return;
            }
            var hasEventsAttached = $._data(this.el, "events") !== undefined, now = new Date(), newTotalSecsLeft;
            newTotalSecsLeft = this.finalDate.getTime() - now.getTime();
            newTotalSecsLeft = Math.ceil(newTotalSecsLeft / 1e3);
            newTotalSecsLeft = !this.options.elapse && newTotalSecsLeft < 0 ? 0 : Math.abs(newTotalSecsLeft);
            if (this.totalSecsLeft === newTotalSecsLeft || !hasEventsAttached) return;
            else this.totalSecsLeft = newTotalSecsLeft;
            this.elapsed = now >= this.finalDate;
            this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - now.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 60),
                totalSeconds: this.totalSecsLeft
            };
            if (!this.options.elapse && this.totalSecsLeft === 0) {
                this.stop();
                this.dispatchEvent("finish");
            } else this.dispatchEvent("update");
        },
        dispatchEvent: function(eventName) {
            var event = $.Event(eventName + ".countdown");
            event.finalDate = this.finalDate;
            event.elapsed = this.elapsed;
            event.offset = $.extend({}, this.offset);
            event.strftime = strftime(this.offset);
            this.$el.trigger(event);
        }
    });
    $.fn.countdown = function() {
        var argumentsArray = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            var instanceNumber = $(this).data("countdown-instance");
            if (instanceNumber !== undefined) {
                var instance = instances[instanceNumber], method = argumentsArray[0];
                if (Countdown.prototype.hasOwnProperty(method)) instance[method].apply(instance, argumentsArray.slice(1));
                else if (String(method).match(/^[$A-Z_][0-9A-Z_$]*$/i) === null) {
                    instance.setFinalDate.call(instance, method);
                    instance.start();
                } else $.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, method));
            } else new Countdown(this, argumentsArray[0], argumentsArray[1]);
        });
    };
});


function $7ef9cb8dc2b7724c$var$createCountdown(item) {
    item.countdown(item.data("countdown-date"), function(event) {
        item.find("[data-countdown-days]").text(event.strftime("%D"));
        item.find("[data-countdown-hours]").text(event.strftime("%H"));
        item.find("[data-countdown-minutes]").text(event.strftime("%M"));
        item.find("[data-countdown-seconds]").text(event.strftime("%S"));
    });
}
function $7ef9cb8dc2b7724c$export$55fbd5f0890cdf7e() {
    $("[data-countdown-date]").each(function() {
        $7ef9cb8dc2b7724c$var$createCountdown($(this));
    });
}


const $165cb073955e137a$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $165cb073955e137a$var$getActivePrices() {
    const greenButtons = $("[data-price] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $165cb073955e137a$var$updatePrices(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateResults();
}
function $165cb073955e137a$var$validateCustomForm() {
    $("#deal-contact-box").validate({
        rules: {
            Email: {
                required: true,
                email: true
            }
        }
    });
}
function $165cb073955e137a$var$submitContactForm(e) {
    const form = $(e.target);
    if (!form.valid()) return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function(response) {
        $("[id^=deal-thankyou]").empty();
        const dealId = $("#Deal_Id").val();
        const message = $("[data-thankyou-message]").data("thankyou-message");
        $("#deal-thankyou-" + dealId).empty().append("<div class='alert alert-success'>" + message + "</div>");
        const currentfeatherlight = $.featherlight.current();
        if (currentfeatherlight) currentfeatherlight.close();
    });
}
function $165cb073955e137a$var$getData(page) {
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const sortBy = $("#SortBy").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const mileagePerAnnum = $("#MileagePerAnnum").val();
    const priceFilter = $165cb073955e137a$var$getActivePrices();
    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        MileagePerAnnum: mileagePerAnnum,
        PriceFilter: priceFilter,
        SortBy: sortBy,
        Page: page
    };
}
function $165cb073955e137a$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.ManufacturerName;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.ModelName;
    if (queryString.length > 0) queryString += "&";
    queryString += "MileagePerAnnum=" + data.MileagePerAnnum;
    if (queryString.length > 0) queryString += "&";
    queryString += "PriceFilter=" + data.PriceFilter;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Page=" + data.Page;
    }
    return "?" + queryString;
}
function $165cb073955e137a$var$updateResultsLogic(page) {
    const data = $165cb073955e137a$var$getData(page);
    $165cb073955e137a$var$History.pushState(data, $("title").html(), location.pathname + $165cb073955e137a$var$buildUpQueryString(data));
}
function $165cb073955e137a$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] === "p";
    })[0].split("=")[1];
}
function $165cb073955e137a$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get("/manufacturer-url/" + manId, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $165cb073955e137a$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get("/model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
function $165cb073955e137a$var$reloadQuery() {
    const State = $165cb073955e137a$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/deals/query", State.data, function(response) {
        $("#deals-page-query-container").replaceWith(response);
    });
}
function $165cb073955e137a$var$markAsLoading() {
    $("#deals-page-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $165cb073955e137a$var$pageData(event) {
    $("html, body").animate({
        scrollTop: 0
    }, 400);
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $165cb073955e137a$var$getPage($(this).attr("href"));
    $165cb073955e137a$var$updateResultsLogic(page);
}
function $165cb073955e137a$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        $.get("/manufacturer-url/" + $(this).val(), function(response) {
            $("#ManufacturerName").val(response);
            window.updateResults();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            const manufacturerId = $("#ManufacturerId").val();
            $.get(`/manufacturer-url/${manufacturerId}`, function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get(`/model-url/${manufacturerId}/${$(this).val()}`, function(response) {
                $("#ModelName").val(response);
                window.updateResults();
            });
        } else {
            $("#ModelName").val("");
            window.updateResults();
        }
    } else window.updateResults();
}
function $165cb073955e137a$export$94d83d887297dd2() {
    if ($("[data-deals-page]").length) {
        window.updateResults = function() {
            $165cb073955e137a$var$updateResultsLogic(1);
        };
        $.featherlight.defaults.afterOpen = $165cb073955e137a$var$validateCustomForm;
        jQuery.validator.setDefaults({
            success: "valid"
        });
        $165cb073955e137a$var$setManufacturer(window.location.href);
        $165cb073955e137a$var$setModel(window.location.href);
        //dropdown changes
        $(document).on("change", "[data-deals-page] input, [data-deals-page] select", $165cb073955e137a$var$onChangeFilters);
        //paging click
        $(document).on("click", "#deals-page-results-container .pagination a", $165cb073955e137a$var$pageData);
        //fuel type button chagnes
        $(document).on("click", "[data-price] a", $165cb073955e137a$var$updatePrices);
        $(document).on("submit", "[data-deal-contact-form]", $165cb073955e137a$var$submitContactForm);
    // Bind to StateChange Event
    //History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
    //    markAsLoading();
    //    reloadQuery();
    //    const State = History.getState();
    //    setTimeout(
    //        function () {
    //            $.get('/deals/results', State.data, function (response) {
    //                $('#deals-page-results-container').replaceWith(response);
    //            });
    //        }, 600);
    //});
    }
}


function $82264929ebb8a49e$var$filterFaqs(event) {
    event.preventDefault();
    const search = $(event.currentTarget).val();
    $("[data-faq-name] a").each(function(index, element) {
        const link = $(element);
        const faqName = link.text();
        if (faqName.toLowerCase().indexOf(search.toLowerCase()) > -1) link.parents("[data-faq-name]").removeClass("d-none");
        else link.parents("[data-faq-name]").addClass("d-none");
    });
    $("[data-faq-category]").each(function(index, element) {
        const category = $(element);
        const visibleFaqs = category.find("[data-faq-name]:not(.d-none)");
        if (visibleFaqs.length > 0) category.removeClass("d-none");
        else category.addClass("d-none");
    });
}
function $82264929ebb8a49e$export$10b45b794006d1d0() {
    $(document).on("keyup", "[data-faq-search]", $82264929ebb8a49e$var$filterFaqs);
}


function $4c3677df652e2937$var$getButton(e) {
    return $(e.target).siblings("[data-trigger-button]");
}
function $4c3677df652e2937$var$show(e) {
    $4c3677df652e2937$var$getButton(e).text("View less");
    //getButton(e).hide();
    $("[data-view-all]").removeClass("hidden");
}
function $4c3677df652e2937$var$hide(e) {
    $4c3677df652e2937$var$getButton(e).text("View more");
    $("[data-view-all]").addClass("hidden");
}
function $4c3677df652e2937$export$7b633cd5cf57daa2() {
    if ($("[data-fleet-management]").length) {
        const moreTaggedNews = $("#more-tagged-news");
        moreTaggedNews.on("show.bs.collapse", $4c3677df652e2937$var$show);
        moreTaggedNews.on("hide.bs.collapse", $4c3677df652e2937$var$hide);
    }
}


function $3e663d5dbb36a26e$var$getFuelCostsWidgetForm() {
    return $("[data-fuel-costs-widget]");
}
function $3e663d5dbb36a26e$var$getCarTaxWidgetForm() {
    return $("[data-car-tax-widget]");
}
function $3e663d5dbb36a26e$var$submitCarTaxWidgetForm() {
    const form = $3e663d5dbb36a26e$var$getCarTaxWidgetForm();
    form.submit();
}
function $3e663d5dbb36a26e$var$submitFuelCostsWidgetForm() {
    const form = $3e663d5dbb36a26e$var$getFuelCostsWidgetForm();
    form.submit();
}
function $3e663d5dbb36a26e$export$124a9858458e53dc() {
    $(document).on("change", "[data-car-tax-widget-select]", $3e663d5dbb36a26e$var$submitCarTaxWidgetForm);
    $(document).on("change", "[data-fuel-costs-widget-select]", $3e663d5dbb36a26e$var$submitFuelCostsWidgetForm);
}


function $9e13b2ad467bb145$export$54941c72d7452803() {
    $(document).on("submit", "[data-fleetnews-user-data-form]", $9e13b2ad467bb145$var$submitUserDataForm);
    $(document).on("submit", "[data-fleetnews-user-data-close-form]", $9e13b2ad467bb145$var$closeForm);
}
function $9e13b2ad467bb145$var$closeForm(e) {
    const form = $(e.target);
    if (!form.valid()) return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function(response) {
        $("[data-fleetnews-user-data]").remove();
    });
}
function $9e13b2ad467bb145$var$submitUserDataForm(e) {
    const toChooseMyNextCompanyCarButton = $("#ToChooseMyNextCompanyCarButton").attr("class");
    if (toChooseMyNextCompanyCarButton.indexOf("active") > -1) $("#ToChooseMyNextCompanyCar").val(true);
    const toManageMyCompanyFleetButton = $("#ToManageMyCompanyFleetButton").attr("class");
    if (toManageMyCompanyFleetButton.indexOf("active") > -1) $("#ToManageMyCompanyFleet").val(true);
    const otherButton = $("#OtherButton").attr("class");
    if (otherButton.indexOf("active") > -1) $("#Other").val(true);
    const form = $(e.target);
    if (!form.valid()) return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function(response) {
        $("[data-fleetnews-user-data]").remove();
    });
}


function $a83f24934579ebaa$export$85500d64d8b96a12() {
    if ($("[data-fn-200]").length) $("#fn200-table").DataTable({
        responsive: true,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
}


function $57a44814a6005e07$export$29a95a623dfab103() {
    $("[data-ads-body-copy]  p:nth-child(4)").after('<style>.bib__name {color: #d38407;}</style><div id="bib--rcm-text-only-element"></div>');
}


function $0223437a5c85c95b$var$filterCompanies(event) {
    event.preventDefault();
    const search = $(event.currentTarget).val();
    $("[data-company-name]").each(function(index, element) {
        const link = $(element);
        const companyName = link.data("company-name");
        if (companyName.toLowerCase().indexOf(search.toLowerCase()) > -1) $(this).removeClass("d-none");
        else $(this).addClass("d-none");
    });
}
function $0223437a5c85c95b$var$format(id, tr) {
    var jqXHR = $.ajax({
        url: `/fleet200-company/get/${id}`,
        type: "GET",
        async: false
    });
    const obj = JSON.parse(jqXHR.responseText);
    if (obj[0].name1 === "" && obj[0].name3 === "" && obj[0].name3 === "" && obj[0].name4 === "" && obj[0].name5 === "") ;
    else {
        var returnText = "<div class='padding-left-75 padding-right-75'>";
        if (obj[0].name1 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name1;
            if (obj[0].jobTitle1 !== "") returnText += "</br>" + obj[0].jobTitle1;
            returnText += "</div></div>";
        }
        if (obj[0].name2 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name2;
            if (obj[0].jobTitle2 !== "") returnText += "</br>" + obj[0].jobTitle2;
            returnText += "</div></div>";
        }
        if (obj[0].name3 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name3;
            if (obj[0].jobTitle3 !== "") returnText += "</br>" + obj[0].jobTitle3;
            returnText += "</div></div>";
        }
        if (obj[0].name4 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name4;
            if (obj[0].jobTitle4 !== "") returnText += "</br>" + obj[0].jobTitle4;
            returnText += "</div></div>";
        }
        if (obj[0].name5 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name5;
            if (obj[0].jobTitle5 !== "") returnText += "</br>" + obj[0].jobTitle5;
            returnText += "</div></div>";
        }
        returnText += "</div>";
        $(tr).find(".more-button").addClass("active");
        $("<div class='details' style=''>" + returnText + "</div>").insertAfter(tr);
    }
}
function $0223437a5c85c95b$export$b62efe4e2fbde874() {
    $("#myTable").tablesorter({
        sortInitialOrder: "desc",
        sortList: [
            [
                5,
                1
            ]
        ],
        widgets: [
            "zebra"
        ]
    });
    $("#myTable").bind("sortBegin", function(e, table) {
        $(".details").remove();
        $(".more-button").removeClass("active");
    });
    $(document).on("keyup", "[data-company-search]", $0223437a5c85c95b$var$filterCompanies);
    $(document).on("click", ".more-button", function(e) {
        e.preventDefault();
        var tr = $(this).closest("tr");
        var selectedRow = $(this);
        var itemId = selectedRow.data("item-id");
        var next = tr.next();
        var className = next.attr("class");
        if (className !== "details") {
            $0223437a5c85c95b$var$format(itemId, tr);
            $(this).closest("tr").next().next().find("td").css("padding-top", "80px");
        } else {
            $(this).closest("tr").next().next().find("td").css("padding-top", "10px");
            $(next).remove();
            $(tr).find(".more-button").removeClass("active");
        }
    });
}


/**
 * Swiper 11.2.8
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 23, 2025
 */ /**
 * SSR Window 5.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 12, 2025
 */ /* eslint-disable no-param-reassign */ function $709edbf6299cccbc$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $709edbf6299cccbc$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($709edbf6299cccbc$var$isObject(src[key]) && $709edbf6299cccbc$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $709edbf6299cccbc$var$extend(target[key], src[key]);
    });
}
const $709edbf6299cccbc$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $709edbf6299cccbc$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $709edbf6299cccbc$var$extend(doc, $709edbf6299cccbc$var$ssrDocument);
    return doc;
}
const $709edbf6299cccbc$var$ssrWindow = {
    document: $709edbf6299cccbc$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $709edbf6299cccbc$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $709edbf6299cccbc$var$extend(win, $709edbf6299cccbc$var$ssrWindow);
    return win;
}



function $737414888e8d31b2$export$35e795649ee09318(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function $737414888e8d31b2$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $737414888e8d31b2$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $737414888e8d31b2$export$2d1720544b23b823() {
    return Date.now();
}
function $737414888e8d31b2$var$getComputedStyle(el) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $737414888e8d31b2$export$342063e11d6c3cad(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $737414888e8d31b2$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $737414888e8d31b2$export$ae1af26003f05816(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $737414888e8d31b2$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $737414888e8d31b2$export$d141bba7fdc215a3() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$737414888e8d31b2$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($737414888e8d31b2$export$ae1af26003f05816(to[nextKey]) && $737414888e8d31b2$export$ae1af26003f05816(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $737414888e8d31b2$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$737414888e8d31b2$export$ae1af26003f05816(to[nextKey]) && $737414888e8d31b2$export$ae1af26003f05816(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $737414888e8d31b2$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $737414888e8d31b2$export$407448d2b89b1813(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $737414888e8d31b2$export$3b14a55fb2447963(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $737414888e8d31b2$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $737414888e8d31b2$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $737414888e8d31b2$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $737414888e8d31b2$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $737414888e8d31b2$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $737414888e8d31b2$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $737414888e8d31b2$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $737414888e8d31b2$export$35e795649ee09318(classes));
    return el;
}
function $737414888e8d31b2$export$4368d992c4eafac0(el) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $737414888e8d31b2$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $737414888e8d31b2$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $737414888e8d31b2$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $737414888e8d31b2$export$23f2a1d2818174ef(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $737414888e8d31b2$export$8b22cf2602fb60ce(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $737414888e8d31b2$export$882b5998b3b9117c(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $737414888e8d31b2$export$dda1d9f60106f0e9(el, size, includeMargins) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function $737414888e8d31b2$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $737414888e8d31b2$export$ffb5f4729a158638(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $737414888e8d31b2$export$2408f22a0fab9ae5(el, html) {
    if (html === void 0) html = "";
    if (typeof trustedTypes !== "undefined") el.innerHTML = trustedTypes.createPolicy("html", {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $f564a415f4d19b8d$var$support;
function $f564a415f4d19b8d$var$calcSupport() {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $f564a415f4d19b8d$var$getSupport() {
    if (!$f564a415f4d19b8d$var$support) $f564a415f4d19b8d$var$support = $f564a415f4d19b8d$var$calcSupport();
    return $f564a415f4d19b8d$var$support;
}
let $f564a415f4d19b8d$var$deviceCached;
function $f564a415f4d19b8d$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $f564a415f4d19b8d$var$getSupport();
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $f564a415f4d19b8d$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$f564a415f4d19b8d$var$deviceCached) $f564a415f4d19b8d$var$deviceCached = $f564a415f4d19b8d$var$calcDevice(overrides);
    return $f564a415f4d19b8d$var$deviceCached;
}
let $f564a415f4d19b8d$var$browser;
function $f564a415f4d19b8d$var$calcBrowser() {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const device = $f564a415f4d19b8d$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $f564a415f4d19b8d$var$getBrowser() {
    if (!$f564a415f4d19b8d$var$browser) $f564a415f4d19b8d$var$browser = $f564a415f4d19b8d$var$calcBrowser();
    return $f564a415f4d19b8d$var$browser;
}
function $f564a415f4d19b8d$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $f564a415f4d19b8d$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $f564a415f4d19b8d$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $f564a415f4d19b8d$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $737414888e8d31b2$export$9e5f44173e64f162)(el, "padding-left") || 0, 10) - parseInt((0, $737414888e8d31b2$export$9e5f44173e64f162)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $737414888e8d31b2$export$9e5f44173e64f162)(el, "padding-top") || 0, 10) - parseInt((0, $737414888e8d31b2$export$9e5f44173e64f162)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $f564a415f4d19b8d$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $737414888e8d31b2$export$407448d2b89b1813)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $737414888e8d31b2$export$407448d2b89b1813)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $737414888e8d31b2$export$9e5f44173e64f162)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $737414888e8d31b2$export$dda1d9f60106f0e9)(slide, "width", true) : (0, $737414888e8d31b2$export$dda1d9f60106f0e9)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $737414888e8d31b2$export$407448d2b89b1813)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $737414888e8d31b2$export$407448d2b89b1813)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $f564a415f4d19b8d$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $f564a415f4d19b8d$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $f564a415f4d19b8d$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $f564a415f4d19b8d$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $f564a415f4d19b8d$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $f564a415f4d19b8d$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $f564a415f4d19b8d$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
const $f564a415f4d19b8d$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $f564a415f4d19b8d$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $737414888e8d31b2$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $737414888e8d31b2$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $f564a415f4d19b8d$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $f564a415f4d19b8d$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $f564a415f4d19b8d$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $f564a415f4d19b8d$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $f564a415f4d19b8d$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $f564a415f4d19b8d$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $f564a415f4d19b8d$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $f564a415f4d19b8d$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $f564a415f4d19b8d$var$unlazy(swiper, i);
    }
};
function $f564a415f4d19b8d$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $f564a415f4d19b8d$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $f564a415f4d19b8d$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $f564a415f4d19b8d$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $f564a415f4d19b8d$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $f564a415f4d19b8d$var$update = {
    updateSize: $f564a415f4d19b8d$var$updateSize,
    updateSlides: $f564a415f4d19b8d$var$updateSlides,
    updateAutoHeight: $f564a415f4d19b8d$var$updateAutoHeight,
    updateSlidesOffset: $f564a415f4d19b8d$var$updateSlidesOffset,
    updateSlidesProgress: $f564a415f4d19b8d$var$updateSlidesProgress,
    updateProgress: $f564a415f4d19b8d$var$updateProgress,
    updateSlidesClasses: $f564a415f4d19b8d$var$updateSlidesClasses,
    updateActiveIndex: $f564a415f4d19b8d$var$updateActiveIndex,
    updateClickedSlide: $f564a415f4d19b8d$var$updateClickedSlide
};
function $f564a415f4d19b8d$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $737414888e8d31b2$export$342063e11d6c3cad)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $f564a415f4d19b8d$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $f564a415f4d19b8d$var$minTranslate() {
    return -this.snapGrid[0];
}
function $f564a415f4d19b8d$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $f564a415f4d19b8d$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $737414888e8d31b2$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $f564a415f4d19b8d$var$translate = {
    getTranslate: $f564a415f4d19b8d$var$getSwiperTranslate,
    setTranslate: $f564a415f4d19b8d$var$setTranslate,
    minTranslate: $f564a415f4d19b8d$var$minTranslate,
    maxTranslate: $f564a415f4d19b8d$var$maxTranslate,
    translateTo: $f564a415f4d19b8d$var$translateTo
};
function $f564a415f4d19b8d$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $f564a415f4d19b8d$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === "reset") swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $f564a415f4d19b8d$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $f564a415f4d19b8d$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $f564a415f4d19b8d$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $f564a415f4d19b8d$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $f564a415f4d19b8d$var$transition = {
    setTransition: $f564a415f4d19b8d$var$setTransition,
    transitionStart: $f564a415f4d19b8d$var$transitionStart,
    transitionEnd: $f564a415f4d19b8d$var$transitionEnd
};
function $f564a415f4d19b8d$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $737414888e8d31b2$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    const browser = $f564a415f4d19b8d$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $f564a415f4d19b8d$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $f564a415f4d19b8d$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $f564a415f4d19b8d$var$slide = {
    slideTo: $f564a415f4d19b8d$var$slideTo,
    slideToLoop: $f564a415f4d19b8d$var$slideToLoop,
    slideNext: $f564a415f4d19b8d$var$slideNext,
    slidePrev: $f564a415f4d19b8d$var$slidePrev,
    slideReset: $f564a415f4d19b8d$var$slideReset,
    slideToClosest: $f564a415f4d19b8d$var$slideToClosest,
    slideToClickedSlide: $f564a415f4d19b8d$var$slideToClickedSlide
};
function $f564a415f4d19b8d$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $737414888e8d31b2$export$db3b6bfb95261072)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $737414888e8d31b2$export$90a7f3efeed30595)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $737414888e8d31b2$export$90a7f3efeed30595)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next",
        initial: initial
    });
}
function $f564a415f4d19b8d$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) (0, $737414888e8d31b2$export$90a7f3efeed30595)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, $737414888e8d31b2$export$90a7f3efeed30595)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $f564a415f4d19b8d$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $f564a415f4d19b8d$var$loop = {
    loopCreate: $f564a415f4d19b8d$var$loopCreate,
    loopFix: $f564a415f4d19b8d$var$loopFix,
    loopDestroy: $f564a415f4d19b8d$var$loopDestroy
};
function $f564a415f4d19b8d$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $f564a415f4d19b8d$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $f564a415f4d19b8d$var$grabCursor = {
    setGrabCursor: $f564a415f4d19b8d$var$setGrabCursor,
    unsetGrabCursor: $f564a415f4d19b8d$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $f564a415f4d19b8d$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $709edbf6299cccbc$export$39b482c5e57630a8)() || el === (0, $709edbf6299cccbc$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $f564a415f4d19b8d$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $f564a415f4d19b8d$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        $f564a415f4d19b8d$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!(0, $737414888e8d31b2$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $f564a415f4d19b8d$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$f564a415f4d19b8d$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $737414888e8d31b2$export$2d1720544b23b823)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === "mouse" || e.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $f564a415f4d19b8d$var$onTouchMove(event) {
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $737414888e8d31b2$export$2d1720544b23b823)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== "mouse") document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $f564a415f4d19b8d$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $737414888e8d31b2$export$2d1720544b23b823)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $737414888e8d31b2$export$2d1720544b23b823)();
    (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $f564a415f4d19b8d$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $f564a415f4d19b8d$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $f564a415f4d19b8d$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $f564a415f4d19b8d$var$onLoad(e) {
    const swiper = this;
    $f564a415f4d19b8d$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function $f564a415f4d19b8d$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const $f564a415f4d19b8d$var$events = (swiper, method)=>{
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!el || typeof el === "string") return;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $f564a415f4d19b8d$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $f564a415f4d19b8d$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $f564a415f4d19b8d$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $f564a415f4d19b8d$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $f564a415f4d19b8d$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $f564a415f4d19b8d$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $f564a415f4d19b8d$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $f564a415f4d19b8d$var$onScroll.bind(swiper);
    swiper.onClick = $f564a415f4d19b8d$var$onClick.bind(swiper);
    swiper.onLoad = $f564a415f4d19b8d$var$onLoad.bind(swiper);
    $f564a415f4d19b8d$var$events(swiper, "on");
}
function $f564a415f4d19b8d$var$detachEvents() {
    const swiper = this;
    $f564a415f4d19b8d$var$events(swiper, "off");
}
var $f564a415f4d19b8d$var$events$1 = {
    attachEvents: $f564a415f4d19b8d$var$attachEvents,
    detachEvents: $f564a415f4d19b8d$var$detachEvents
};
const $f564a415f4d19b8d$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $f564a415f4d19b8d$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === "window" || !params.breakpointsBase ? params.breakpointsBase : "container";
    const breakpointContainer = [
        "window",
        "container"
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $f564a415f4d19b8d$var$isGridEnabled(swiper, params);
    const isMultiRow = $f564a415f4d19b8d$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $737414888e8d31b2$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $f564a415f4d19b8d$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $f564a415f4d19b8d$var$breakpoints = {
    setBreakpoint: $f564a415f4d19b8d$var$setBreakpoint,
    getBreakpoint: $f564a415f4d19b8d$var$getBreakpoint
};
function $f564a415f4d19b8d$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $f564a415f4d19b8d$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $f564a415f4d19b8d$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $f564a415f4d19b8d$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === "string") return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $f564a415f4d19b8d$var$classes = {
    addClasses: $f564a415f4d19b8d$var$addClasses,
    removeClasses: $f564a415f4d19b8d$var$removeClasses
};
function $f564a415f4d19b8d$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $f564a415f4d19b8d$var$checkOverflow$1 = {
    checkOverflow: $f564a415f4d19b8d$var$checkOverflow
};
var $f564a415f4d19b8d$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $f564a415f4d19b8d$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $737414888e8d31b2$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $737414888e8d31b2$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $737414888e8d31b2$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $f564a415f4d19b8d$var$prototypes = {
    eventsEmitter: $f564a415f4d19b8d$var$eventsEmitter,
    update: $f564a415f4d19b8d$var$update,
    translate: $f564a415f4d19b8d$var$translate,
    transition: $f564a415f4d19b8d$var$transition,
    slide: $f564a415f4d19b8d$var$slide,
    loop: $f564a415f4d19b8d$var$loop,
    grabCursor: $f564a415f4d19b8d$var$grabCursor,
    events: $f564a415f4d19b8d$var$events$1,
    breakpoints: $f564a415f4d19b8d$var$breakpoints,
    checkOverflow: $f564a415f4d19b8d$var$checkOverflow$1,
    classes: $f564a415f4d19b8d$var$classes
};
const $f564a415f4d19b8d$var$extendedDefaults = {};
class $f564a415f4d19b8d$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $737414888e8d31b2$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $737414888e8d31b2$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $f564a415f4d19b8d$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $f564a415f4d19b8d$var$getSupport();
        swiper.device = $f564a415f4d19b8d$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $f564a415f4d19b8d$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $f564a415f4d19b8d$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $737414888e8d31b2$export$d141bba7fdc215a3)({}, $f564a415f4d19b8d$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $737414888e8d31b2$export$d141bba7fdc215a3)({}, swiperParams, $f564a415f4d19b8d$var$extendedDefaults, params);
        swiper.originalParams = (0, $737414888e8d31b2$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $737414888e8d31b2$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $737414888e8d31b2$export$23f2a1d2818174ef)(slides[0]);
        return (0, $737414888e8d31b2$export$23f2a1d2818174ef)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index));
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $f564a415f4d19b8d$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $737414888e8d31b2$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $737414888e8d31b2$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $737414888e8d31b2$export$9e5f44173e64f162)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $737414888e8d31b2$export$9e5f44173e64f162)(el, "direction") === "rtl"),
            wrongRTL: (0, $737414888e8d31b2$export$9e5f44173e64f162)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $f564a415f4d19b8d$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $f564a415f4d19b8d$var$processLazyPreloader(swiper, e.target);
            });
        });
        $f564a415f4d19b8d$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $f564a415f4d19b8d$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== "string") el.removeAttribute("style");
            if (wrapperEl) wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== "string") swiper.el.swiper = null;
            (0, $737414888e8d31b2$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $737414888e8d31b2$export$d141bba7fdc215a3)($f564a415f4d19b8d$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $f564a415f4d19b8d$var$extendedDefaults;
    }
    static get defaults() {
        return $f564a415f4d19b8d$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$f564a415f4d19b8d$export$25ce5a424b770e84.prototype.__modules__) $f564a415f4d19b8d$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $f564a415f4d19b8d$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$f564a415f4d19b8d$export$25ce5a424b770e84.installModule(m));
            return $f564a415f4d19b8d$export$25ce5a424b770e84;
        }
        $f564a415f4d19b8d$export$25ce5a424b770e84.installModule(module);
        return $f564a415f4d19b8d$export$25ce5a424b770e84;
    }
}
Object.keys($f564a415f4d19b8d$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($f564a415f4d19b8d$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $f564a415f4d19b8d$export$25ce5a424b770e84.prototype[protoMethod] = $f564a415f4d19b8d$var$prototypes[prototypeGroup][protoMethod];
    });
});
$f564a415f4d19b8d$export$25ce5a424b770e84.use([
    $f564a415f4d19b8d$var$Resize,
    $f564a415f4d19b8d$var$Observer
]);






function $ba0542580cadfb4c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("swiper-slide");
        else slideEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === "undefined" ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $737414888e8d31b2$export$407448d2b89b1813)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $0abcf5eeb4def3b2$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $737414888e8d31b2$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $737414888e8d31b2$export$4368d992c4eafac0)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $11aaaff5c52a2005$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $737414888e8d31b2$export$2d1720544b23b823)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $737414888e8d31b2$export$2d1720544b23b823)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $737414888e8d31b2$export$2d1720544b23b823)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $737414888e8d31b2$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $737414888e8d31b2$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $d97b353fb4cc475d$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $eaaaf8b39da376c0$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $d97b353fb4cc475d$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $d9d2cfaa8c2f08b1$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}




function $e9d5694a0a5e5ad4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return "next";
        else if (nextIndex === prevIndex - 1) return "previous";
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $737414888e8d31b2$export$23f2a1d2818174ef)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === "next") swiper.slideNext();
            else if (moveDirection === "previous") swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $737414888e8d31b2$export$dda1d9f60106f0e9)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $737414888e8d31b2$export$23f2a1d2818174ef)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(subEl, paginationHTML || "");
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $d97b353fb4cc475d$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $737414888e8d31b2$export$8b22cf2602fb60ce)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $737414888e8d31b2$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $d0931fa014098cca$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $737414888e8d31b2$export$4368d992c4eafac0)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $d97b353fb4cc475d$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $737414888e8d31b2$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $737414888e8d31b2$export$35e795649ee09318)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on("changeDirection", ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock changeDirection", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $737414888e8d31b2$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $737414888e8d31b2$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $737414888e8d31b2$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $737414888e8d31b2$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $737414888e8d31b2$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $ee7539a46857f0eb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $737414888e8d31b2$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $737414888e8d31b2$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $759564f7265016ff$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === "mouse";
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $737414888e8d31b2$export$342063e11d6c3cad)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $737414888e8d31b2$export$342063e11d6c3cad)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = "0ms";
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $737414888e8d31b2$export$4368d992c4eafac0)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $737414888e8d31b2$export$4368d992c4eafac0)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === "number" && typeof image.currentY === "number") {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $d32a53564318ff98$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $737414888e8d31b2$export$882b5998b3b9117c)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === "string" ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $ddec56a6d154f225$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = (0, $737414888e8d31b2$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $737414888e8d31b2$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $737414888e8d31b2$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $737414888e8d31b2$export$23f2a1d2818174ef)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute("data-swiper-slide-index")), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $737414888e8d31b2$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("focus", handleFocus, true);
            swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
            swiper.el.removeEventListener("pointerup", handlePointerUp, true);
        }
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $737414888e8d31b2$export$db3b6bfb95261072)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $0a7f72abb390586e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $6a005130dbe95232$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute("data-hash") === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $eaf75da0b716a547$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains("swiper-slide-active"));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("pointerenter", onPointerEnter);
            swiper.el.removeEventListener("pointerleave", onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $3fb235b8df1172c3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $737414888e8d31b2$export$ae1af26003f05816)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $737414888e8d31b2$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $ecce813767c35ba6$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $737414888e8d31b2$export$2d1720544b23b823)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $737414888e8d31b2$export$2d1720544b23b823)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $737414888e8d31b2$export$2d1720544b23b823)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $737414888e8d31b2$export$882b5998b3b9117c)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $737414888e8d31b2$export$882b5998b3b9117c)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $737414888e8d31b2$export$882b5998b3b9117c)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $0c0d2c4292134b5f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $4b64943e8b7d45e9$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(tempDOM, "");
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $4b64943e8b7d45e9$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(tempDOM, "");
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $4b64943e8b7d45e9$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $4b64943e8b7d45e9$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $4b64943e8b7d45e9$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $4b64943e8b7d45e9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $4b64943e8b7d45e9$var$appendSlide.bind(swiper),
        prependSlide: $4b64943e8b7d45e9$var$prependSlide.bind(swiper),
        addSlide: $4b64943e8b7d45e9$var$addSlide.bind(swiper),
        removeSlide: $4b64943e8b7d45e9$var$removeSlide.bind(swiper),
        removeAllSlides: $4b64943e8b7d45e9$var$removeAllSlides.bind(swiper)
    });
}


function $3e1d86cf3c3014a7$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate _virtualUpdated", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $2badf9babbb38496$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $3e1430f6f6738d78$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $737414888e8d31b2$export$882b5998b3b9117c)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $db93034b7b46e880$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $d18dd749558189dc$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $737414888e8d31b2$export$ffb5f4729a158638)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $5df6f81c0cc16aec$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $28c6414a32cbb537$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $737414888e8d31b2$export$ffb5f4729a158638)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $5aa9633bcb8b10eb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $737414888e8d31b2$export$ffb5f4729a158638)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $e2ffef07309caf7b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $737414888e8d31b2$export$ffb5f4729a158638)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $c4048b77982f3827$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $87b693ffb012c6f5$export$a7425bd496405417() {
    const $slider = $(".fleet200-testimonials-slider");
    if (!$slider.length) {
        console.warn("Slider element .fleet200-testimonials-slider not found");
        return;
    }
    // Calculate the maximum height of all slides
    const $slides = $slider.find(".swiper-slide");
    let maxHeight = 0;
    $slides.each(function() {
        const slideHeight = $(this).outerHeight();
        if (slideHeight > maxHeight) maxHeight = slideHeight;
    });
    // Apply the maximum height to all slides
    if (maxHeight > 0) $slides.css("min-height", `${maxHeight}px`);
    new (0, $f564a415f4d19b8d$export$25ce5a424b770e84)(".fleet200-testimonials-slider", {
        modules: [
            (0, $eaaaf8b39da376c0$export$2e2bcd8739ae039),
            (0, $eaf75da0b716a547$export$2e2bcd8739ae039)
        ],
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        loop: false,
        // Remove autoHeight to prevent dynamic resizing
        // autoHeight: true,
        speed: 1000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    });
}


let $dfc3ec1d9e099b15$var$quickCalculationForm, $dfc3ec1d9e099b15$var$advancedCalculationForm, $dfc3ec1d9e099b15$var$fuelCostMessageContainer;
const $dfc3ec1d9e099b15$var$errorClass = "input-validation-error";
function $dfc3ec1d9e099b15$var$addToFleet(event) {
    event.preventDefault();
    $dfc3ec1d9e099b15$var$fuelCostMessageContainer.empty();
    const fuelTypesElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#FuelTypes");
    const mileageElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#Mileage");
    const manufacturerElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ManufacturerId");
    const modelGroupElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ModelGroupId");
    const derivativeElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#DerivativeId");
    const quantityElement = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#Quantity");
    const messages = [];
    if (!$dfc3ec1d9e099b15$var$checkFuelType(fuelTypesElement)) messages.push("Please select a fuel type");
    if (!$dfc3ec1d9e099b15$var$checkMileage(mileageElement)) messages.push("Please select a valid mileage");
    if (!$dfc3ec1d9e099b15$var$checkManufacturer(manufacturerElement)) messages.push("Please select a manufacturer");
    if (!$dfc3ec1d9e099b15$var$checkModel(modelGroupElement)) messages.push("Please select a model");
    if (!$dfc3ec1d9e099b15$var$checkDerivative(derivativeElement)) messages.push("Please select a derivative");
    if (!$dfc3ec1d9e099b15$var$checkQuantity(quantityElement)) messages.push("Please select a valid quantity");
    if (messages.length) {
        const ul = $("<ul>").addClass("list-unstyled field-validation-error margin-bottom-0");
        for(let i = 0; i < messages.length; i++)ul.append($("<li>").append(messages[i]));
        $dfc3ec1d9e099b15$var$fuelCostMessageContainer.append(ul);
        return;
    }
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$checkFuelType(fuelType) {
    if (!fuelType.val()) {
        fuelType.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    fuelType.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkMileage(mileage) {
    const mileageVal = parseInt(mileage.val());
    if (isNaN(mileageVal) || mileageVal <= 0) {
        mileage.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    mileage.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkManufacturer(manufacturer) {
    if (!manufacturer.val()) {
        manufacturer.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    manufacturer.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkModel(model) {
    if (!model.val()) {
        model.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    model.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkDerivative(derivative) {
    if (!derivative.val()) {
        derivative.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    derivative.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$checkQuantity(quantity) {
    const quantityVal = parseInt(quantity.val());
    if (isNaN(quantityVal) || quantityVal <= 0) {
        quantity.addClass($dfc3ec1d9e099b15$var$errorClass);
        return false;
    }
    quantity.removeClass($dfc3ec1d9e099b15$var$errorClass);
    return true;
}
function $dfc3ec1d9e099b15$var$quickCalculate(event) {
    if (!$dfc3ec1d9e099b15$var$quickCalculationForm.valid()) return;
    $dfc3ec1d9e099b15$var$quickCalculationForm.find("#QuickExplicitlyCalculated").val("true");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$advancedCalculate(event) {
    $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ExplicitlyCalculated").val("true");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$changeFuelTypes(event) {
    $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ManufacturerId").val("");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$changeManufacturer(event) {
    $dfc3ec1d9e099b15$var$advancedCalculationForm.find("#ModelGroupId").val("");
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$submitForms(event) {
    event.preventDefault();
    const url = $dfc3ec1d9e099b15$var$advancedCalculationForm.attr("action");
    let data = $dfc3ec1d9e099b15$var$advancedCalculationForm.serializeArray();
    data = data.concat($dfc3ec1d9e099b15$var$quickCalculationForm.serializeArray());
    //console.log(data);
    $dfc3ec1d9e099b15$var$postToUrl(url, data);
}
function $dfc3ec1d9e099b15$var$removeFromFleet(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const row = button.parents("tr");
    row.remove();
    $dfc3ec1d9e099b15$var$submitForms(event);
}
function $dfc3ec1d9e099b15$var$postToUrl(path, params, method) {
    method = method || "post"; // Set method to post by default, if not specified.
    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for(let key in params){
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", params[key].name);
        hiddenField.setAttribute("value", params[key].value);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
}
function $dfc3ec1d9e099b15$export$17fc438eb96437e2() {
    if ($("[data-fuel-cost-calculator]").length) {
        $dfc3ec1d9e099b15$var$quickCalculationForm = $("[data-quick-calculation]");
        $dfc3ec1d9e099b15$var$advancedCalculationForm = $("[data-fuel-cost-form]");
        $dfc3ec1d9e099b15$var$fuelCostMessageContainer = $dfc3ec1d9e099b15$var$advancedCalculationForm.find("[data-fuel-cost-message-container]");
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#FuelTypes", $dfc3ec1d9e099b15$var$changeFuelTypes);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#ManufacturerId", $dfc3ec1d9e099b15$var$changeManufacturer);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#ModelGroupId", $dfc3ec1d9e099b15$var$submitForms);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("click", "[data-remove-from-fleet]", $dfc3ec1d9e099b15$var$removeFromFleet);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("change", "#Area", $dfc3ec1d9e099b15$var$submitForms);
        $dfc3ec1d9e099b15$var$quickCalculationForm.on("change", "#QuickArea", $dfc3ec1d9e099b15$var$submitForms);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("click", "[data-add-to-fleet]", $dfc3ec1d9e099b15$var$addToFleet);
        $dfc3ec1d9e099b15$var$advancedCalculationForm.on("click", "[data-advanced-calculate]", $dfc3ec1d9e099b15$var$advancedCalculate);
        $dfc3ec1d9e099b15$var$quickCalculationForm.on("click", "[data-quick-calculate]", $dfc3ec1d9e099b15$var$quickCalculate);
    }
}


function $b98720deb745778b$var$setFuelTypeButtons() {
    setTimeout(function() {
        const url = window.location.href.split("?")[1];
        if (!url) return;
        const selectedFuelTypeArray = url.split("=");
        const selectedFuelType = selectedFuelTypeArray[selectedFuelTypeArray.length - 1];
        if (selectedFuelType.indexOf(",") > 1) {
            const stringArray = selectedFuelType.split(",");
            stringArray.forEach(function(item) {
                const buttonTarget = `data-fuel-type-${item}`;
                $(`[${buttonTarget}]`).removeClass().addClass("btn btn-green");
            });
        } else {
            const buttonTarget = `data-fuel-type-${selectedFuelType}`;
            $(`[${buttonTarget}]`).removeClass().addClass("btn btn-green");
        }
    }, 5000);
}
function $b98720deb745778b$export$d18b5b0ff33e313c() {
    window.fuelTypeButtons = $b98720deb745778b$var$setFuelTypeButtons;
    window.fuelTypeButtons();
}


function $935dae51dafb9406$var$setCaption(imageId) {
    const galleryId = $("[data-image-gallery-id]").data("image-gallery-id");
    $.get("/get-image-caption/" + imageId + "/" + galleryId, function(response) {
        $("[data-slider-caption-container]").html(response);
        $("[data-slider-caption-container]").show();
    });
}
function $935dae51dafb9406$var$updateUrl(event) {
    const history = window.History;
    const stateData = {};
    const imageId = event.target.currSlide.imageId || event.target.currSlide.caption?.prevObject.data("image-id");
    if (!imageId) return;
    $935dae51dafb9406$var$setCaption(imageId);
    stateData.image = imageId;
    const queryString = $.param(stateData);
    stateData.doNotReloadAds = true;
    history.replaceState(stateData, $("title").html(), location.pathname + "?" + queryString);
}
function $935dae51dafb9406$var$setupAdHolder(holder, type) {
    const ad = $("<div data-ad-holder>");
    const adHolderId = "ad-" + type + "-" + new Date().getTime();
    ad.attr("id", adHolderId);
    holder.append(ad);
    return adHolderId;
}
function $935dae51dafb9406$var$checkHolder(element, selector) {
    const holder = element.find(selector);
    const slot = holder.data("ad-slot");
    return holder;
}
function $935dae51dafb9406$var$loadLeaderboard(slider) {
    const holder = $935dae51dafb9406$var$checkHolder(slider, ".rsLeaderboardHolder");
    if (holder == null) return;
    const adHolderId = $935dae51dafb9406$var$setupAdHolder(holder, "leaderboard");
}
function $935dae51dafb9406$var$loadMpus(slider) {
    if (window.isViewportLessThan("md")) return;
    let holder = $935dae51dafb9406$var$checkHolder(slider, ".rsMpuHolder > .mpu-1-holder");
    let adHolderId;
    if (holder != null) adHolderId = $935dae51dafb9406$var$setupAdHolder(holder, "mpu-1");
    holder = $935dae51dafb9406$var$checkHolder(slider, ".rsMpuHolder > .mpu-2-holder");
    if (holder != null) adHolderId = $935dae51dafb9406$var$setupAdHolder(holder, "mpu-2");
}
function $935dae51dafb9406$var$toggleNavigation(slider, hide, timeout = 5000) {
    const rsOverflow = slider.querySelector(".rsOverflow");
    if (rsOverflow) {
        if (hide) rsOverflow.classList.add("rsNoDrag");
        else rsOverflow.classList.remove("rsNoDrag");
    }
    Array.from(slider.querySelectorAll(".rsArrow")).forEach(function(arrow) {
        arrow.style.display = hide ? "none" : "block";
    });
    if (hide) setTimeout(function() {
        console.log("[Gallery] Navigation toggle timeout");
        $935dae51dafb9406$var$toggleNavigation(slider, false, timeout);
    }, timeout);
}
function $935dae51dafb9406$var$loadSlideMpu(slider, slide) {
    $("[data-slider-caption-container]").hide();
    const existingSlot = slide.data("ad-slot");
    $935dae51dafb9406$var$toggleNavigation(slider.slider[0], true, slider.st.adNavLockout || 5000);
}
function $935dae51dafb9406$var$unlockNav(event) {
    const slot = event.slot;
    if (!slot.lockedNav) return;
    const slider = slot.slider;
    $935dae51dafb9406$var$toggleNavigation(slider.slider[0], false, slider.st.adNavLockout || 1500);
}
function $935dae51dafb9406$var$tryLoadMpu(event) {
    const slide = event.target.currSlide.content;
    if (slide.data("gallery-ad")) {
        $935dae51dafb9406$var$loadSlideMpu(event.target, slide);
        ayManagerEnv.changePage();
    }
}
function $935dae51dafb9406$var$reloadFixedAds(event) {
    const $slider = event.target;
    $slider.leaderboardReloadCount += 1;
    if ($slider.leaderboardReloadCount >= $slider.st.leaderboardReloadAfter) {
        $935dae51dafb9406$var$loadLeaderboard($slider.slider);
        ayManagerEnv.refresh([
            "leaderboard-1-gallery",
            "mpu-1-gallery",
            "mpu-2-gallery"
        ], {
            mode: "visible"
        });
        $slider.leaderboardReloadCount = 0;
    }
    if (!window.isViewportLessThan("md")) {
        $slider.mpuReloadCount += 1;
        if ($slider.mpuReloadCount >= $slider.st.mpuReloadAfter) {
            $935dae51dafb9406$var$loadMpus($slider.slider);
            ayManagerEnv.refresh([
                "leaderboard-1-gallery",
                "mpu-1-gallery",
                "mpu-2-gallery"
            ], {
                mode: "visible"
            });
            $slider.mpuReloadCount = 0;
        }
    }
}
function $935dae51dafb9406$var$postSlideChange(event) {
    const $slider = event.target;
    if (!$slider.slider.hasClass("rsFullscreen")) return;
    if ($slider.changeEventsDisabled) return;
    if ($slider.changeEventsDisabledByGoto) {
        $slider.changeEventsDisabledByGoto = false;
        return;
    }
    $935dae51dafb9406$var$reloadFixedAds(event);
    $935dae51dafb9406$var$tryLoadMpu(event);
    $935dae51dafb9406$var$updateUrl(event);
}
function $935dae51dafb9406$var$setup() {
    window.loadGallery = function() {
        const sliders = $("[data-slider-gallery]");
        if (sliders.length === 0) return;
        sliders.each(function(index, element) {
            const $element = $(element);
            if ($element.data("royalSlider") != null) return;
            const slides = $element.children().clone();
            const desktopSlides = slides.filter("a").clone();
            const options = {
                arrowsNavAutoHide: false,
                imageScaleMode: "fit-if-smaller",
                imageScalePadding: 0,
                controlNavigationSpacing: 0,
                controlNavigation: "none",
                loop: true,
                numImagesToPreload: 1,
                keyboardNavEnabled: true,
                usePreloader: true,
                slidesSpacing: 0,
                minSlideOffset: 0,
                leaderboardReloadAfter: $element.data("leaderboard-reload-after") || 4,
                mpuReloadAfter: $element.data("mpu-reload-after") || 4,
                adNavLockout: $element.data("ad-nav-lockout") || 1500,
                fullscreen: {
                    enabled: true,
                    nativeFS: false
                }
            };
            $element.royalSlider(options);
            const slider = $element.data("royalSlider");
            const mpuHolder = $('<div class="rsMpuHolder">');
            const mpu1 = $('<div class="mpu-1-holder mb-3">').appendTo(mpuHolder);
            const mpu2 = $('<div class="mpu-2-holder mb-3">').appendTo(mpuHolder);
            $element.prepend(mpuHolder);
            const leaderboardHolder = $('<div class="rsLeaderboardHolder">').prependTo($element);
            slider.ev.on("rsExitFullscreen", function() {
                $("#heading-group").css("z-index", "2");
                $element.hide();
                $element.removeClass("fullscreen");
            });
            slider.ev.on("rsBeforeSizeSet", function() {
                const leaderboardHolderHeight = leaderboardHolder.outerHeight(true);
                const mpuHolderWidth = mpuHolder.outerWidth(true);
                slider._wrapHeight = slider._wrapHeight - leaderboardHolderHeight;
                slider._wrapWidth = slider._wrapWidth - mpuHolderWidth;
            });
            $element.hide();
            slider.allSlides = jQuery.extend(true, [], slider.slides);
            slider.desktopSlides = $(slider.allSlides).filter(function(index, element) {
                return element.images !== null;
            }).get();
            function goToFast(indexOf) {
                slider.changeEventsDisabledByGoto = true;
                const temp = slider.st.transitionSpeed;
                slider.st.transitionSpeed = 0;
                slider.goTo(indexOf, true);
                slider.st.transitionSpeed = temp;
            }
            function setToDesktop(init) {
                slider.changeEventsDisabled = true;
                if (slider.currSlide.images == null) slider.goTo(slider.currSlideId - 1, true);
                const indexOf = slider.desktopSlides.findIndex(function(element) {
                    return element.images[0] === slider.currSlide.images[0];
                });
                while(slider.slides.length > 0)slider.removeSlide(0);
                for(let i = 0; i < slider.desktopSlides.length; i++){
                    const slide = desktopSlides[i];
                    slider.appendSlide(slide);
                }
                setTimeout(function() {
                    goToFast(indexOf);
                }, 50);
                slider.changeEventsDisabled = false;
            }
            function setToMobile() {
                slider.changeEventsDisabled = true;
                const indexOf = slider.allSlides.findIndex(function(element) {
                    return element.images != null && element.images[0] === slider.currSlide.images[0];
                });
                while(slider.slides.length > 0)slider.removeSlide(0);
                for(let i = 0; i < slider.allSlides.length; i++){
                    const slide = slides[i];
                    slider.appendSlide(slide);
                }
                setTimeout(function() {
                    goToFast(indexOf);
                }, 50);
                slider.changeEventsDisabled = false;
            }
            $(document).on("viewport-changed", function(event, data) {
                if (data.from !== document.viewportSize.mobile && data.to !== document.viewportSize.mobile) return;
                if (data.to === document.viewportSize.mobile) setToMobile();
                else if (data.from === document.viewportSize.mobile) setToDesktop();
                $935dae51dafb9406$var$loadLeaderboard($element);
                $935dae51dafb9406$var$loadMpus($element);
                slider.leaderboardReloadCount = 0;
            });
            slider.ev.on("rsEnterFullscreen", function() {
                ayManagerEnv.changePage();
                $("#heading-group").css("z-index", "1");
                $element.show();
                $element.addClass("fullscreen");
                const defaultImageId = $("[data-default-image-id]").data("default-image-id");
                $935dae51dafb9406$var$setCaption(defaultImageId);
                $935dae51dafb9406$var$loadLeaderboard($element);
                $935dae51dafb9406$var$loadMpus($element);
                if (!window.isViewportLessThan("md")) setToDesktop();
                else setToMobile();
            });
            slider.leaderboardReloadCount = 0;
            slider.mpuReloadCount = 0;
            slider.ev.on("rsAfterSlideChange", $935dae51dafb9406$var$postSlideChange);
            window.gallerySliderData = slider;
            const siblings = $element.siblings("[data-slider-caption-container]");
            const caption = $element.find(".rsGCaption");
            caption.appendTo(siblings);
        });
    };
}
function $935dae51dafb9406$var$launchGallery(event) {
    event.preventDefault();
    const $this = $(event.currentTarget);
    const galleryName = $this.closest(".article-gallery").find("[data-slider-gallery]").data("slider-gallery");
    const gallery = $('[data-slider-gallery="' + galleryName + '"]');
    const slider = gallery.data("royalSlider");
    if (!slider) return;
    const index = $this.data("gallery-launcher-index");
    if (typeof index == "undefined") return;
    const slide = $(slider.allSlides).filter(function(_, element) {
        return element.id === index;
    }).get(0);
    if (slide == null) return;
    const slideIndex = slider.slides.findIndex(function(element) {
        return element.images != null && element.images[0] === slide.images[0];
    });
    if (slideIndex === -1) return;
    slider.goTo(slideIndex, false);
    setTimeout(function() {
        slider.enterFullscreen();
    }, 51);
}
function $935dae51dafb9406$export$f0c7f3aad087f331() {
    $935dae51dafb9406$var$setup();
    window.loadGallery();
    $(document).on("click", "[data-gallery-launcher]", $935dae51dafb9406$var$launchGallery);
}


function $1681bada7f12e93a$var$getForm() {
    return $("[data-fn-job-search]");
}
function $1681bada7f12e93a$var$setPage(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const page = button.data("pager-page");
    const form = $1681bada7f12e93a$var$getForm();
    form.find("#PageNumber").val(page);
    form.submit();
}
function $1681bada7f12e93a$var$getUrlVars(hrefUrl) {
    const vars = [];
    let hash;
    const hashes = hrefUrl.slice(hrefUrl.indexOf("?") + 1).split("&");
    for(let i = 0; i < hashes.length; i++){
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function $1681bada7f12e93a$var$applyPagerAttributes() {
    const pager = $("#fn-pager");
    const links = pager.find("a");
    links.each(function(index, element) {
        const alink = $(element);
        const link = alink.attr("href");
        if (!link) return;
        const queryString = $1681bada7f12e93a$var$getUrlVars(link);
        const page = queryString["page"];
        if (!page) return;
        alink.attr("href", "#");
        alink.attr("data-pager-page", page);
    });
}
function $1681bada7f12e93a$export$8ffecd3ecbf5a7bf() {
    if ($("[data-jobs-search]").length) {
        $(document).on("click", "[data-pager-page]", $1681bada7f12e93a$var$setPage);
        $1681bada7f12e93a$var$applyPagerAttributes();
    }
}


function $1062b41150fcb383$export$2b2ccfd71dd67323() {
    if ($("[data-jquery-checkbox]").length) $(".button-checkbox").each(function() {
        // Settings
        const $widget = $(this), $button = $widget.find("button"), $checkbox = $widget.find("input:checkbox"), color = $button.data("color"), settings = {
            on: {
                icon: "glyphicon glyphicon-check"
            },
            off: {
                icon: "glyphicon glyphicon-unchecked"
            }
        };
        // Event Handlers
        $button.on("click", function() {
            $checkbox.prop("checked", !$checkbox.is(":checked"));
            $checkbox.triggerHandler("change");
            updateDisplay();
        });
        $checkbox.on("change", function() {
            updateDisplay();
        });
        // Actions
        function updateDisplay() {
            const isChecked = $checkbox.is(":checked");
            // Set the button's state
            $button.data("state", isChecked ? "on" : "off");
            // Set the button's icon
            $button.find(".state-icon").removeClass().addClass("state-icon " + settings[$button.data("state")].icon);
            //update the value of checkbox
            //var value = $checkbox.val();
            //alert(value);
            //$checkbox.val('checked');
            // Update the button's color
            if (isChecked) $button.removeClass("btn-default").addClass("btn-" + color + " active");
            else $button.removeClass("btn-" + color + " active").addClass("btn-default");
        }
        // Initialization
        function init() {
            updateDisplay();
            // Inject the icon if applicable
            if ($button.find(".state-icon").length === 0) $button.prepend('<i class="state-icon ' + settings[$button.data("state")].icon + '"></i>\xa0');
        }
        init();
    });
}


function $99ad575d7443e4d6$var$onRegisterButtonClick(e) {
    $99ad575d7443e4d6$var$checkPhoneRequirement();
    const form = $("[data-registration-form]");
    if (!form.valid()) return;
    e.preventDefault();
    const $button = form.find('button[type="submit"], input[type="submit"]');
    const partnerByPhone = $("#PartnerByPhone").is(":checked");
    const bauerByPhone = $("#BauerByPhone").is(":checked");
    const phoneNumber = $("#PhoneNumber").val();
    if (partnerByPhone === true || bauerByPhone === false) {
        if (phoneNumber !== "") {
            $button.attr("disabled", "disabled");
            $(form).submit();
        } else $("[data-phone-validation]").removeClass("hidden");
    } else {
        $button.attr("disabled", "disabled");
        $(form).submit();
    }
}
function $99ad575d7443e4d6$var$getTopHeaderHeight() {
    let height = 0;
    if (window.isViewportGreaterThanOrEqualTo("lg")) {
        const siteSelector = $(".site-selector");
        height += siteSelector.height();
        siteSelector.removeClass("collapse");
        siteSelector.removeAttr("style");
    } else if (window.isViewportLessThan("md")) {
        const mobileFixedHeader = $("#fixedHeader");
        height += mobileFixedHeader.height();
    } else if (window.getViewportSize() == "md") {
        const tabletFixedHeader = $("#fixedHeader");
        height += tabletFixedHeader.height();
    }
    return height;
}
const $99ad575d7443e4d6$var$sph = "scrolled-past-header";
function $99ad575d7443e4d6$var$onFNScroll() {
    const scrollPosition = window.pageYOffset;
    //var headerHeight = $('#fixedHeader').height();
    const headerHeight = $99ad575d7443e4d6$var$getTopHeaderHeight();
    if (scrollPosition > headerHeight) $("html").addClass($99ad575d7443e4d6$var$sph);
    else $("html").removeClass($99ad575d7443e4d6$var$sph);
//if (isTablet || isMobile) {
//    if (!$(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").addClass('ad-scroll-fix');
//    }
//} else {
//    if ($(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").removeClass('ad-scroll-fix');
//    }
//}
}
function $99ad575d7443e4d6$var$fixLeaderboardOnMobileTablet() {
    const width = $(document).width();
    const isTablet = width <= 976 && width > 768;
    const isMobile = width <= 768;
    const newTakeOverActive = $("body").hasClass("hero-takeover-active");
//if (newTakeOverActive) {
//    $(".leaderboard-container").removeClass('ad-scroll-fix');
//    return;
//}
//if (isTablet || isMobile) {
//    if (!$(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").addClass('ad-scroll-fix');
//    }
//} else {
//    if ($(".leaderboard-container").hasClass('ad-scroll-fix')) {
//        $(".leaderboard-container").removeClass('ad-scroll-fix');
//    }
//}
}
function $99ad575d7443e4d6$var$checkPhoneRequirement() {
    const partnerByPhone = $("#PartnerByPhone").is(":checked");
    const bauerByPhone = $("#BauerByPhone").is(":checked");
    const phoneNumber = $("#PhoneNumber").val();
    if (partnerByPhone === true || bauerByPhone === false) {
        if (phoneNumber !== "") $("[data-phone-validation]").addClass("hidden");
        else $("[data-phone-validation]").removeClass("hidden");
    } else $("[data-phone-validation]").addClass("hidden");
}
function $99ad575d7443e4d6$var$onShowNavbar(e) {
    let minusHeight = 85;
    if ($("html").hasClass("scrolled-past-header")) {
        minusHeight = 35;
        if ($("body").hasClass("mrcms-admin-bar-on")) minusHeight = 65;
    } else if ($("body").hasClass("mrcms-admin-bar-on")) minusHeight = 115;
    const windowHeight = $(window).innerHeight() - minusHeight;
    $(".navbar-collapse .nav.navbar-nav ").css({
        height: windowHeight
    });
    $("body").attr("style", "margin: 0; height: 0; overflow: hidden;");
    $("#main-content").attr("style", "visibility:hidden");
//$(".ad-scroll-fix").hide();
}
function $99ad575d7443e4d6$var$onHideNavbar(e) {
    $("body").attr("style", "");
    $("#main-content").attr("style", "");
//$(".ad-scroll-fix").show();
}
function $99ad575d7443e4d6$var$onShowRightHandBar(e) {
    if (window.isViewportLessThan("lg")) {
        $("body").attr("style", "margin: 0; height: 0; overflow: hidden;");
        $("[data-ads-main-column]").attr("style", "margin: 0; height: 0; overflow: hidden;visibility:hidden");
        $(".leaderboard-container").attr("style", "height: 0; visibility:hidden");
        $("footer").attr("style", "height: 0; visibility:hidden");
    //$(".ad-scroll-fix").hide();
    }
}
function $99ad575d7443e4d6$var$onShownRightHandBar(e) {
    if (window.isViewportLessThan("lg")) {
        let minusHeight = 90;
        if ($("html").hasClass("scrolled-past-header")) minusHeight = 30;
        const rightMenuHeight = $(window).innerHeight() - minusHeight;
        $("#righthandbar.collapse.in").css({
            height: rightMenuHeight
        });
    }
}
function $99ad575d7443e4d6$var$onHideRightHandBar(e) {
    if (window.isViewportLessThan("lg")) {
        $("body").attr("style", "");
        $("[data-ads-main-column]").attr("style", "");
        $(".leaderboard-container").attr("style", "");
        $("footer").attr("style", "");
    //$(".ad-scroll-fix").show();
    }
}
function $99ad575d7443e4d6$var$onShowHidePasswordClick(event) {
    event.preventDefault();
    const input = $("#show_hide_password input");
    const visible = $("#show_hide_password i");
    if (input.attr("type") === "text") {
        input.attr("type", "password");
        visible.addClass("fa-eye-slash");
        visible.removeClass("fa-eye");
    } else if (input.attr("type") === "password") {
        input.attr("type", "text");
        visible.removeClass("fa-eye-slash");
        visible.addClass("fa-eye");
    }
}
function $99ad575d7443e4d6$var$fixAdOnScroll() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) {
        if ($(window).scrollTop() > 100) {
            if (!$("#top-leaderboard").hasClass("ad-scroll-fix")) $("#top-leaderboard").addClass("ad-scroll-fix");
        } else $("#top-leaderboard").removeClass("ad-scroll-fix");
    }
}
function $99ad575d7443e4d6$var$stickyInline01() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) $("#top-leaderboard").removeClass("sticky-dfp-ad");
}
function $99ad575d7443e4d6$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    var toggleBtn = document.getElementById("body-copy-toggle");
    if (textDiv && toggleBtn) {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.scrollHeight; // use scrollHeight to get total content height
        // If 'textDiv' height is more than the height of 2 lines of text, show the toggle button
        if (textDivHeight > 50) {
            toggleBtn.style.display = "block";
            // Set initial collapsed state
            textDiv.style.maxHeight = "3.2em";
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                var isCollapsed = textDiv.style.maxHeight === "3.2em";
                if (isCollapsed) {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                } else {
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                }
            });
        }
    }
}
function $99ad575d7443e4d6$export$7689f9df4f599197() {
    $99ad575d7443e4d6$var$stickyInline01();
    // need to do this after document.ready so that all dependencies are loaded
    //$(window).scroll(fixingHeaderBar);
    //$(window).on('load', fixingHeaderBar);
    //$(window).on('resize', fixingHeaderBar);
    $(document).on("click", "#OtherButton", function() {
        const classAttribute = $(this).attr("class");
        if (classAttribute.indexOf("active") > -1) $("[data-other-text]").show();
        else {
            $("[data-other-text]").hide();
            $("#OtherText").val("");
        }
    });
    $99ad575d7443e4d6$var$fixLeaderboardOnMobileTablet();
    $(window).resize(function() {
        $99ad575d7443e4d6$var$fixLeaderboardOnMobileTablet();
    });
    $("nav.navbar .collapse").on("show.bs.collapse", $99ad575d7443e4d6$var$onShowNavbar);
    $("nav.navbar .collapse").on("hide.bs.collapse", $99ad575d7443e4d6$var$onHideNavbar);
    $("#righthandbar").on("show.bs.collapse", $99ad575d7443e4d6$var$onShowRightHandBar);
    $("#righthandbar").on("shown.bs.collapse", $99ad575d7443e4d6$var$onShownRightHandBar);
    $("#righthandbar").on("hide.bs.collapse", $99ad575d7443e4d6$var$onHideRightHandBar);
    $("#compareanothercar-link").click(function(event) {
        event.preventDefault();
        $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top
        }, 500);
    });
    $("#show_hide_password a").on("click", $99ad575d7443e4d6$var$onShowHidePasswordClick);
    $("[data-past-events]").click(function() {
        $("html, body").animate({
            scrollTop: $("#past-events").offset().top
        }, 100);
    });
    $("#PartnerByPhone").change(function() {
        $99ad575d7443e4d6$var$checkPhoneRequirement();
    });
    $("#BauerByPhone").change(function() {
        $99ad575d7443e4d6$var$checkPhoneRequirement();
    });
    $("#PhoneNumber").blur(function() {
        $99ad575d7443e4d6$var$checkPhoneRequirement();
    });
    $("#PhoneNumber").keypress(function() {
        $("[data-phone-validation]").addClass("hidden");
    });
    $(document).on("click", "[data-btn-register]", $99ad575d7443e4d6$var$onRegisterButtonClick);
    window.setTimeout(function() {
        $(".form-submitted-message").fadeTo(500, 0).slideUp(500, function() {
            $(this).remove();
        });
    }, 4000);
    $(window).on("scroll", $99ad575d7443e4d6$var$onFNScroll);
    /*$('body').prepend('<a href="#" class="back-to-top">Back to Top</a>');*/ const amountScrolled = 300;
    $(window).scroll(function() {
        if ($(window).scrollTop() > amountScrolled) $("a.back-to-top").fadeIn("slow");
        else $("a.back-to-top").fadeOut("slow");
    });
    $("a.back-to-top, a.simple-back-to-top").click(function() {
        $("html, body").animate({
            scrollTop: 0
        }, 700);
        return false;
    });
    $("[data-extra-content]").click(function(e) {
        e.preventDefault();
        $("#extra-content").toggle("slow");
    });
    $("[data-more-charging-info]").click(function() {
        $("html, body").animate({
            scrollTop: $("#charging-data").offset().top - 100
        }, 700);
        return false;
    });
    $(document).on("scroll", $99ad575d7443e4d6$var$fixAdOnScroll);
    $99ad575d7443e4d6$var$handleBodyCopyToggle();
// $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
//     // Avoid following the href location when clicking
//     event.preventDefault();
//     // Avoid having the menu to close when clicking
//     event.stopPropagation();
//     // If a menu is already open we close it
//     //$('ul.dropdown-menu [data-toggle=dropdown]').parent().removeClass('open');
//     // opening the one you clicked on
//     //$(this).parent().addClass('open');
//
//     $(this).closest(".dropdown-submenu").toggleClass("open");
// });
}


const $fe07b9887899a8fb$var$history = window.History;
function $fe07b9887899a8fb$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $fe07b9887899a8fb$var$getData() {
    const dataArray = $("[data-car-tax-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $fe07b9887899a8fb$var$updateResultsLogic(isPageChange) {
    const data = $fe07b9887899a8fb$var$getData();
    if (isPageChange) data.isPageChange = true;
    $fe07b9887899a8fb$var$history.pushState(data, $("title").html(), location.pathname + "?" + $fe07b9887899a8fb$var$buildUpQueryString(data));
    return data;
}
function $fe07b9887899a8fb$var$triggerUpdateResults(event) {
    if (event.target.name === "Manufacturer1Id") {
        if ($("#ModelGroup1Id").val() !== null) {
            $("#ModelGroup1Id").val("");
            $("#Derivative1Id").val("");
        }
    }
    if (event.target.name === "ModelGroup1Id") {
        if ($("#Derivative1Id").val() !== null) $("#Derivative1Id").val("");
    }
    window.updateResults();
}
function $fe07b9887899a8fb$var$reloadQuery() {
    const state = $fe07b9887899a8fb$var$history.getState();
    $.get("/costs/new-car-tax-calculator/query", state.data, function(response) {
        $("[data-car-tax-query-attributes]").replaceWith(response);
    });
}
function $fe07b9887899a8fb$var$updateState() {
    $fe07b9887899a8fb$var$reloadQuery();
    const state = $fe07b9887899a8fb$var$history.getState();
    $.get("/costs/new-car-tax-calculator/results", state.data, function(response) {
        $("[data-car-tax-results-container]").replaceWith(response);
        if (window.isViewportLessThan("lg")) {
            $(".first-car-tax-result").insertAfter($(".first-car-tax-query"));
            $(".second-car-tax-result").insertAfter($(".second-car-tax-query"));
        }
    });
}
function $fe07b9887899a8fb$var$moveElements() {
    if (window.isViewportLessThan("lg")) {
        $(".first-car-tax-result").insertAfter($(".first-car-tax-query"));
        $(".second-car-tax-result").insertAfter($(".second-car-tax-query"));
    }
}
function $fe07b9887899a8fb$export$7c7fd016d0e808fe() {
    if ($("[data-new-car-tax-calculator]").length) {
        $(document).on("change", "[data-car-tax-query-attributes] input, [data-car-tax-query-attributes] select", $fe07b9887899a8fb$var$triggerUpdateResults);
        // Bind to StateChange Event
        $fe07b9887899a8fb$var$history.Adapter.bind(window, "statechange", $fe07b9887899a8fb$var$updateState);
        $fe07b9887899a8fb$var$moveElements();
        $(window).on("resize", $fe07b9887899a8fb$var$moveElements);
        window.updateResults = function() {
            $fe07b9887899a8fb$var$updateResultsLogic();
        };
    }
}


const $1e7dc984495afd55$var$history = window.History;
function $1e7dc984495afd55$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $1e7dc984495afd55$var$getData() {
    const dataArray = $("[data-fuel-cost-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $1e7dc984495afd55$var$updateResultsLogic(isPageChange) {
    const data = $1e7dc984495afd55$var$getData();
    if (isPageChange) data.isPageChange = true;
    $1e7dc984495afd55$var$history.pushState(data, $("title").html(), location.pathname + "?" + $1e7dc984495afd55$var$buildUpQueryString(data));
    return data;
}
function $1e7dc984495afd55$var$triggerUpdateResults(event) {
    const currentMpg = $("#Mpg").val();
    if ($(event.target).data("autocomplete") != null) return;
    if (event.target.name === "FuelType") $("#PencePerLitre").val("");
    if (event.target.name === "Mileage") {
        if (currentMpg === "") return;
    }
    if (event.target.name === "ManufacturerId") {
        if (currentMpg !== "") $("#Mpg").val("");
        if ($("#ModelGroupId").val() != null) {
            $("#ModelGroupId").val("");
            $("#DerivativeId").val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if (currentMpg !== "") $("#Mpg").val("");
        if ($("#DerivativeId").val() != null) $("#DerivativeId").val("");
    }
    window.updateResults();
}
function $1e7dc984495afd55$var$calculateExtraMpg(event) {
    event.preventDefault();
    const currentMpg = parseFloat($("#Mpg").val());
    $("#Mpg").val(currentMpg + 5);
    window.updateResults();
}
//function calculateExtra1P(event) {
//    event.preventDefault();
//    var currentPrice = parseFloat($("#PencePerLitre").val());;
//    $("#PencePerLitre").val(currentPrice + 1);
//    window.updateResults();
//}
function $1e7dc984495afd55$var$calculateExtra3P(event) {
    event.preventDefault();
    const currentPrice = parseFloat($("#PencePerLitre").val());
    $("#PencePerLitre").val(currentPrice + 3);
    window.updateResults();
}
function $1e7dc984495afd55$var$scrollToResult(event) {
    const penceperlitre = $("#PencePerLitre").val();
    const mileage = $("#Mileage").val();
    const mpg = $("#Mpg").val();
    let headerHeight = 300;
    if (window.isViewportLessThan("md")) headerHeight = 120;
    if (penceperlitre !== "" && mileage !== "" && mpg !== "") $("html, body").animate({
        scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
    }, 2000);
    if (penceperlitre !== "" && mileage !== "" && mpg === "") {
        $("[data-mpg-message]").append("<div class='alert alert-danger margin-bottom-15'>Please enter mpg or choose the make, model and version for us to find it for you.</div>");
        $("html, body").animate({
            scrollTop: $("[data-mpg-section]").offset().top - headerHeight
        }, 2000);
    }
}
function $1e7dc984495afd55$var$reloadQuery() {
    const state = $1e7dc984495afd55$var$history.getState();
    $.get("/costs/new-fuel-cost-calculator/query", state.data, function(response) {
        $("[data-fuel-cost-query-attributes]").replaceWith(response);
    });
}
function $1e7dc984495afd55$var$updateState() {
    $1e7dc984495afd55$var$reloadQuery();
    const state = $1e7dc984495afd55$var$history.getState();
    $.get("/costs/new-fuel-cost-calculator/results", state.data, function(response) {
        $("[data-fuel-cost-results-container]").replaceWith(response);
        if (response.indexOf("fuel-cost-calculator-result") !== -1) {
            let headerHeight = 300;
            if (window.isViewportLessThan("md")) headerHeight = 120;
            $("html, body").animate({
                scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
            }, 2000);
        }
    });
}
function $1e7dc984495afd55$export$536c895956e6bdad() {
    if ($("[data-new-fuel-cost-calculator]").length) {
        $(document).on("change", "[data-fuel-cost-query-attributes] input, [data-fuel-cost-query-attributes] select", $1e7dc984495afd55$var$triggerUpdateResults);
        $(document).on("click", "[data-recalculate-extra-mpg]", $1e7dc984495afd55$var$calculateExtraMpg);
        //$(document).on("click", "[data-recalculate-extra-1p]", calculateExtra1P);
        $(document).on("click", "[data-recalculate-extra-3p]", $1e7dc984495afd55$var$calculateExtra3P);
        $(document).on("click", "[data-view-result-button]", $1e7dc984495afd55$var$scrollToResult);
        // Bind to StateChange Event
        $1e7dc984495afd55$var$history.Adapter.bind(window, "statechange", $1e7dc984495afd55$var$updateState);
        window.updateResults = function() {
            $1e7dc984495afd55$var$updateResultsLogic();
        };
    }
}


$.fn.replaceWithCallback = function(replace, callback) {
    var ret = $.fn.replaceWith.call(this, replace); // Call replaceWith
    if (typeof callback === "function") callback.call(ret); // Call your callback
    return ret; // For chaining
};
let $c4df93a4feca97f3$var$reset = false;
const $c4df93a4feca97f3$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $c4df93a4feca97f3$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
//sorting the results
function $c4df93a4feca97f3$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("new-running-cost-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy !== newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateCarRunningCostResults();
}
function $c4df93a4feca97f3$var$getData(page) {
    const operatingCycleId = $("#OperatingCycleId").val();
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const miles = $("#Miles").val();
    const years = $("#Years").val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const carType = $("#CarType").val();
    const co2From = $("#CO2From").val();
    const co2To = $("#CO2To").val();
    const bikPriceFrom = $("#BIKPriceFrom").val();
    const bikPriceTo = $("#BIKPriceTo").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $c4df93a4feca97f3$var$getActiveFuelTypes();
    return {
        OperatingCycleId: operatingCycleId,
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Miles: miles,
        Years: years,
        Manufacturer: manufacturer,
        Model: model,
        CarType: carType,
        BIKPriceFrom: bikPriceFrom,
        BIKPriceTo: bikPriceTo,
        CO2From: co2From,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}
function $c4df93a4feca97f3$var$buildUpQueryString(data) {
    let queryString = "";
    const operatingCycleDefault = $("#OperatingCycleId option").eq(0).val();
    if (data.OperatingCycleId !== operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += `Years=${data.Years}&Miles=${data.Miles}`;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += `CarType=${data.CarType}`;
    else queryString += "CarType=";
    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.Manufacturer}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.Model}`;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += `CO2From=${data.CO2From}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `CO2To=${data.CO2To}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `BIKPriceFrom=${data.BIKPriceFrom}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `BIKPriceTo=${data.BIKPriceTo}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortDesc=${data.SortDesc}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `FuelType=${data.FuelType}`;
    return `?${queryString}`;
}
//asc & desc sorting
function $c4df93a4feca97f3$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $(`[data-new-running-cost-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $(`[data-new-running-cost-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
//load the datatable for low res
function $c4df93a4feca97f3$var$loadAsDataTable() {
    const table = $("#new-running-costs").DataTable({
        // responsive: {
        //     breakpoints: [
        //         ]
        // },
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
    //Check spacer when datatable responsive display collapsed (hide)
    table.on("responsive-display.dt", function(e, datatable, row, showHide, update) {
        $c4df93a4feca97f3$var$resetSpacersSize();
    });
}
function $c4df93a4feca97f3$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $c4df93a4feca97f3$var$updateResultsLogic(page) {
    const data = $c4df93a4feca97f3$var$getData(page);
    var returnUrl = "/Identity/Account/Login?returnUrl=" + location.pathname + $c4df93a4feca97f3$var$buildUpQueryString(data);
    $c4df93a4feca97f3$var$History.pushState(data, $("title").html(), location.pathname + $c4df93a4feca97f3$var$buildUpQueryString(data));
//setTimeout(function () {
//    $('[data-tco-login-link]').attr('href', returnUrl);
//}, 1000);
}
function $c4df93a4feca97f3$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] === "p";
    })[0].split("=")[1];
}
function $c4df93a4feca97f3$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/cap-manufacturer-url/${manId}`, function(response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#Manufacturer").val(manufacturer);
        }
    }
}
function $c4df93a4feca97f3$var$setCarType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "VehicleGroupId";
            })[0].split("=")[1];
            $.get(`/cap-car-type-url/${vehicleGroupId}`, function(response) {
                $("#CarType").val(response);
            });
        } else if (href.indexOf("CarType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "CarType";
            })[0].split("=")[1];
            $("#CarType").val(carType);
        }
    }
}
function $c4df93a4feca97f3$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/cap-model-url/${manufacturerId}/${modelId}`, function(response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#Model").val(model);
        }
    }
}
function $c4df93a4feca97f3$var$setOperatingCycle() {
    $.get(`/cap-operating-cycles/miles/${$("#DefaultOperatingCycleId").val()}`, function(response) {
        $("#Miles").val(response);
    });
    $.get(`/cap-operating-cycles/years/${$("#DefaultOperatingCycleId").val()}`, function(response) {
        $("#Years").val(response);
    });
}
function $c4df93a4feca97f3$var$setupMpus() {
    if (window.location.pathname === "/car-running-costs-calculator" && window.location.search !== "") {
        if ($("#mpus").length) $("#mpus").remove();
        if ($("#running-cost-mobile-mpu").length) $("#running-cost-mobile-mpu").remove();
    }
}
function $c4df93a4feca97f3$var$showHideDetail() {
    const $this = $(this);
    let id = $this.attr("href");
    let collapsibleElement = document.querySelector(id);
    if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
    if (collapsibleElement) {
        if (!collapsibleElement.dataset.eventInitiated) collapsibleElement.addEventListener("shown.bs.collapse", function(e) {
            this.dataset.eventInitiated = true;
            let spacer = $(collapsibleElement).closest("tr").next("tr.spacer");
            if (spacer) spacer.find("td").attr("height", $(this).height());
        });
    }
    const currentText = $.trim($this.text());
    const row = $this.closest("tr");
    let currentSpacer = $this.closest("table").find('.spacer[data-id="' + id + '"]');
    const rowHeight = row.height();
    if (currentText === "View data") {
        $this.text("Hide data");
        const takeOverClass = $("body").attr("class");
        if (currentSpacer.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo("xl")) {
                if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="195"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            } else if (window.getViewportSize() == "lg") {
                if (rowHeight > 40) {
                    if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="165"></td></tr>');
                    else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="145"></td></tr>');
                } else if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="195"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            } else if (window.getViewportSize() == "md") {
                if (takeOverClass === "takeover-active desktop-takeover") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="210"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="190"></td></tr>');
            } else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="350"></td></tr>');
        }
    } else {
        $this.text("View data");
        currentSpacer.remove();
    }
    $c4df93a4feca97f3$var$resetSpacersSize();
}
function $c4df93a4feca97f3$var$markAsLoading() {
    let container = $("#new-running-cost-results-container");
    container.height(container.height()); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $c4df93a4feca97f3$var$pageData(event) {
    event.preventDefault();
    //markAsLoading();
    if ($(this).attr("href") === undefined) return;
    const page = $c4df93a4feca97f3$var$getPage($(this).attr("href"));
    $c4df93a4feca97f3$var$updateResultsLogic(page);
}
function $c4df93a4feca97f3$var$checkIsDigitsOnly(e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which !== 8 && e.which !== 0 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
        //display error message
        const id = $(e.target).attr("id");
        $(`[data-error="${id}"]`).html("digits only").show().fadeOut("slow");
        return false;
    }
}
//adding to compare list
function $c4df93a4feca97f3$var$addVehicle(id, callback) {
    $.get(`/compare-list/handle/add/${id}`, function(response) {
        let success;
        if (response === 0) success = true;
        else if (response === 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response === 2) success = true;
        else {
            alert("Error");
            success = false;
        }
        if (callback) callback(success);
    });
//$("html, body").animate({ scrollTop: 0 }, "slow");
}
function $c4df93a4feca97f3$var$removeVehicle(id, callback) {
    $.get(`/compare-list/handle/remove/${id}`, function(response) {
        const success = response === 0;
        if (callback) callback(success);
    });
}
function $c4df93a4feca97f3$var$reloadQuery() {
    const State = $c4df93a4feca97f3$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/new-running-cost/query", State.data, function(response) {
        $("#new-running-cost-query-container").replaceWith(response);
        $c4df93a4feca97f3$var$handleBodyCopyToggle();
    });
    $.get("/new-running-cost/bottom-seo", State.data, function(response) {
        $("#new-running-cost-seo-container").replaceWith(response);
        $c4df93a4feca97f3$var$handleBodyCopyToggle();
    });
//$('html,body').animate({
//        scrollTop: $(".actual-filters-con").offset().top
//    },
//    'slow');
}
function $c4df93a4feca97f3$var$markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text("Add to compare");
}
function $c4df93a4feca97f3$var$markAsToRemove(btn) {
    btn.html(btn.data("original-text"));
    btn.addClass("added");
    btn.text("Comparing");
}
function $c4df93a4feca97f3$var$updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("new-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data("original-text")) btn.data("original-text", btn.html());
    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) $c4df93a4feca97f3$var$removeVehicle(data, function(success) {
        if (success) {
            $c4df93a4feca97f3$var$markAsToAdd(btn);
            $c4df93a4feca97f3$var$reloadQuery();
        } else $c4df93a4feca97f3$var$markAsToRemove(btn);
        $c4df93a4feca97f3$var$reloadQuery();
    });
    else $c4df93a4feca97f3$var$addVehicle(data, function(success) {
        if (success) {
            $c4df93a4feca97f3$var$markAsToRemove(btn);
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
            $c4df93a4feca97f3$var$reloadQuery();
        } else $c4df93a4feca97f3$var$markAsToAdd(btn);
    });
//setTimeout(function () { fuelTypeButtons(); }, 800);
}
function $c4df93a4feca97f3$var$onChangeFilters(event) {
    //markAsLoading();
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "OperatingCycleId") {
        const id = $(this).val();
        $.get(`/cap-operating-cycles/miles/${id}`, function(response) {
            $("#Miles").val(response);
            $.get(`/cap-operating-cycles/years/${id}`, function(response) {
                $("#Years").val(response);
                window.updateCarRunningCostResults();
            });
        });
    } else if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#Model").val("");
        if (parseInt($(this).val()) > 0) $.get(`/cap-manufacturer-url/${$(this).val()}`, function(response) {
            $("#Manufacturer").val(response);
            window.updateCarRunningCostResults();
        });
        else {
            $("#Manufacturer").val("");
            window.updateCarRunningCostResults();
        }
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/cap-manufacturer-url/${$("#ManufacturerId").val()}`, function(response) {
                $("#Manufacturer").val(response);
            });
            $.get(`/cap-model-url/${$("#ManufacturerId").val()}/${$(this).val()}`, function(response) {
                $("#Model").val(response);
                window.updateCarRunningCostResults();
            });
        } else {
            $("#Model").val("");
            window.updateCarRunningCostResults();
        }
    } else if (currentDropdown === "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get(`/cap-car-type-url/${$("#VehicleGroupId").val()}`, function(response) {
            $("#CarType").val(response);
            window.updateCarRunningCostResults();
        });
        else {
            $("#CarType").val("");
            window.updateCarRunningCostResults();
        }
    } else window.updateCarRunningCostResults();
}
function $c4df93a4feca97f3$var$updateFuelTypes(event) {
    //markAsLoading();
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateCarRunningCostResults();
}
function $c4df93a4feca97f3$var$updateState() {
    $c4df93a4feca97f3$var$markAsLoading();
    $c4df93a4feca97f3$var$reloadQuery();
    const State = $c4df93a4feca97f3$var$History.getState();
    $.get("/new-running-cost/results", State.data, function(response) {
        $("#new-running-cost-results-container").replaceWith(response);
        $("#new-running-cost-results-container input[name^='comparelist']").each(function() {
            const compareListId = $(this).val();
            $(`[data-new-compare-list-add-id=${compareListId}]`).addClass("added").text("Comparing");
        });
        $c4df93a4feca97f3$var$loadAsDataTable();
        $c4df93a4feca97f3$var$applyResultsSortArrows();
        if ($c4df93a4feca97f3$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
            $c4df93a4feca97f3$var$reset = false;
        }
    }).done(function() {
        setTimeout(function() {
            const resultsContainer = document.getElementById("new-running-cost-results-container");
            console.log(resultsContainer.getAttribute("data-results-loaded"));
            // ad slots
            window.ayManagerEnv = window.ayManagerEnv || {
                cmd: []
            };
            if (typeof Handlebars === "undefined") console.error("Handlebars not loaded.");
            if (!Handlebars.helpers.json) Handlebars.registerHelper("json", function(context) {
                return JSON.stringify(context);
            });
            const adSlotTemplate = Handlebars.compile(document.getElementById("ad-slot-template").innerHTML);
            const adSlots = {};
            const adSections = document.querySelectorAll("[data-ad-id]");
            if (adSections.length === 0) console.warn("No ad section found.");
            adSections.forEach(function(section) {
                const adDataInputs = section.querySelectorAll("[data-ad-data]");
                adDataInputs.forEach(function(adSlot) {
                    let adSlotData = adSlot.getAttribute("data-ad-data");
                    try {
                        adSlotData = JSON.parse(adSlotData);
                    } catch (e) {
                        console.warn("Invalid JSON in data-ad-data:", adSlotData);
                    }
                    if (!adSlotData || !adSlotData.slotId) console.warn("Invalid ad slot data:", adSlotData);
                    const adSlotHtml = adSlotTemplate(adSlotData);
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = adSlotHtml;
                    const newSlotElem = tempDiv.firstElementChild;
                    adSlot.parentNode.replaceChild(newSlotElem, adSlot);
                    adSlots[adSlotData.slotId] = {
                        slotId: adSlotData.slotId,
                        sizeMapping: adSlotData.sizeMapping,
                        isEager: adSlotData.isEager || false,
                        outOfPage: adSlotData.outOfPage || false,
                        container: document.getElementById(adSlotData.slotId + "-container"),
                        element: document.getElementById(adSlotData.slotId)
                    };
                });
                setupAdMovement(adSlots, section);
            });
            function shouldAdd(adSlot) {
                return !!adSlot.container.closest("[data-ads-hidden-column]");
            }
            function getIndex(adSlot) {
                const hiddenColumn = adSlot.container.closest("[data-ads-hidden-column]");
                if (!hiddenColumn) return -1;
                const holders = Array.from(hiddenColumn.querySelectorAll("[data-ad-slot-name]")).map((e)=>e.parentNode);
                const holder = adSlot.container.parentNode;
                return holders.indexOf(holder);
            }
            function setupAdMovement(adSlots, adSection) {
                const slotsToAdd = [];
                for(let name in adSlots)if (adSlots.hasOwnProperty(name)) {
                    const slot = adSlots[name];
                    if (shouldAdd(slot)) slotsToAdd.push(slot);
                }
                if (slotsToAdd.length === 0) return;
                slotsToAdd.sort((a, b)=>getIndex(a) - getIndex(b));
                for (let adSlot of slotsToAdd){
                    const slotName = adSlot.slotId;
                    const desktopSlot = adSlot.container;
                    let mobileReplacementSlot = adSection.querySelector(`[data-ad-mobile-replace="${slotName}"]`);
                    if (!mobileReplacementSlot) {
                        mobileReplacementSlot = document.createElement("div");
                        mobileReplacementSlot.setAttribute("data-ad-mobile-replace", slotName);
                        mobileReplacementSlot.className = "col-md-6 mb-3 text-center";
                        adSection.appendChild(mobileReplacementSlot);
                    }
                    const responsiveMovable = desktopSlot.getAttribute("data-responsive-movable");
                    mobileReplacementSlot.setAttribute("data-responsive-movable-xs", responsiveMovable);
                    mobileReplacementSlot.setAttribute("data-responsive-movable-sm", responsiveMovable);
                }
            }
            if (window.registerMovableElements && window.moveElementsToCurrentViewport) {
                window.registerMovableElements(window.jQuery || $);
                window.moveElementsToCurrentViewport(true);
            }
            window.ayManagerEnv.cmd.push(function() {
                ayManagerEnv.changePage();
            });
        }, 250);
    });
    function hideIfNoAd() {
    //the below works but then the even/odd table needs adjusting and more work that worth.
    /* setTimeout(function(){
             let $carrunningcost = $("#carrunningcost-ad-slot-1");   
             const len = $carrunningcost.html().length;
             if (len === 0){
                 $carrunningcost.parent().parent().parent().hide();
             } else {
                 $carrunningcost.parent().parent().parent().show();
             }
         }, 1000);   */ }
}
function $c4df93a4feca97f3$var$resetSpacersSize() {
    $(".spacer[data-id]").each(function() {
        let spacer = $(this);
        let id = spacer.data("id");
        let collapsibleElement = document.querySelector(id);
        if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
        if (collapsibleElement) {
            if (collapsibleElement.offsetParent !== null && $(collapsibleElement).height() > 0) spacer.find("td").attr("height", $(collapsibleElement).height());
            else spacer.remove();
        } else spacer.remove();
    });
}
function $c4df93a4feca97f3$var$handleToggleBtnClick() {
    var toggleBtn = document.getElementById("tco-toggle");
    if (toggleBtn) toggleBtn.addEventListener("click", function(e) {
        e.preventDefault();
        var textDiv = document.getElementById("text");
        if (textDiv.style.maxHeight.replace("px", "") > 19.2) {
            // If block is expanded 
            textDiv.style.maxHeight = "2.8em"; // Collapse it
            this.innerHTML = "Show more +";
        } else {
            textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
            this.innerHTML = "Show less";
        }
    });
}
function $c4df93a4feca97f3$export$332cf1f44c0656c1() {
    if (!$("[data-new-car-running-costs]").length) return;
    $c4df93a4feca97f3$var$setupMpus();
    $c4df93a4feca97f3$var$setOperatingCycle();
    $c4df93a4feca97f3$var$setManufacturer(window.location.href);
    $c4df93a4feca97f3$var$setCarType(window.location.href);
    $c4df93a4feca97f3$var$setModel(window.location.href);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
    $("[data-no-results]").hide();
    $c4df93a4feca97f3$var$loadAsDataTable();
    $(document).on("click", "[data-view-detail]", $c4df93a4feca97f3$var$showHideDetail);
    $(document).on("keypress", "[data-digits-only]", $c4df93a4feca97f3$var$checkIsDigitsOnly);
    //add to compare list button click
    $(document).on("click", "[data-new-compare-list-add-id]", $c4df93a4feca97f3$var$updateCompareList);
    //dropdown changes
    $(document).on("change", "[data-new-car-running-costs] input, [data-new-car-running-costs] select", $c4df93a4feca97f3$var$onChangeFilters);
    $(document).on("keypress", "[data-new-car-running-costs] input", function(e) {
        if (e.keyCode === 13) {
            $c4df93a4feca97f3$var$onChangeFilters();
            return false;
        }
    });
    //fuel type button chagnes
    $(document).on("click", "[data-fuel-type] a", $c4df93a4feca97f3$var$updateFuelTypes);
    //paging click
    $(document).on("click", "#new-running-cost-results-container .pagination a", $c4df93a4feca97f3$var$pageData);
    $c4df93a4feca97f3$var$applyResultsSortArrows();
    $(document).on("click", "[data-new-running-cost-sort]", $c4df93a4feca97f3$var$sortResults);
    window.addEventListener("resize", function() {
        $c4df93a4feca97f3$var$resetSpacersSize();
    });
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        let viewDetailsButton = $(this).parents("tr").find("[data-view-detail]");
        if (viewDetailsButton.length) {
            if (window.isViewportLessThan("md")) $(this).closest("tr").find(".dtr-control").trigger("click");
            else {
                let id = viewDetailsButton.attr("href");
                let collapsibleElement = document.querySelector(id);
                if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
                if (collapsibleElement) {
                    viewDetailsButton.toggleClass("collapsed");
                    viewDetailsButton.data("aria-expanded", !viewDetailsButton.data("aria-expanded"));
                    $(collapsibleElement).toggleClass("show");
                    $(this).closest("tr").find("[data-view-detail]").trigger("click");
                }
            }
        }
        $c4df93a4feca97f3$var$resetSpacersSize();
    });
    $("#new-running-cost-results-container input[name^='comparelist']").each(function() {
        const compareListId = $(this).val();
        $(`[data-new-compare-list-add-id=${compareListId}]`).addClass("added").text("Comparing");
    });
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        //var state = History.getState();
        //markAsLoading();
        $c4df93a4feca97f3$var$History.pushState({}, $("title").html(), location.pathname);
        $c4df93a4feca97f3$var$reset = true;
    });
    window.updateCarRunningCostResults = function() {
        $c4df93a4feca97f3$var$updateResultsLogic(1);
        $c4df93a4feca97f3$var$setupMpus();
    };
    $c4df93a4feca97f3$var$handleToggleBtnClick();
    // Bind to StateChange Event
    $c4df93a4feca97f3$var$History.Adapter.bind(window, "statechange", $c4df93a4feca97f3$var$updateState);
}


let $a51221e90ccfb5f2$var$reset = false;
var $a51221e90ccfb5f2$var$table;
const $a51221e90ccfb5f2$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $a51221e90ccfb5f2$var$getActiveCO2Buttons() {
    const greenButtons = $("[data-co2] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $a51221e90ccfb5f2$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $a51221e90ccfb5f2$var$getActiveNOxButtons() {
    const greenButtons = $("[data-urban-NOx] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
//sorting the results
function $a51221e90ccfb5f2$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("air-index-tool-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy !== newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$getData(page) {
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const year = $("#Year").val();
    const bodyStyle = $("#BodyStyle").val();
    const engine = $("#Engine").val();
    const co2 = $a51221e90ccfb5f2$var$getActiveCO2Buttons();
    const urbanNOx = $a51221e90ccfb5f2$var$getActiveNOxButtons();
    const searchTerm = $("#SearchTerm").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Manufacturer: manufacturer,
        Model: model,
        Year: year,
        BodyStyle: bodyStyle,
        Engine: engine,
        CO2Rating: co2,
        UrbanNoxRating: urbanNOx,
        SearchTerm: searchTerm,
        SortBy: sortBy,
        SortDesc: sortDesc,
        P: page
    };
}
function $a51221e90ccfb5f2$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.Manufacturer}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.Model}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Year=${data.Year}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `BodyStyle=${data.BodyStyle}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Engine=${data.Engine}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `CO2Rating=${data.CO2Rating}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `UrbanNOxRating=${data.UrbanNoxRating}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SearchTerm=${data.SearchTerm}`;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortDesc=${data.SortDesc}`;
    return `?${queryString}`;
}
//asc & desc sorting
function $a51221e90ccfb5f2$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $(`[data-air-index-tool-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $(`[data-air-index-tool-sort=${sortBy}]`).attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
//load the datatable for low res
function $a51221e90ccfb5f2$var$loadAsDataTable() {
    $a51221e90ccfb5f2$var$table = $("#air-index-results-table").DataTable({
        "columns": [
            {
                "className": "dt-control",
                "orderable": false,
                "data": null,
                "defaultContent": ""
            },
            {
                "data": "make"
            },
            {
                "data": "fuel"
            },
            {
                "data": "year"
            },
            {
                "data": "engine"
            },
            {
                "data": "bhp"
            },
            {
                "data": "euro"
            },
            {
                "data": "co2"
            },
            {
                "data": "nox"
            },
            {
                "data": "compare"
            }
        ],
        "order": [
            [
                1,
                "asc"
            ]
        ],
        searching: false,
        paging: false,
        "info": false,
        responsive: true,
        "ordering": false
    });
//const table = $('#air-index-results-table').DataTable({
//    "columns": [
//        {
//            "className": 'dt-control',
//            "orderable": false,
//            "data": null,
//            "defaultContent": ''
//        },
//        { "data": "make" },
//        { "data": "fuel" },
//        { "data": "year" },
//        { "data": "engine" },
//        { "data": "bhp" },
//        { "data": "euro" },
//        { "data": "co2" },
//        { "data": "nox" },
//        { "data": "compare" }
//    ],
//    "order": [[1, 'asc']],
//    searching: false,
//    paging: false,
//    "info": false,
//    responsive: true
//});
}
function $a51221e90ccfb5f2$var$updateResultsLogic(page) {
    const data = $a51221e90ccfb5f2$var$getData(page);
    $a51221e90ccfb5f2$var$History.pushState(data, $("title").html(), location.pathname + $a51221e90ccfb5f2$var$buildUpQueryString(data));
//hideInitialBodyContent();
}
function $a51221e90ccfb5f2$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] === "p";
    })[0].split("=")[1];
}
function $a51221e90ccfb5f2$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/manufacturer-url/${manId}`, function(response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#Manufacturer").val(manufacturer);
        }
    }
}
function $a51221e90ccfb5f2$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/model-url/${manufacturerId}/${modelId}`, function(response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#Model").val(model);
        }
    }
}
function $a51221e90ccfb5f2$var$markAsLoading() {
    $("#air-index-tool-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $a51221e90ccfb5f2$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $a51221e90ccfb5f2$var$getPage($(this).attr("href"));
    $a51221e90ccfb5f2$var$updateResultsLogic(page);
}
//adding to compare list
function $a51221e90ccfb5f2$var$addVehicle(id, callback) {
    $.get(`/emissions-data/compare-list/handle/add/${id}`, function(response) {
        let success;
        if (response === 0) success = true;
        else if (response === 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response === 2) success = true;
        else {
            alert("Error");
            success = false;
        }
        if (callback) callback(success);
    });
}
function $a51221e90ccfb5f2$var$removeVehicle(id, callback) {
    $.get(`/emissions-data/compare-list/handle/remove/${id}`, function(response) {
        const success = response === 0;
        if (callback) callback(success);
    });
}
function $a51221e90ccfb5f2$var$reloadQuery() {
    const State = $a51221e90ccfb5f2$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/emissions-data/query", State.data, function(response) {
        $("#air-index-tool-query-container").replaceWith(response);
        $a51221e90ccfb5f2$var$handleBodyCopyToggle();
    });
}
function $a51221e90ccfb5f2$var$markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text("Compare");
}
function $a51221e90ccfb5f2$var$markAsToRemove(btn) {
    btn.html(btn.data("original-text"));
    btn.addClass("added");
    btn.text("Comparing");
}
function $a51221e90ccfb5f2$var$updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("air-index-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data("original-text")) btn.data("original-text", btn.html());
    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) $a51221e90ccfb5f2$var$removeVehicle(data, function(success) {
        if (success) {
            $a51221e90ccfb5f2$var$markAsToAdd(btn);
            $a51221e90ccfb5f2$var$reloadQuery();
        } else $a51221e90ccfb5f2$var$markAsToRemove(btn);
        $a51221e90ccfb5f2$var$reloadQuery();
    });
    else $a51221e90ccfb5f2$var$addVehicle(data, function(success) {
        if (success) {
            $a51221e90ccfb5f2$var$markAsToRemove(btn);
            $("html, body").animate({
                scrollTop: $("#air-index-tool-query-container").offset().top
            }, "slow");
            $a51221e90ccfb5f2$var$reloadQuery();
        } else $a51221e90ccfb5f2$var$markAsToAdd(btn);
    });
}
function $a51221e90ccfb5f2$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#Model").val("");
        $.get(`/manufacturer-url/${$(this).val()}`, function(response) {
            $("#Manufacturer").val(response);
            window.updateAirIndexToolResults();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/manufacturer-url/${$("#ManufacturerId").val()}`, function(response) {
                $("#Manufacturer").val(response);
            });
            $.get(`/model-url/${$("#ManufacturerId").val()}/${$(this).val()}`, function(response) {
                $("#Model").val(response);
                window.updateAirIndexToolResults();
            });
        } else {
            $("#Model").val("");
            window.updateAirIndexToolResults();
        }
    } else window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$updateCO2Buttons(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$updateUrbanNOxButtons(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateAirIndexToolResults();
}
function $a51221e90ccfb5f2$var$updateState() {
    $a51221e90ccfb5f2$var$markAsLoading();
    $a51221e90ccfb5f2$var$reloadQuery();
    const State = $a51221e90ccfb5f2$var$History.getState();
    $.get("/emissions-data/results", State.data, function(response) {
        $("#air-index-tool-results-container").replaceWith(response);
        $("#air-index-tool-results-container input[name^='comparelist']").each(function() {
            const compareListId = $(this).val();
            $(`[data-air-index-compare-list-add-id=${compareListId}]`).addClass("added").text("Comparing");
        });
        $a51221e90ccfb5f2$var$loadAsDataTable();
        $a51221e90ccfb5f2$var$applyResultsSortArrows();
        if ($a51221e90ccfb5f2$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning margin-top-15'>Your results will appear here - please choose a filter from above to start your search</div>");
            $a51221e90ccfb5f2$var$reset = false;
        }
    //hideInitialBodyContent(true);
    });
}
function $a51221e90ccfb5f2$var$oneDecimalPlace(x) {
    return Number.parseFloat(x).toFixed(1);
}
/* Formatting function for row details - modify as you need */ function $a51221e90ccfb5f2$var$format(id) {
    var jqXHR = $.ajax({
        url: `/emissions-data/get/${id}`,
        type: "GET",
        async: false
    });
    const obj = JSON.parse(jqXHR.responseText);
    var details = $.ajax({
        url: `/emissions-data/get-url/${id}`,
        type: "GET",
        async: false
    });
    var airco2Rating = "";
    var co2RatingStandard = "";
    if (obj.airCO2Rating === "A") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-a">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "0 - 95 g/km";
    } else if (obj.airCO2Rating === "B") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-b">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "95 - 130 g/km";
    } else if (obj.airCO2Rating === "C") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-c">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "130 - 180 g/km";
    } else if (obj.airCO2Rating === "D") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-d">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "180 - 230 g/km";
    } else if (obj.airCO2Rating === "E") {
        airco2Rating = '<div class="float-start pe-3"> <span class="air-index-rating rating-e">' + obj.airCO2Rating + "</span></div>";
        co2RatingStandard = "230+ g/km";
    }
    var urbanNoxRating = "";
    var urbanNoxStandardRating = "";
    if (obj.airUrbanNoxRating === "A") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-a">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "0 - 80 mg/km";
    } else if (obj.airUrbanNoxRating === "B") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-b">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "80 - 168 mg/km";
    } else if (obj.airUrbanNoxRating === "C") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-c">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "168 - 270 mg/km";
    } else if (obj.airUrbanNoxRating === "D") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-d">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "270 - 600 mg/km";
    } else if (obj.airUrbanNoxRating === "E") {
        urbanNoxRating = '<div class="float-start pe-3"> <span class="air-index-rating rating-e">' + obj.airUrbanNoxRating + "</span></div>";
        urbanNoxStandardRating = "600+ mg/km";
    }
    var mobileData = "";
    if (window.isViewportLessThan("md")) mobileData = '<tr class="d-md-none"><td>Fuel</td><td>' + obj.fuelType + "</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>Year</td>" + "<td>" + obj.modelYear + "</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>Engine</td>" + "<td>" + obj.engineCC + "cc</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>BHP</td>" + "<td>" + obj.powerBhp + "bhp</td>" + "</tr>" + '<tr class="d-md-none">' + "<td>Euro</td>" + "<td>" + obj.euroStage + "</td>" + "</tr>";
    var extraData = "";
    if (obj.officialNedcMpg != null) extraData += "<tr><td>Official NEDC mpg</td><td>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.officialNedcMpg) + " mpg</td>" + "</tr>";
    if (obj.officialWltpMpg != null) extraData += "<tr><td>Official WLTP mpg</td><td>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.officialWltpMpg) + " mpg</td>" + "</tr>";
    return '<div class="row additional-air-index-info"><div class="col-md-4"><table class="table">' + mobileData + '<tr class="drive">' + "<td>Drive</td>" + "<td>" + obj.driveTrain + "</td>" + "</tr>" + "<tr>" + "<td>Body type</td>" + "<td>" + obj.bodyStyle + "</td>" + "</tr>" + "<tr>" + "<td>Transmission</td>" + "<td>" + obj.transmission + "</td>" + "</tr>" + "<tr>" + "<td>Engine (Litres)</td>" + "<td>" + obj.engineL + "</td>" + "</tr>" + "<tr>" + "<td>Power</td>" + "<td>" + obj.powerPS + "bhp</td>" + "</tr>" + "<tr>" + "<td>Predicted fuel economy</td>" + "<td>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.airMpg) + " mpg<br/>" + $a51221e90ccfb5f2$var$oneDecimalPlace(obj.fuelEconomy) + " litres/100km</td>" + "</tr>" + extraData + "</table>" + '<a href="' + details.responseText + '" class="btn btn-primary mb-3">More details</a>' + "</div>" + '<div class="col-md-4 px-lg-3 px-md-4">' + '<div class="mb-3">' + "<h4>Carbon dioxide (CO2)</h4>" + "</div>" + '<div class="mb-3">' + airco2Rating + '<div class="float-start">' + '<div class="margin-bottom-10">' + "<strong>Air Index range</strong> " + "<br/>" + co2RatingStandard + "</div>" + "<strong>Official rating</strong>" + "<br/>" + "" + obj.officialCO2 + " g/km " + "</div>" + '<div class="clearfix"></div>' + "</div>" + '<div class="mb-2 mb-md-0"><strong> What is CO2? </strong> <br/> <small>Vehicles produce CO2 when they use fuel. The amount of CO2 produced is directly linked to how much fuel it consumes. Excess levels of CO2 can be harmful to humans and the environment.</small><br/></div><hr class="visible-xs"/>' + "</div>" + '<div class="col-md-4">' + '<div class="mb-3">' + "<h4>Urban NOx</h4>" + "</div>" + '<div class="mb-3">' + urbanNoxRating + '<div class="float-start">' + '<div class="mb-2">' + "<strong>Air Index range</strong> " + "<br/>" + urbanNoxStandardRating + "</div>" + "</div>" + '<div class="clearfix"></div>' + "</div>" + '<div class="mb-2 mb-md-0"><strong> What is Urban NOx? </strong> <br/> <small>NOx refers to nitric oxide and nitrogen dioxide. They are released from vehicle engines and can reach harmful levels in towns and cities. They are an irritant and cause inflammation of the airways.</small><br/></div>' + "</div>" + "</div>";
}
function $a51221e90ccfb5f2$var$checkBodyContent(text) {
    if (text === "Show more") {
        $("#data-air-index-body p:not(:first-child)").show(500);
        $("[data-air-index-tool-toggle]").text("Show less");
    } else {
        $("#data-air-index-body p:not(:first-child)").hide(500);
        $("[data-air-index-tool-toggle]").text("Show more");
    }
}
function $a51221e90ccfb5f2$export$1254953e51e11fff() {
    if (!$("[data-air-index-tool]").length) return;
    //hideInitialBodyContent(false);
    $(document).on("click", "[data-air-index-tool-toggle]", function(e) {
        e.preventDefault();
        var text = $(this).text();
        $a51221e90ccfb5f2$var$checkBodyContent(text);
    });
    $(document).on("click", "[data-showing-cars]", function(e) {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: $("#air-index-tool-results-container").offset().top - 120
        }, "slow");
    });
    $(".slider4").bxSlider({
        slideWidth: 400,
        minSlides: 2,
        maxSlides: 3,
        moveSlides: 3,
        slideMargin: 30,
        pager: true
    });
    $(document).on("click", "#air-index-results-table tbody td.dt-control", function() {
        var tr = $(this).closest("tr");
        var row = $a51221e90ccfb5f2$var$table.row(tr);
        var selectedRow = $(this);
        var itemId = selectedRow.data("item-id");
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass("shown");
        } else {
            // Open this row
            row.child($a51221e90ccfb5f2$var$format(itemId)).show();
            tr.addClass("shown");
        }
    //if (row.child.isShown()) {
    //    if (window.isViewportLessThan('md')) {
    //        // Open this row
    //        row.child(format(itemId)).show();
    //        tr.addClass('shown');
    //    } else {
    //        // This row is already open - close it
    //        row.child.hide();
    //        tr.removeClass('shown');
    //    }
    //}
    //else {
    //    if (window.isViewportLessThan('md')) {
    //        // This row is already open - close it
    //        row.child.hide();
    //        tr.removeClass('shown');
    //    } else {
    //        // Open this row
    //        row.child(format(itemId)).show();
    //        tr.addClass('shown');
    //    }
    //}
    });
    $(document).on("click", "#air-index-results-table tbody td a.data-more-details", function(e) {
        e.preventDefault();
        var tr = $(this).closest("tr");
        var row = $a51221e90ccfb5f2$var$table.row(tr);
        var selectedRow = $(this);
        var itemId = selectedRow.data("item-id");
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass("shown");
        } else {
            // Open this row
            row.child($a51221e90ccfb5f2$var$format(itemId)).show();
            tr.addClass("shown");
        }
    });
    $a51221e90ccfb5f2$var$setManufacturer(window.location.href);
    $a51221e90ccfb5f2$var$setModel(window.location.href);
    $("#initial-result").html("<div class='alert alert-warning margin-top-15'>Your results will appear here - please choose a filter from above to start your search</div>");
    $("[data-no-results]").hide();
    $a51221e90ccfb5f2$var$loadAsDataTable();
    //$(document).on("click", "[data-view-detail]", showHideDetail);
    //add to compare list button click
    $(document).on("click", "[data-air-index-compare-list-add-id]", $a51221e90ccfb5f2$var$updateCompareList);
    //dropdown changes
    $(document).on("change", "[data-air-index-tool] input, [data-air-index-tool] select", $a51221e90ccfb5f2$var$onChangeFilters);
    $(document).on("keypress", "[data-air-index-tool] input", function(e) {
        if (e.keyCode === 13) {
            $a51221e90ccfb5f2$var$onChangeFilters();
            return false;
        }
    });
    //co2 button changes
    $(document).on("click", "[data-co2] a", $a51221e90ccfb5f2$var$updateCO2Buttons);
    //urban NOx button changes
    $(document).on("click", "[data-urban-NOx] a", $a51221e90ccfb5f2$var$updateUrbanNOxButtons);
    //paging click
    $(document).on("click", "#air-index-tool-results-container .pagination a", $a51221e90ccfb5f2$var$pageData);
    $a51221e90ccfb5f2$var$applyResultsSortArrows();
    $(document).on("click", "[data-air-index-tool-sort]", $a51221e90ccfb5f2$var$sortResults);
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $a51221e90ccfb5f2$var$History.pushState({}, $("title").html(), location.pathname);
        $a51221e90ccfb5f2$var$reset = true;
    });
    window.updateAirIndexToolResults = function() {
        $a51221e90ccfb5f2$var$updateResultsLogic(1);
    };
    // Bind to StateChange Event
    $a51221e90ccfb5f2$var$History.Adapter.bind(window, "statechange", $a51221e90ccfb5f2$var$updateState);
}


const $3bc885c99072932d$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $3bc885c99072932d$var$getData(page) {
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const carType = $("#CarGroup").val();
    const rangeFrom = $("#RangeFrom").val();
    const rangeTo = $("#RangeTo").val();
    const priceFrom = $("#PriceFrom").val();
    const priceTo = $("#PriceTo").val();
    const sortBy = $("#Sorting").val();
    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        CarType: carType,
        RangeFrom: rangeFrom,
        RangeTo: rangeTo,
        PriceFrom: priceFrom,
        PriceTo: priceTo,
        SortBy: sortBy,
        P: page
    };
}
function $3bc885c99072932d$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $3bc885c99072932d$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += `Manufacturer=${data.ManufacturerName}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `Model=${data.ModelName}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `CarType=${data.CarType}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `RangeFrom=${data.RangeFrom}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `RangeTo=${data.RangeTo}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `PriceFrom=${data.PriceFrom}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `PriceTo=${data.PriceTo}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += `p=${data.P}`;
    }
    return `?${queryString}`;
}
function $3bc885c99072932d$var$updateResultsLogic(page) {
    const data = $3bc885c99072932d$var$getData(page);
    $3bc885c99072932d$var$History.pushState(data, $("title").html(), location.pathname + $3bc885c99072932d$var$buildUpQueryString(data));
}
function $3bc885c99072932d$var$getPage(href) {
    const querystring = href.split("?")[1];
    console.log("EV querystring: " + querystring);
    if (!querystring) return null; // or some default value
    const parts = querystring.split("&");
    console.log("EV parts: " + parts);
    const pageParam = $.grep(parts, function(el) {
        return el.split("=")[0] === "page";
    });
    if (!pageParam.length) return null; // or some default value
    return pageParam[0].split("=")[1];
}
function $3bc885c99072932d$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/manufacturer-url/${manId}`, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $3bc885c99072932d$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "ManufacturerId";
            })[0].split("=")[1];
            $.get(`/electric-model-url/${manufacturerId}/${modelId}`, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
function $3bc885c99072932d$var$setCarType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("CarType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "CarType";
            })[0].split("=")[1];
            $("#CarGroup").val(carType);
        }
    }
}
function $3bc885c99072932d$var$setRange(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("RangeFrom") > 1) {
            const rangeFrom = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "RangeFrom";
            })[0].split("=")[1];
            $("#RangeFrom").val(rangeFrom);
        }
        if (href.indexOf("RangeTo") > 1) {
            const rangeTo = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "RangeTo";
            })[0].split("=")[1];
            $("#RangeTo").val(rangeTo);
        }
    }
}
function $3bc885c99072932d$var$setPrice(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("PriceFrom") > 1) {
            const priceFrom = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "PriceFrom";
            })[0].split("=")[1];
            $("#PriceFrom").val(priceFrom);
        }
        if (href.indexOf("PriceTo") > 1) {
            const priceTo = $.grep(parts, function(el, index) {
                return el.split("=")[0] === "PriceTo";
            })[0].split("=")[1];
            $("#PriceTo").val(priceTo);
        }
    }
}
function $3bc885c99072932d$var$markAsLoading() {
    $("#electric-vehicles-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $3bc885c99072932d$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $3bc885c99072932d$var$getPage($(this).attr("href"));
    $3bc885c99072932d$var$updateResultsLogic(page);
}
function $3bc885c99072932d$var$reloadQuery() {
    const State = $3bc885c99072932d$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/electric-vehicles/query", State.data, function(response) {
        $("#electric-vehicles-query-container").replaceWith(response);
        $3bc885c99072932d$var$setupPriceSlider();
        $3bc885c99072932d$var$setupRangeSlider();
        $3bc885c99072932d$var$handleBodyCopyToggle();
    });
}
function $3bc885c99072932d$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        if (parseInt($(this).val()) > 0) $.get(`/manufacturer-url/${$(this).val()}`, function(response) {
            $("#ManufacturerName").val(response);
            window.updateElectricVehicles();
        });
        else {
            $("#ManufacturerName").val("");
            window.updateElectricVehicles();
        }
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get(`/manufacturer-url/${$("#ManufacturerId").val()}`, function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get(`/electric-model-url/${$("#ManufacturerId").val()}/${$(this).val()}`, function(response) {
                $("#ModelName").val(response);
                window.updateElectricVehicles();
            });
        } else {
            $("#ModelName").val("");
            window.updateElectricVehicles();
        }
    } else if (currentDropdown === "CarType") {
        $("#CarGroup").val($(this).val());
        window.updateElectricVehicles();
    } else if (currentDropdown === "SortBy") {
        $("#Sorting").val($(this).val());
        window.updateElectricVehicles();
    } else window.updateElectricVehicles();
}
function $3bc885c99072932d$var$updateState() {
    $3bc885c99072932d$var$markAsLoading();
    $3bc885c99072932d$var$reloadQuery();
    const State = $3bc885c99072932d$var$History.getState();
    $.get("/electric-vehicles/results", State.data, function(response) {
        $("#electric-vehicles-results-container").replaceWith(response);
    //if (reset) {
    //    $('[data-no-results]').hide();
    //    $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose a make above to start your search</div>");
    //    reset = false;
    //}
    }).done(function() {
        setTimeout(function() {
            console.log("rendering slots for mobiles");
            // ad slots
            window.ayManagerEnv = window.ayManagerEnv || {
                cmd: []
            };
            if (typeof Handlebars === "undefined") console.error("Handlebars not loaded.");
            if (!Handlebars.helpers.json) Handlebars.registerHelper("json", function(context) {
                return JSON.stringify(context);
            });
            const adSlotTemplate = Handlebars.compile(document.getElementById("ad-slot-template").innerHTML);
            const adSlots = {};
            const adSections = document.querySelectorAll("[data-ad-id]");
            if (adSections.length === 0) console.warn("No ad section found.");
            adSections.forEach(function(section) {
                const adDataInputs = section.querySelectorAll("[data-ad-data]");
                adDataInputs.forEach(function(adSlot) {
                    let adSlotData = adSlot.getAttribute("data-ad-data");
                    try {
                        adSlotData = JSON.parse(adSlotData);
                    } catch (e) {
                        console.warn("Invalid JSON in data-ad-data:", adSlotData);
                    }
                    if (!adSlotData || !adSlotData.slotId) console.warn("Invalid ad slot data:", adSlotData);
                    const adSlotHtml = adSlotTemplate(adSlotData);
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = adSlotHtml;
                    const newSlotElem = tempDiv.firstElementChild;
                    adSlot.parentNode.replaceChild(newSlotElem, adSlot);
                    adSlots[adSlotData.slotId] = {
                        slotId: adSlotData.slotId,
                        sizeMapping: adSlotData.sizeMapping,
                        isEager: adSlotData.isEager || false,
                        outOfPage: adSlotData.outOfPage || false,
                        container: document.getElementById(adSlotData.slotId + "-container"),
                        element: document.getElementById(adSlotData.slotId)
                    };
                });
                setupAdMovement(adSlots, section);
            });
            function shouldAdd(adSlot) {
                return !!adSlot.container.closest("[data-ads-hidden-column]");
            }
            function getIndex(adSlot) {
                const hiddenColumn = adSlot.container.closest("[data-ads-hidden-column]");
                if (!hiddenColumn) return -1;
                const holders = Array.from(hiddenColumn.querySelectorAll("[data-ad-slot-name]")).map((e)=>e.parentNode);
                const holder = adSlot.container.parentNode;
                return holders.indexOf(holder);
            }
            function setupAdMovement(adSlots, adSection) {
                const slotsToAdd = [];
                for(let name in adSlots)if (adSlots.hasOwnProperty(name)) {
                    const slot = adSlots[name];
                    if (shouldAdd(slot)) slotsToAdd.push(slot);
                }
                if (slotsToAdd.length === 0) return;
                slotsToAdd.sort((a, b)=>getIndex(a) - getIndex(b));
                for (let adSlot of slotsToAdd){
                    const slotName = adSlot.slotId;
                    const desktopSlot = adSlot.container;
                    let mobileReplacementSlot = adSection.querySelector(`[data-ad-mobile-replace="${slotName}"]`);
                    if (!mobileReplacementSlot) {
                        mobileReplacementSlot = document.createElement("div");
                        mobileReplacementSlot.setAttribute("data-ad-mobile-replace", slotName);
                        mobileReplacementSlot.className = "col-md-6 mb-3 text-center";
                        adSection.appendChild(mobileReplacementSlot);
                    }
                    const responsiveMovable = desktopSlot.getAttribute("data-responsive-movable");
                    mobileReplacementSlot.setAttribute("data-responsive-movable-xs", responsiveMovable);
                    mobileReplacementSlot.setAttribute("data-responsive-movable-sm", responsiveMovable);
                }
            }
            if (window.registerMovableElements && window.moveElementsToCurrentViewport) {
                window.registerMovableElements(window.jQuery || $);
                window.moveElementsToCurrentViewport(true);
            }
            window.ayManagerEnv.cmd.push(function() {
                ayManagerEnv.changePage();
            });
        }, 250);
    });
//$.get('/electric-vehicles/heading', State.data, function (response) {
//    $('#electric-vehicles-heading-container').replaceWith(response);
//});
}
function $3bc885c99072932d$var$setupPriceSlider() {
    let priceFromValue = parseFloat($("#PriceFrom").val());
    let minimum = 10000;
    if (!isNaN(priceFromValue) && priceFromValue !== minimum) minimum = priceFromValue;
    let priceToValue = parseFloat($("#PriceTo").val());
    let maximum = 250000;
    if (!isNaN(priceToValue) && priceToValue !== maximum) maximum = priceToValue;
    let priceSliderInput = document.querySelector("#price-slider-range");
    priceSliderInput.setAttribute("data-old-data", `${minimum},${maximum}`);
    let priceRangeSlider = new rSlider({
        target: "#price-slider-range",
        values: {
            min: 10000,
            max: 250000
        },
        range: true,
        tooltip: true,
        scale: false,
        labels: false,
        step: 500,
        set: [
            minimum,
            maximum
        ],
        onChange: function(values) {
            let oldData = priceSliderInput.getAttribute("data-old-data");
            $("#PriceFrom").val(values.split(",")[0]);
            $("#PriceTo").val(values.split(",")[1]);
            if (oldData !== values) {
                priceSliderInput.setAttribute("data-old-data", `${values}`);
                $3bc885c99072932d$var$onChangeFilters();
            }
        }
    });
}
function $3bc885c99072932d$var$setupRangeSlider() {
    let rangeFromValue = parseFloat($("#RangeFrom").val());
    let minimum = 0;
    if (!isNaN(rangeFromValue) && rangeFromValue !== minimum) minimum = rangeFromValue;
    let rangeToValue = parseFloat($("#RangeTo").val());
    let maximum = 1000;
    if (!isNaN(rangeToValue) && rangeToValue !== maximum) maximum = rangeToValue;
    let rangeSliderInput = document.querySelector("#range-slider-range");
    rangeSliderInput.setAttribute("data-old-data", `${minimum},${maximum}`);
    let rangeSliderRange = new rSlider({
        target: "#range-slider-range",
        values: {
            min: 0,
            max: 1000
        },
        range: true,
        tooltip: true,
        scale: false,
        labels: false,
        step: 10,
        set: [
            minimum,
            maximum
        ],
        onChange: function(values) {
            let oldData = rangeSliderInput.getAttribute("data-old-data");
            $("#RangeFrom").val(values.split(",")[0]);
            $("#RangeTo").val(values.split(",")[1]);
            if (oldData !== values) {
                rangeSliderInput.setAttribute("data-old-data", `${values}`);
                $3bc885c99072932d$var$onChangeFilters();
            }
        }
    });
}
function $3bc885c99072932d$export$e09e8541d6e6379b() {
    if (!$("[data-electric-vehicles]").length) return;
    $3bc885c99072932d$var$setManufacturer(window.location.href);
    $3bc885c99072932d$var$setModel(window.location.href);
    $3bc885c99072932d$var$setRange(window.location.href);
    $3bc885c99072932d$var$setPrice(window.location.href);
    $3bc885c99072932d$var$setCarType(window.location.href);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose a make above to start your search</div>");
    $("[data-no-results]").hide();
    //dropdown changes
    $(document).on("change", "[data-electric-vehicles] input, [data-electric-vehicles] select", $3bc885c99072932d$var$onChangeFilters);
    $(document).on("keypress", "[data-electric-vehicles] input", function(e) {
        if (e.keyCode === 13) {
            $3bc885c99072932d$var$onChangeFilters();
            return false;
        }
    });
    //paging click
    $(document).on("click", "#electric-vehicles-results-container .pagination a", $3bc885c99072932d$var$pageData);
    window.updateElectricVehicles = function() {
        $3bc885c99072932d$var$updateResultsLogic(1);
    };
    // Bind to StateChange Event
    $3bc885c99072932d$var$History.Adapter.bind(window, "statechange", $3bc885c99072932d$var$updateState);
    $3bc885c99072932d$var$setupPriceSlider();
    $3bc885c99072932d$var$setupRangeSlider();
}


function $ff2e9cac1156f2ea$var$setFuelPriceDate(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $ff2e9cac1156f2ea$var$drawChart(serverData) {
    var data = google.visualization.arrayToDataTable(serverData);
    var options = {
        title: "Nationwide average fuel price per litre (pence)",
        curveType: "function",
        legend: {
            position: "bottom"
        },
        chartArea: {
            width: "80%"
        }
    };
    var chart = new google.visualization.LineChart(document.getElementById("curve_chart"));
    chart.draw(data, options);
}
function $ff2e9cac1156f2ea$var$getServerData() {
    $.get("/regional-fuel-prices/average-price-chart-data", $ff2e9cac1156f2ea$var$drawChart);
}
function $ff2e9cac1156f2ea$export$376e40bec80c21a() {
    if (!$("[data-regional-fuel-prices]").length) return;
    // Define the callback function
    function init() {
        $ff2e9cac1156f2ea$var$getServerData();
        $(document).on("change", "[data-regional-fuel-price-date]", $ff2e9cac1156f2ea$var$setFuelPriceDate);
        $("#regional-fuel-prices-table").DataTable({
            responsive: true,
            "bPageinate": false,
            "bFilter": false,
            "bInfo": false,
            "bAutoWidth": false,
            "bLengthChange": false,
            "bSearchable": false,
            "iDisplayLength": -1,
            "order": [],
            "fnDrawCallback": function(oSettings) {
                $(".dataTables_paginate").hide();
            }
        });
    }
    // Load the API and specify the init function as callback
    google.charts.load("current", {
        packages: [
            "corechart"
        ],
        callback: init // This ensures init is called only after Google Charts is fully loaded
    });
}


(function($1) {
    function hoverEvent() {}
    $1(function() {
        $1(document).on("mouseover", "[data-upsell]", hoverEvent);
    });
})(jQuery);
const $a8340321fe089932$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $a8340321fe089932$var$changeSupplier() {
    const data = $a8340321fe089932$var$getData(1);
    const queryString = $a8340321fe089932$var$buildUpQueryString(data);
    if (queryString != "") $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/" + $a8340321fe089932$var$buildUpQueryString(data) + "/");
    else $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/" + $a8340321fe089932$var$buildUpQueryString(data));
//History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}
function $a8340321fe089932$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "page";
    })[0].split("=")[1];
}
function $a8340321fe089932$var$pageData(event) {
    if ($(event.target).attr("href") === undefined) return false;
    const page = $a8340321fe089932$var$getPage($(this).attr("href"));
    const data = $a8340321fe089932$var$getData(page);
    //History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
    const queryString = $a8340321fe089932$var$buildUpQueryString(data);
    if (queryString !== "") $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/" + queryString + "/");
    else $a8340321fe089932$var$History.pushState(data, $("title").html(), "/suppliers/");
    const top = $("html").offset().top;
    $("html,body").animate({
        scrollTop: top
    }, 350);
    return false;
}
function $a8340321fe089932$var$getData(page) {
    const categories = $('.supplier-categories-container input[name="Categories"]:checked').map(function(index, element) {
        return $(element).val();
    }).toArray();
    return {
        Categories: categories.join(","),
        Page: page
    };
}
function $a8340321fe089932$var$buildUpQueryString(data) {
    if (data.Categories.length == 0 && data.Page <= 1) return "";
    let queryString = "";
    if (data.Categories.length > 0) queryString += data.Categories;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "/";
        queryString += data.Page;
    }
    return queryString;
}
function $a8340321fe089932$var$updateState() {
    const State = $a8340321fe089932$var$History.getState();
    $.get("/Apps/FleetNews/supplier-zone/query", State.data, function(response) {
        $("[data-supplier-query]").replaceWith(response);
    });
    $.get("/Apps/FleetNews/supplier-zone/results", State.data, function(response) {
        $("[data-supplier-results]").replaceWith(response);
    });
}
function $a8340321fe089932$export$ae69331b624aa7a() {
    const page = $("[data-supplier-zone]").length;
    if (!page) return;
    $(document).on("change", ".supplier-categories-container input", $a8340321fe089932$var$changeSupplier);
    $(document).on("click", "[data-supplier-results] .pagination a", $a8340321fe089932$var$pageData);
    //Bind to StateChange Event
    $a8340321fe089932$var$History.Adapter.bind(window, "statechange", $a8340321fe089932$var$updateState);
}


function $86f87e45f0071f3a$export$6f277b52b642b4f9() {
    $(document).on("click", "[data-test-drive-click]", function(e) {
        var clickValue = $(this).data("test-drive-click");
        if (clickValue !== "undefined") $.get("/set-test-drive-click-count/" + clickValue, function(response) {});
    });
}


function $b9c76af634f3d75b$var$markAsLoading() {
    $("#car-launch-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $b9c76af634f3d75b$var$reloadQuery() {
    var State = History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/up-sold-car-launch/running-costs/query", State.data, function(response) {
        $("#car-launch-query-container").replaceWith(response);
    });
}
function $b9c76af634f3d75b$var$setOperatingCycle() {
    $.get("/cap-operating-cycles/miles/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Miles").val(response);
    });
    $.get("/cap-operating-cycles/years/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Years").val(response);
    });
}
function $b9c76af634f3d75b$var$buildUpQueryString(data) {
    var queryString = "";
    var operatingCycleDefault = $("#OperatingCycleId option").eq(0).val();
    if (data.OperatingCycleId != operatingCycleDefault) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Years=" + data.Years + "&Miles=" + data.Miles + "&ModelGroupId=" + data.ModelGroupId + "&DerivativeId=" + data.DerivativeId;
    }
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.imageId) > 0) queryString += "image=" + data.imageId;
    else queryString += "image=";
    if (data.ModelYear !== "") queryString += "&ModelYear=" + data.ModelYear;
    return "?" + queryString;
}
function $b9c76af634f3d75b$var$getData(page) {
    var operatingCycleId = $("#OperatingCycleId").val();
    var miles = $("#Miles").val();
    var years = $("#Years").val();
    var modelGroupId = $("#ModelGroupId").val();
    var imageId = $("#Image").val();
    var derivativeId = $("#DerivativeId").val();
    var modelYear = $("#ModelYear").val();
    return {
        OperatingCycleId: operatingCycleId,
        Miles: miles,
        Years: years,
        DerivativeId: derivativeId,
        imageId: imageId,
        ModelGroupId: modelGroupId,
        ModelYear: modelYear
    };
}
function $b9c76af634f3d75b$var$updateRunningCostsLogic(page) {
    var data = $b9c76af634f3d75b$var$getData(page);
    History.pushState(data, $("title").html(), location.pathname + $b9c76af634f3d75b$var$buildUpQueryString(data));
}
window.updateRunningCosts = function() {
    $b9c76af634f3d75b$var$updateRunningCostsLogic(1);
};
function $b9c76af634f3d75b$var$onImageSliderChange(event) {
    //console.log($(this).find(".item.active").data('image'));
    var image = $(this).find(".item.active").data("image-id");
    $("#Image").val(image);
    window.updateRunningCosts();
}
function $b9c76af634f3d75b$var$onChangeFilters(event) {
    var currentDropdown = $(this).attr("name");
    if (currentDropdown === "OperatingCycleId") {
        var derivativeId = $("#DerivativeId").val();
        if (parseInt(derivativeId) > 0) {
            var id = $(this).val();
            $.get("/cap-operating-cycles/miles/" + id, function(response) {
                $("#Miles").val(response);
                $.get("/cap-operating-cycles/years/" + id, function(response) {
                    $("#Years").val(response);
                    window.updateRunningCosts();
                });
            });
        } else alert("please select a derivative first");
    } else if (currentDropdown == "DerivativeId") {
        $("#DerivativeId").val($(this).val());
        window.updateRunningCosts();
    }
}
function $b9c76af634f3d75b$var$validateCustomForm() {
    $("#car-launch-contact-box").validate({
        rules: {
            Name: {
                required: true
            },
            Telephone: {
                require_from_group: [
                    1,
                    ".phone-group"
                ]
            },
            Email: {
                require_from_group: [
                    1,
                    ".phone-group"
                ]
            }
        },
        messages: {
            Name: "Name is required.",
            Telephone: "Please complete either email or phone number",
            Email: "Please complete either email or phone number"
        }
    });
}
function $b9c76af634f3d75b$var$updateState() {
    $b9c76af634f3d75b$var$markAsLoading();
    $b9c76af634f3d75b$var$reloadQuery();
    var State = History.getState();
    setTimeout(function() {
        $.get("/up-sold-car-launch/running-costs/results", State.data, function(response) {
            $("#car-launch-results-container").replaceWith(response);
        });
        $.get("/up-sold-car-launch/fact-sheet/results", State.data, function(response) {
            $("#car-launch-fact-sheet-container").replaceWith(response);
        });
    }, 500);
}
function $b9c76af634f3d75b$export$af46fff3f8bb6cb0() {
    if (!$("[data-upsold-car-launch]").length) return;
    $.featherlight.defaults.afterOpen = $b9c76af634f3d75b$var$validateCustomForm;
    jQuery.validator.setDefaults({
        success: "valid"
    });
    $b9c76af634f3d75b$var$setOperatingCycle();
    $(document).on("change", "[data-car-launch-running-costs] select", $b9c76af634f3d75b$var$onChangeFilters);
    $("a.carousel-control-down").click(function() {
        $("html, body").animate({
            scrollTop: $("#name").offset().top - 160
        });
        return false;
    });
    $("#carousel-example-generic").bind("slid.bs.carousel", $b9c76af634f3d75b$var$onImageSliderChange);
    $("#carousel-example-generic").swiperight(function() {
        $(this).carousel("prev");
    });
    $("#carousel-example-generic").swipeleft(function() {
        $(this).carousel("next");
    });
    var heights = $("div.sameheight").map(function() {
        return $(this).height();
    }).get(), maxHeight = Math.max.apply(null, heights);
    $("div.sameheight").height(maxHeight);
    $(document).on("submit", "[data-car-launch-contact-form]", function(e) {
        $("[data-upsold-contact-button]").disabled = true;
        var form = $(e.target);
        if (!form.valid()) return;
        e.preventDefault();
        $.post(form.attr("action"), form.serialize(), function(response) {
            $("[data-success-message]").empty().append("<section><div class='container'><div class='padding-top-15'><div class='alert alert-success'>Thank you for contacting us. You will receive a response soon.</div></div></div></section>");
            var currentfeatherlight = $.featherlight.current();
            if (currentfeatherlight) currentfeatherlight.close();
        });
    });
//History.Adapter.bind(window, 'statechange', updateState);
}


let $cb041d180d1b1b5e$var$reset = false;
const $cb041d180d1b1b5e$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $cb041d180d1b1b5e$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $cb041d180d1b1b5e$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $cb041d180d1b1b5e$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-manufacturer-url/" + manId, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $cb041d180d1b1b5e$var$setBodyType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VehicleGroupId";
            })[0].split("=")[1];
            $.get("/cap-van-type-url/" + vehicleGroupId, function(response) {
                $("#BodyType").val(response);
            });
        } else if (href.indexOf("BodyType") > 1) {
            const vanType = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "BodyType";
            })[0].split("=")[1];
            $("#BodyType").val(vanType);
        }
    }
}
function $cb041d180d1b1b5e$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
//load the datatable for low res
function $cb041d180d1b1b5e$var$loadAsDataTable() {
    const table = $("#van-co2-table").DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
}
function $cb041d180d1b1b5e$var$checkIsDigitsOnly(e) {
    if (e.which !== 8 && e.which !== 0 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
        const id = $(e.target).attr("id");
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }
    return true;
}
function $cb041d180d1b1b5e$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        $.get("/cap-van-manufacturer-url/" + $(this).val(), function(response) {
            $("#ManufacturerName").val(response);
        });
        window.updateVanCO2Results();
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-van-manufacturer-url/" + $("#ManufacturerId").val(), function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get("/cap-van-model-url/" + $("#ManufacturerId").val() + "/" + $(this).val(), function(response) {
                $("#ModelName").val(response);
                window.updateVanCO2Results();
            });
        } else {
            $("#ModelName").val("");
            window.updateVanCO2Results();
        }
    } else if (currentDropdown === "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get("/cap-van-type-url/" + $("#VehicleGroupId").val(), function(response) {
            $("#BodyType").val(response);
            window.updateVanCO2Results();
        });
        else {
            $("#BodyType").val("");
            window.updateVanCO2Results();
        }
    } else window.updateVanCO2Results();
}
function $cb041d180d1b1b5e$var$updateFuelTypes(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateVanCO2Results();
}
function $cb041d180d1b1b5e$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += "BodyType=" + data.BodyType;
    else queryString += "BodyType=";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.ManufacturerName;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.ModelName;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.Page;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;
    if (queryString.length > 0) queryString += "&";
    queryString += "MpgFrom=" + data.MpgFrom;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;
    return "?" + queryString;
}
function $cb041d180d1b1b5e$var$getData(page) {
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const bodyType = $("#BodyType").val();
    const co2To = $("#CO2To").val();
    const mpgFrom = $("#MpgFrom").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $cb041d180d1b1b5e$var$getActiveFuelTypes();
    return {
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        BodyType: bodyType,
        MpgFrom: mpgFrom,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        Page: page
    };
}
function $cb041d180d1b1b5e$var$updateResultsLogic(page) {
    const data = $cb041d180d1b1b5e$var$getData(page);
    $cb041d180d1b1b5e$var$History.pushState(data, $("title").html(), location.pathname + $cb041d180d1b1b5e$var$buildUpQueryString(data));
}
function $cb041d180d1b1b5e$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "p";
    })[0].split("=")[1];
}
function $cb041d180d1b1b5e$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $cb041d180d1b1b5e$var$getPage($(this).attr("href"));
    $cb041d180d1b1b5e$var$updateResultsLogic(page);
}
function $cb041d180d1b1b5e$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
function $cb041d180d1b1b5e$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("co2-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateVanCO2Results();
}
function $cb041d180d1b1b5e$var$markAsLoading() {
    $("#co2-calculator-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $cb041d180d1b1b5e$var$reloadQuery() {
    const State = $cb041d180d1b1b5e$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    let clonedData = {
        ...State.data
    };
    clonedData.P = clonedData.Page;
    $.get("/van-co2-calculator/query", clonedData, function(response) {
        $("#co2-calculator-query-container").replaceWith(response);
        $cb041d180d1b1b5e$var$handleBodyCopyToggle();
    });
}
function $cb041d180d1b1b5e$var$updateState() {
    $cb041d180d1b1b5e$var$markAsLoading();
    $cb041d180d1b1b5e$var$reloadQuery();
    const State = $cb041d180d1b1b5e$var$History.getState();
    let clonedData = {
        ...State.data
    };
    clonedData.P = clonedData.Page;
    $.get("/van-co2-calculator/results", clonedData, function(response) {
        $("#co2-calculator-results-container").replaceWith(response);
        $cb041d180d1b1b5e$var$loadAsDataTable();
        $cb041d180d1b1b5e$var$applyResultsSortArrows();
        if ($cb041d180d1b1b5e$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
            $cb041d180d1b1b5e$var$reset = false;
        }
    });
}
function $cb041d180d1b1b5e$export$b16f720339b8b3cd() {
    if (!$("[data-van-co2-calculator]").length) return;
    window.updateVanCO2Results = function() {
        $cb041d180d1b1b5e$var$updateResultsLogic(1);
    };
    const currentUrl = window.location.href;
    $cb041d180d1b1b5e$var$setManufacturer(currentUrl);
    $cb041d180d1b1b5e$var$setBodyType(currentUrl);
    $cb041d180d1b1b5e$var$setModel(currentUrl);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
    $("[data-no-results]").hide();
    $cb041d180d1b1b5e$var$loadAsDataTable();
    $(document).on("keypress", "[data-digits-only]", $cb041d180d1b1b5e$var$checkIsDigitsOnly);
    $(document).on("change", "[data-van-co2-calculator] input, [data-van-co2-calculator] select", $cb041d180d1b1b5e$var$onChangeFilters);
    $(document).on("keypress", "[data-van-co2-calculator] input", function(e) {
        if (e.keyCode === 13) {
            $cb041d180d1b1b5e$var$onChangeFilters();
            return false;
        }
    });
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        $(this).parents("tr").find("[data-view-detail]").trigger("click");
    });
    $(document).on("click", "[data-fuel-type] a", $cb041d180d1b1b5e$var$updateFuelTypes);
    $(document).on("click", "#co2-calculator-results-container .pagination a", $cb041d180d1b1b5e$var$pageData);
    $cb041d180d1b1b5e$var$applyResultsSortArrows();
    $(document).on("click", "[data-co2-sort]", $cb041d180d1b1b5e$var$sortResults);
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $cb041d180d1b1b5e$var$History.pushState({}, $("title").html(), location.pathname);
        $cb041d180d1b1b5e$var$reset = true;
    });
    $cb041d180d1b1b5e$var$History.Adapter.bind(window, "statechange", $cb041d180d1b1b5e$var$updateState);
} //(function ($) {
 //    function getForm() {
 //        return $("[data-van-co2-form]");
 //    }
 //    function sortResults(event) {
 //        event.preventDefault();
 //        var button = $(event.currentTarget);
 //        var data = button.data("co2-sort");
 //        var form = getForm();
 //        var currentSort = form.find("#SortBy").val();
 //        form.find("#SortBy").val(data);
 //        form.find("#SortDesc").val(data != currentSort ? "false" : "true");
 //        form.submit();
 //    }
 //    //ToDo: Refactor this
 //    function applySortArrows() {
 //        var form = getForm();
 //        var currentSort = form.find("#SortBy").val();
 //        var isDesc = form.find("#SortDesc").val();
 //        var cssClass;
 //        if (isDesc == "True") {
 //            cssClass = "sorting_desc";
 //        } else {
 //            cssClass = "sorting_asc";
 //        }
 //        var runningCostTable = $("#van-co2-table");
 //        var test = runningCostTable.find("[data-co2-sort='" + currentSort + "']");
 //        test.parent().addClass(cssClass);
 //    }
 //    function changeManufacturer() {
 //        var form = getForm();
 //        form.find("#ModelGroupId").val("");
 //        form.submit();
 //    }
 //    function changeModelGroup() {
 //        var form = getForm();
 //        form.submit();
 //    }
 //    var table = $('#van-co2-table').DataTable({
 //        responsive: true,
 //        "ordering": false,
 //        "bPageinate": false,
 //        "bFilter": false,
 //        "bInfo": false,
 //        "bAutoWidth": false,
 //        "bLengthChange": false,
 //        "bSearchable": false,
 //        "iDisplayLength": -1,
 //        "fnDrawCallback": function (oSettings) {
 //            $('.dataTables_paginate').hide();
 //        }
 //    });
 //    $(function () {
 //        $(document).on("click", "[data-co2-sort]", sortResults);
 //        $(document).on("change", "#ManufacturerId", changeManufacturer);
 //        $(document).on("change", "#ModelGroupId", changeModelGroup);
 //        applySortArrows();
 //    });
 //})(jQuery);


var $29b334ac16b2381b$var$History = window.History; // Note: We are using a capital H instead of a lower h
var $29b334ac16b2381b$var$compareListSortBy;
var $29b334ac16b2381b$var$compareListSortDesc;
function $29b334ac16b2381b$var$getData() {
    var sortBy = $29b334ac16b2381b$var$compareListSortBy;
    var sortDesc = $29b334ac16b2381b$var$compareListSortDesc;
    return {
        SortBy: sortBy,
        SortDesc: sortDesc
    };
}
function $29b334ac16b2381b$var$buildUpQueryString(data) {
    var queryString = "";
    if (queryString.length > 0) queryString += "&";
    queryString += `SortBy=${data.SortBy}`;
    if (queryString.length > 0) queryString += "&";
    queryString += `SortDesc=${data.SortDesc}`;
    return `?${queryString}`;
}
function $29b334ac16b2381b$var$sortResults(event) {
    event.preventDefault();
    var newSortBy = $(this).data("compare-list-sort");
    if ($29b334ac16b2381b$var$compareListSortBy !== newSortBy) $29b334ac16b2381b$var$compareListSortDesc = "false";
    else if ($29b334ac16b2381b$var$compareListSortDesc === "true") $29b334ac16b2381b$var$compareListSortDesc = "false";
    else $29b334ac16b2381b$var$compareListSortDesc = "true";
    $29b334ac16b2381b$var$compareListSortBy = newSortBy;
    var data = $29b334ac16b2381b$var$getData();
    $29b334ac16b2381b$var$History.pushState(data, $("title").html(), location.pathname + $29b334ac16b2381b$var$buildUpQueryString(data));
}
function $29b334ac16b2381b$var$updateState() {
    var State = $29b334ac16b2381b$var$History.getState();
    $.get(`/van-compare-list/results/${$("#RunningCostIds").val()}`, State.data, function(response) {
        $("#compare-list-results-container").replaceWith(response);
        $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
        if ($29b334ac16b2381b$var$compareListSortDesc.toLowerCase() === "true") $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    });
}
function $29b334ac16b2381b$export$953e2b044b74bd66() {
    if (!$("[data-van-compare-list]").length) return;
    $29b334ac16b2381b$var$compareListSortBy = $("#SortBy").val();
    $29b334ac16b2381b$var$compareListSortDesc = $("#SortDesc").val();
    $(document).on("click", "[data-compare-list-sort]", $29b334ac16b2381b$var$sortResults);
    $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/asc.png') no-repeat right center;");
    if ($29b334ac16b2381b$var$compareListSortDesc.toLowerCase() === "true") $(`[data-compare-list-sort=${$29b334ac16b2381b$var$compareListSortBy}]`).attr("style", "background: url('/Content/Images/desc.png') no-repeat right center;");
    $(document).on("click", "[data-remove-from-list]", function(event) {
        var id = $(this).attr("data-remove-from-list");
        $.get(`/van-compare-list/handle/remove/${id}`, function(response) {});
    });
// Bind to StateChange Event
//History.Adapter.bind(window, 'statechange', updateState);
}


function $b0c1205ab438e8b5$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $b0c1205ab438e8b5$var$markAsLoading() {
    let container = $("#van-reviews-search-loading-container");
    container.height(50); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $b0c1205ab438e8b5$export$abf0c736cc0404e4() {
    $(document).on("change", "form[data-van-review-search] select", function(e) {
        $b0c1205ab438e8b5$var$markAsLoading();
        $b0c1205ab438e8b5$var$submitForm(e);
        if ($("#ManufacturerSlugSelected").val() == "search") $("#ManufacturerSlug").val("");
    });
}


function $a45552c76e7ee752$var$changeManufacturer() {
    var manufacturerName = $("#ManufacturerId").val();
    $.get("/vans/section/query?ManufacturerName=" + manufacturerName, function(response) {
        $("[data-van-section-search]").replaceWith(response);
    });
}
function $a45552c76e7ee752$var$changeModel() {
    var modelName = $("#ModelId").val();
    $("#ModelName").val(modelName);
}
function $a45552c76e7ee752$export$b4ebbdbd9d8b89a1() {
    if ($("[data-van-reviews-section]").length) {
        $(document).on("change", "#ManufacturerId", $a45552c76e7ee752$var$changeManufacturer);
        $(document).on("change", "#ModelId", $a45552c76e7ee752$var$changeModel);
        $("#ManufacturerId").trigger("change");
    }
}


function $de5410f3f786fb03$var$submitForm(event) {
    event.preventDefault();
    $(event.target).parents("form").submit();
}
function $de5410f3f786fb03$export$ea92669c2bcde238() {
    $(document).on("change", "form[data-manufacturer-dropdown] select", $de5410f3f786fb03$var$submitForm);
}


let $631d9a7494b6c619$var$reset = false;
const $631d9a7494b6c619$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $631d9a7494b6c619$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $631d9a7494b6c619$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $631d9a7494b6c619$var$reloadQuery() {
    const State = $631d9a7494b6c619$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/new-van-running-cost/query", State.data, function(response) {
        $("#new-van-running-cost-query-container").replaceWith(response);
        $631d9a7494b6c619$var$handleBodyCopyToggle();
    });
    $.get("/new-van-running-cost/bottom-seo", State.data, function(response) {
        $("#new-van-running-cost-seo-container").replaceWith(response);
        $631d9a7494b6c619$var$handleBodyCopyToggle();
    });
}
function $631d9a7494b6c619$var$markAsLoading() {
    let container = $("#new-van-running-cost-results-container");
    container.height(container.height()); // set the height to stop moving on large desktop
    container.text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $631d9a7494b6c619$var$setOperatingCycle() {
    $.get("/cap-van-operating-cycles/miles/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Miles").val(response);
    });
    $.get("/cap-van-operating-cycles/years/" + $("#DefaultOperatingCycleId").val(), function(response) {
        $("#Years").val(response);
    });
}
function $631d9a7494b6c619$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown == "OperatingCycleId") {
        const id = $(this).val();
        $.get("/cap-van-operating-cycles/miles/" + id, function(response) {
            $("#Miles").val(response);
            $.get("/cap-van-operating-cycles/years/" + id, function(response) {
                $("#Years").val(response);
                window.updateVanRunningCosts();
            });
        });
    } else if (currentDropdown == "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#Model").val("");
        if (parseInt($(this).val()) > 0) $.get("/cap-van-manufacturer-url/" + $(this).val(), function(response) {
            $("#Manufacturer").val(response);
            window.updateVanRunningCosts();
        });
        else {
            $("#Manufacturer").val("");
            window.updateVanRunningCosts();
        }
    } else if (currentDropdown == "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-van-manufacturer-url/" + $("#ManufacturerId").val(), function(response) {
                $("#Manufacturer").val(response);
                window.updateVanRunningCosts();
            });
            $.get("/cap-van-model-url/" + $("#ManufacturerId").val() + "/" + $(this).val(), function(response) {
                $("#Model").val(response);
                window.updateVanRunningCosts();
            });
        } else {
            $("#Model").val("");
            window.updateVanRunningCosts();
        }
    } else if (currentDropdown == "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get("/cap-van-type-url/" + $("#VehicleGroupId").val(), function(response) {
            $("#VanType").val(response);
            window.updateVanRunningCosts();
        });
        else {
            $("#VanType").val("");
            window.updateVanRunningCosts();
        }
    } else window.updateVanRunningCosts();
}
//sorting the results
function $631d9a7494b6c619$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("new-running-cost-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() == "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateVanRunningCosts();
}
function $631d9a7494b6c619$var$showHideDetail() {
    const $this = $(this);
    let id = $this.attr("href");
    let collapsibleElement = document.querySelector(id);
    if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
    if (collapsibleElement) {
        if (!collapsibleElement.dataset.eventInitiated) collapsibleElement.addEventListener("shown.bs.collapse", function(e) {
            this.dataset.eventInitiated = true;
            let spacer = $(collapsibleElement).closest("tr").next("tr.spacer");
            if (spacer) spacer.find("td").attr("height", $(this).height());
        });
    }
    const currentText = $.trim($this.text());
    const row = $this.parents("tr");
    let currentSpacer = $this.closest("table").find('.spacer[data-id="' + id + '"]');
    const rowHeight = row.height();
    if (currentText == "View data") {
        $this.text("Hide data");
        if (currentSpacer.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo("xl")) row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            else if (window.getViewportSize() == "lg") {
                if (rowHeight > 40) row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="145"></td></tr>');
                else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="175"></td></tr>');
            } else if (window.getViewportSize() == "md") row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="190"></td></tr>');
            else row.after('<tr class="spacer" data-id="' + id + '"><td colspan="6" height="400"></td></tr>');
        }
    } else {
        $this.text("View data");
        currentSpacer.remove();
    }
    $631d9a7494b6c619$var$resetSpacersSize();
}
//sorting arrow
function $631d9a7494b6c619$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $("[data-new-running-cost-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() == "true") $("[data-new-running-cost-sort=" + sortBy + "]").attr("style", "background: url('/Themes/FleetNews/Content/Images/top-desc.png') no-repeat right center;");
}
function $631d9a7494b6c619$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-manufacturer-url/" + manId, function(response) {
                $("#Manufacturer").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Manufacturer";
            })[0].split("=")[1];
            $("#Manufacturer").val(manufacturer);
        }
    }
}
function $631d9a7494b6c619$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-van-model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#Model").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Model";
            })[0].split("=")[1];
            $("#Model").val(model);
        }
    }
}
function $631d9a7494b6c619$var$setVanType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VehicleGroupId";
            })[0].split("=")[1];
            $.get("/cap-van-type-url/" + vehicleGroupId, function(response) {
                $("#VanType").val(response);
            });
        } else if (href.indexOf("VanType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VanType";
            })[0].split("=")[1];
            $("#VanType").val(carType);
        }
    }
}
function $631d9a7494b6c619$var$checkIsDigitsOnly(e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which != 8 && e.which != 0 && e.which != 13 && e.which != 46 && (e.which < 48 || e.which > 57)) {
        //display error message
        const id = $(e.target).attr("id");
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }
    return true;
}
function $631d9a7494b6c619$var$loadAsDataTable() {
    const table = $("#new-running-costs").DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
    //Check spacer when datatable responsive display collapsed (hide)
    table.on("responsive-display.dt", function(e, datatable, row, showHide, update) {
        $631d9a7494b6c619$var$resetSpacersSize();
    });
}
function $631d9a7494b6c619$var$addVehicle(id, callback) {
    $.get("/van-compare-list/handle/add/" + id, function(response) {
        let success;
        if (response == 0) success = true;
        else if (response == 1) {
            alert("Maximum of 5 vehicles.");
            success = false;
        } else if (response == 2) success = true;
        else {
            alert("Error");
            success = false;
        }
        if (callback) callback(success);
    });
}
function $631d9a7494b6c619$var$removeVehicle(id, callback) {
    $.get("/van-compare-list/handle/remove/" + id, function(response) {
        const success = response == 0;
        if (callback) callback(success);
    });
}
function $631d9a7494b6c619$var$markAsToAdd(btn) {
    btn.removeClass().addClass("btn btn-green btn-block w-100").text("Add to compare");
}
function $631d9a7494b6c619$var$markAsToRemove(btn) {
    btn.html(btn.data("original-text"));
    btn.addClass("added");
    btn.text("Comparing");
}
function $631d9a7494b6c619$var$updateCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("new-compare-list-add-id");
    const btn = $(event.target);
    if (!btn.data("original-text")) btn.data("original-text", btn.html());
    const btnClass = $(this).attr("class");
    btn.html("<img src='/Themes/FleetNews/Content/Images/loading.png'/>");
    if (btnClass.indexOf("added") > 1) $631d9a7494b6c619$var$removeVehicle(data, function(success) {
        if (success) {
            $631d9a7494b6c619$var$markAsToAdd(btn);
            $631d9a7494b6c619$var$reloadQuery();
        } else $631d9a7494b6c619$var$markAsToRemove(btn);
        $631d9a7494b6c619$var$reloadQuery();
    });
    else $631d9a7494b6c619$var$addVehicle(data, function(success) {
        if (success) {
            $631d9a7494b6c619$var$markAsToRemove(btn);
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
            $631d9a7494b6c619$var$reloadQuery();
        } else $631d9a7494b6c619$var$markAsToAdd(btn);
    });
}
function $631d9a7494b6c619$var$updateFuelTypes(event) {
    //markAsLoading();
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateVanRunningCosts();
}
$(function() {});
function $631d9a7494b6c619$var$buildUpQueryString(data) {
    let queryString = "";
    //var operatingCycleDefault = $('#OperatingCycleId option').eq(0).val();
    //if (data.OperatingCycleId != operatingCycleDefault) {
    //    if (queryString.length > 0) queryString += "&";
    //    queryString += "Years=" + data.Years + "&Miles=" + data.Miles;
    //}
    if (queryString.length > 0) queryString += "&";
    queryString += "Years=" + data.Years + "&Miles=" + data.Miles;
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += "VanType=" + data.VanType;
    else queryString += "VanType=";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.Manufacturer;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.Model;
    if (data.P > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.P;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += "MinPayload=" + data.MinPayload;
    if (queryString.length > 0) queryString += "&";
    queryString += "MinLoadWidth=" + data.MinLoadWidth;
    if (queryString.length > 0) queryString += "&";
    queryString += "MinLoadLength=" + data.MinLoadLength;
    if (queryString.length > 0) queryString += "&";
    queryString += "MinTow=" + data.MinTow;
    if (queryString.length > 0) queryString += "&";
    queryString += "BIKPriceFrom=" + data.BIKPriceFrom;
    if (queryString.length > 0) queryString += "&";
    queryString += "BIKPriceTo=" + data.BIKPriceTo;
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2From=" + data.CO2From;
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;
    return "?" + queryString;
}
function $631d9a7494b6c619$var$getData(page) {
    const operatingCycleId = $("#OperatingCycleId").val();
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const miles = $("#Miles").val();
    const years = $("#Years").val();
    const manufacturer = $("#Manufacturer").val();
    const model = $("#Model").val();
    const vanType = $("#VanType").val();
    const co2From = $("#CO2From").val();
    const co2To = $("#CO2To").val();
    const minPayload = $("#MinPayload").val();
    const minLoadWidth = $("#MinLoadWidth").val();
    const minLoadLength = $("#MinLoadLength").val();
    const minTow = $("#MinTow").val();
    const bikPriceFrom = $("#BIKPriceFrom").val();
    const bikPriceTo = $("#BIKPriceTo").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $631d9a7494b6c619$var$getActiveFuelTypes();
    return {
        OperatingCycleId: operatingCycleId,
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Miles: miles,
        Years: years,
        Manufacturer: manufacturer,
        Model: model,
        VanType: vanType,
        MinPayload: minPayload,
        MinLoadWidth: minLoadWidth,
        MinLoadLength: minLoadLength,
        MinTow: minTow,
        BIKPriceFrom: bikPriceFrom,
        BIKPriceTo: bikPriceTo,
        CO2From: co2From,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}
function $631d9a7494b6c619$var$updateResultsLogic(page) {
    const data = $631d9a7494b6c619$var$getData(page);
    $631d9a7494b6c619$var$History.pushState(data, $("title").html(), location.pathname + $631d9a7494b6c619$var$buildUpQueryString(data));
}
function $631d9a7494b6c619$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $631d9a7494b6c619$var$getPage($(this).attr("href"));
    $631d9a7494b6c619$var$updateResultsLogic(page);
}
function $631d9a7494b6c619$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "p";
    })[0].split("=")[1];
}
function $631d9a7494b6c619$var$updateState() {
    $631d9a7494b6c619$var$markAsLoading();
    $631d9a7494b6c619$var$reloadQuery();
    const State = $631d9a7494b6c619$var$History.getState();
    $.get("/new-van-running-cost/results", State.data, function(response) {
        $("#new-van-running-cost-results-container").replaceWith(response);
        $("#new-van-running-cost-results-container input[name^='comparelist']").each(function() {
            const compareListId = $(this).val();
            $("[data-new-compare-list-add-id=" + compareListId + "]").addClass("added").text("Comparing");
        });
        $631d9a7494b6c619$var$loadAsDataTable();
        $631d9a7494b6c619$var$applyResultsSortArrows();
        if ($631d9a7494b6c619$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
            $631d9a7494b6c619$var$reset = false;
        }
    }).done(function() {
        setTimeout(function() {
            const resultsContainer = document.getElementById("new-van-running-cost-results-container");
            console.log(resultsContainer.getAttribute("data-results-loaded"));
            // ad slots
            window.ayManagerEnv = window.ayManagerEnv || {
                cmd: []
            };
            if (typeof Handlebars === "undefined") console.error("Handlebars not loaded.");
            if (!Handlebars.helpers.json) Handlebars.registerHelper("json", function(context) {
                return JSON.stringify(context);
            });
            const adSlotTemplate = Handlebars.compile(document.getElementById("ad-slot-template").innerHTML);
            const adSlots = {};
            const adSections = document.querySelectorAll("[data-ad-id]");
            if (adSections.length === 0) console.warn("No ad section found.");
            adSections.forEach(function(section) {
                const adDataInputs = section.querySelectorAll("[data-ad-data]");
                adDataInputs.forEach(function(adSlot) {
                    let adSlotData = adSlot.getAttribute("data-ad-data");
                    try {
                        adSlotData = JSON.parse(adSlotData);
                    } catch (e) {
                        console.warn("Invalid JSON in data-ad-data:", adSlotData);
                    }
                    if (!adSlotData || !adSlotData.slotId) console.warn("Invalid ad slot data:", adSlotData);
                    const adSlotHtml = adSlotTemplate(adSlotData);
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = adSlotHtml;
                    const newSlotElem = tempDiv.firstElementChild;
                    adSlot.parentNode.replaceChild(newSlotElem, adSlot);
                    adSlots[adSlotData.slotId] = {
                        slotId: adSlotData.slotId,
                        sizeMapping: adSlotData.sizeMapping,
                        isEager: adSlotData.isEager || false,
                        outOfPage: adSlotData.outOfPage || false,
                        container: document.getElementById(adSlotData.slotId + "-container"),
                        element: document.getElementById(adSlotData.slotId)
                    };
                });
                setupAdMovement(adSlots, section);
            });
            function shouldAdd(adSlot) {
                return !!adSlot.container.closest("[data-ads-hidden-column]");
            }
            function getIndex(adSlot) {
                const hiddenColumn = adSlot.container.closest("[data-ads-hidden-column]");
                if (!hiddenColumn) return -1;
                const holders = Array.from(hiddenColumn.querySelectorAll("[data-ad-slot-name]")).map((e)=>e.parentNode);
                const holder = adSlot.container.parentNode;
                return holders.indexOf(holder);
            }
            function setupAdMovement(adSlots, adSection) {
                const slotsToAdd = [];
                for(let name in adSlots)if (adSlots.hasOwnProperty(name)) {
                    const slot = adSlots[name];
                    if (shouldAdd(slot)) slotsToAdd.push(slot);
                }
                if (slotsToAdd.length === 0) return;
                slotsToAdd.sort((a, b)=>getIndex(a) - getIndex(b));
                for (let adSlot of slotsToAdd){
                    const slotName = adSlot.slotId;
                    const desktopSlot = adSlot.container;
                    let mobileReplacementSlot = adSection.querySelector(`[data-ad-mobile-replace="${slotName}"]`);
                    if (!mobileReplacementSlot) {
                        mobileReplacementSlot = document.createElement("div");
                        mobileReplacementSlot.setAttribute("data-ad-mobile-replace", slotName);
                        mobileReplacementSlot.className = "col-md-6 mb-3 text-center";
                        adSection.appendChild(mobileReplacementSlot);
                    }
                    const responsiveMovable = desktopSlot.getAttribute("data-responsive-movable");
                    mobileReplacementSlot.setAttribute("data-responsive-movable-xs", responsiveMovable);
                    mobileReplacementSlot.setAttribute("data-responsive-movable-sm", responsiveMovable);
                }
            }
            if (window.registerMovableElements && window.moveElementsToCurrentViewport) {
                window.registerMovableElements(window.jQuery || $);
                window.moveElementsToCurrentViewport(true);
            }
            window.ayManagerEnv.cmd.push(function() {
                ayManagerEnv.changePage();
            });
        }, 250);
    });
    function hideIfNoAd() {
    //the below works but then the even/odd table needs adjusting and more work that worth.
    /* setTimeout(function(){
             let $vanrunningcost = $("#vanrunningcost-ad-slot-1");   
             const len = $$vanrunningcost.html().length;
             if (len === 0){
                 $vanrunningcost.parent().parent().parent().hide();
             } else {
                 $vanrunningcost.parent().parent().parent().show();
             }
         }, 1000);   */ }
}
function $631d9a7494b6c619$var$setupMpus() {
    if (window.location.pathname === "/tools/van/running-costs/" && window.location.search !== "") {
        if ($("#mpus").length) $("#mpus").remove();
    }
}
function $631d9a7494b6c619$var$resetSpacersSize() {
    $(".spacer[data-id]").each(function() {
        let spacer = $(this);
        let id = spacer.data("id");
        let collapsibleElement = document.querySelector(id);
        if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
        if (collapsibleElement) {
            if (collapsibleElement.offsetParent !== null && $(collapsibleElement).height() > 0) spacer.find("td").attr("height", $(collapsibleElement).height());
            else spacer.remove();
        } else spacer.remove();
    });
}
function $631d9a7494b6c619$export$9ef30b34c240b3e6() {
    if (!$("[data-new-van-running-costs]").length) return;
    $631d9a7494b6c619$var$setupMpus();
    $631d9a7494b6c619$var$setOperatingCycle();
    $631d9a7494b6c619$var$setManufacturer(window.location.href);
    $631d9a7494b6c619$var$setVanType(window.location.href);
    $631d9a7494b6c619$var$setModel(window.location.href);
    $631d9a7494b6c619$var$loadAsDataTable();
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a van type or make above to start your search</div>");
    $("[data-no-results]").hide();
    //dropdown changes
    $(document).on("change", "[data-new-van-running-costs] input, [data-new-van-running-costs] select", $631d9a7494b6c619$var$onChangeFilters);
    $(document).on("keypress", "[data-new-van-running-costs] input", function(e) {
        if (e.keyCode == 13) {
            $631d9a7494b6c619$var$onChangeFilters();
            return false;
        }
    });
    //paging click
    $(document).on("click", "#new-van-running-cost-results-container .pagination a", $631d9a7494b6c619$var$pageData);
    //fuel type button chagnes
    $(document).on("click", "[data-fuel-type] a", $631d9a7494b6c619$var$updateFuelTypes);
    //sort
    $(document).on("click", "[data-new-running-cost-sort]", $631d9a7494b6c619$var$sortResults);
    window.addEventListener("resize", function() {
        $631d9a7494b6c619$var$resetSpacersSize();
    });
    //viewdata
    $(document).on("click", "[data-view-detail]", $631d9a7494b6c619$var$showHideDetail);
    //digit only
    $(document).on("keypress", "[data-digits-only]", $631d9a7494b6c619$var$checkIsDigitsOnly);
    //arrow
    $631d9a7494b6c619$var$applyResultsSortArrows();
    //reset
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $631d9a7494b6c619$var$History.pushState({}, $("title").html(), location.pathname);
        $631d9a7494b6c619$var$reset = true;
    });
    //add to compare list button click
    $(document).on("click", "[data-new-compare-list-add-id]", $631d9a7494b6c619$var$updateCompareList);
    //derivative link
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        let viewDetailsButton = $(this).parents("tr").find("[data-view-detail]");
        if (viewDetailsButton.length) {
            if (window.isViewportLessThan("md")) $(this).closest("tr").find(".dtr-control").trigger("click");
            else {
                let id = viewDetailsButton.attr("href");
                let collapsibleElement = document.querySelector(id);
                if (window.isViewportLessThan("md")) collapsibleElement = document.querySelector(`tr.child ${id}`);
                if (collapsibleElement) {
                    viewDetailsButton.toggleClass("collapsed");
                    viewDetailsButton.data("aria-expanded", !viewDetailsButton.data("aria-expanded"));
                    $(collapsibleElement).toggleClass("show");
                    $(this).closest("tr").find("[data-view-detail]").trigger("click");
                }
            }
        }
        $631d9a7494b6c619$var$resetSpacersSize();
    });
    // Bind to StateChange Event
    $631d9a7494b6c619$var$History.Adapter.bind(window, "statechange", $631d9a7494b6c619$var$updateState);
    window.updateVanRunningCosts = function() {
        $631d9a7494b6c619$var$updateResultsLogic(1);
        $631d9a7494b6c619$var$setupMpus();
    };
}


const $a44a9adb885e4949$var$history = window.History;
function $a44a9adb885e4949$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $a44a9adb885e4949$var$getData() {
    const dataArray = $("[data-what-is-my-car-mpg-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $a44a9adb885e4949$var$updateResultsLogic(isPageChange) {
    const data = $a44a9adb885e4949$var$getData();
    if (isPageChange) data.isPageChange = true;
    $a44a9adb885e4949$var$history.pushState(data, $("title").html(), location.pathname + "?" + $a44a9adb885e4949$var$buildUpQueryString(data));
    return data;
}
function $a44a9adb885e4949$var$triggerUpdateResults(event) {
    if ($(event.target).data("autocomplete") != null) return;
    if (event.target.name === "ManufacturerId") {
        if ($("#ModelGroupId").val() != null) {
            $("#ModelGroupId").val("");
            $("#DerivativeId").val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if ($("#DerivativeId").val() != null) $("#DerivativeId").val("");
    }
    window.updateResults();
}
function $a44a9adb885e4949$var$reloadQuery() {
    const state = $a44a9adb885e4949$var$history.getState();
    $.get("/costs/what-is-my-car-mpg/query", state.data, function(response) {
        $("[data-what-is-my-car-mpg-query-attributes]").replaceWith(response);
    });
}
function $a44a9adb885e4949$var$updateState() {
    $a44a9adb885e4949$var$reloadQuery();
    const state = $a44a9adb885e4949$var$history.getState();
    $.get("/costs/what-is-my-car-mpg/results", state.data, function(response) {
        $("[data-what-is-my-car-mpg-results-container]").replaceWith(response);
    });
}
function $a44a9adb885e4949$var$scrollToResult(e) {
    e.preventDefault();
    $("html, body").animate({
        scrollTop: $(window).scrollTop() + 200
    }, 2000);
}
function $a44a9adb885e4949$export$5a34e6870ef2f82e() {
    if (!$("[data-what-is-my-car-mpg]").length) return;
    $(document).on("change", "[data-what-is-my-car-mpg-query-attributes] input, [data-what-is-my-car-mpg-query-attributes] select", $a44a9adb885e4949$var$triggerUpdateResults);
    $(document).on("click", "[data-view-result-button]", $a44a9adb885e4949$var$scrollToResult);
    //Bind to StateChange Event
    $a44a9adb885e4949$var$history.Adapter.bind(window, "statechange", $a44a9adb885e4949$var$updateState);
    window.updateResults = function() {
        $a44a9adb885e4949$var$updateResultsLogic();
    };
}


let $41f3be02cf03cd10$var$reset = false;
const $41f3be02cf03cd10$var$History = window.History; // Note: We are using a capital H instead of a lower h
function $41f3be02cf03cd10$var$getActiveFuelTypes() {
    const greenButtons = $("[data-fuel-type] a.btn-green");
    const values = $.map(greenButtons, function(element, index) {
        return $(element).attr("value");
    });
    return values.join(",");
}
function $41f3be02cf03cd10$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== "undefined") {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;
        console.log("TextDiv Height:", textDivHeight); // Debugging: Check the height
        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 19.2) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });
            console.log("Toggle Button Added"); // Debugging: Confirm button is added
        }
    } else console.log("TextDiv not found"); // Debugging: Check if textDiv is found
}
function $41f3be02cf03cd10$var$setManufacturer(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ManufacturerId") > 1) {
            const manId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-manufacturer-url/" + manId, function(response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf("Manufacturer") > 1) {
            const manufacturer = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Manufacturer";
            })[0].split("=")[1];
            $("#ManufacturerName").val(manufacturer);
        }
    }
}
function $41f3be02cf03cd10$var$setCarType(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("VehicleGroupId") > 1) {
            const vehicleGroupId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "VehicleGroupId";
            })[0].split("=")[1];
            $.get("/cap-car-type-url/" + vehicleGroupId, function(response) {
                $("#CarType").val(response);
            });
        } else if (href.indexOf("CarType") > 1) {
            const carType = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "CarType";
            })[0].split("=")[1];
            $("#CarType").val(carType);
        }
    }
}
function $41f3be02cf03cd10$var$setModel(href) {
    if (href.indexOf("?") > 1) {
        const querystring = href.split("?")[1];
        const parts = querystring.split("&");
        if (href.indexOf("ModelGroupId") > 1) {
            const modelId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ModelGroupId";
            })[0].split("=")[1];
            const manufacturerId = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "ManufacturerId";
            })[0].split("=")[1];
            $.get("/cap-model-url/" + manufacturerId + "/" + modelId, function(response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf("Model") > 1) {
            const model = $.grep(parts, function(el, index) {
                return el.split("=")[0] == "Model";
            })[0].split("=")[1];
            $("#ModelName").val(model);
        }
    }
}
//load the datatable for low res
function $41f3be02cf03cd10$var$loadAsDataTable() {
    const table = $("#car-co2-table").DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function(oSettings) {
            $(".dataTables_paginate").hide();
        }
    });
}
function $41f3be02cf03cd10$var$checkIsDigitsOnly(e) {
    if (e.which !== 8 && e.which !== 0 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
        const id = $(e.target).attr("id");
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }
    return true;
}
function $41f3be02cf03cd10$var$onChangeFilters(event) {
    const currentDropdown = $(this).attr("name");
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val("");
        $("#ModelName").val("");
        $.get("/cap-manufacturer-url/" + $(this).val(), function(response) {
            $("#ManufacturerName").val(response);
            window.updateCarCO2Results();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-manufacturer-url/" + $("#ManufacturerId").val(), function(response) {
                $("#ManufacturerName").val(response);
            });
            $.get("/cap-model-url/" + $("#ManufacturerId").val() + "/" + $(this).val(), function(response) {
                $("#ModelName").val(response);
                window.updateCarCO2Results();
            });
        } else {
            $("#ModelName").val("");
            window.updateCarCO2Results();
        }
    } else if (currentDropdown === "VehicleGroupId") {
        $("#ModelGroupId").val("");
        if (parseInt($("#VehicleGroupId").val()) > 0) $.get("/cap-car-type-url/" + $("#VehicleGroupId").val(), function(response) {
            $("#CarType").val(response);
            window.updateCarCO2Results();
        });
        else {
            $("#CarType").val("");
            window.updateCarCO2Results();
        }
    } else window.updateCarCO2Results();
}
function $41f3be02cf03cd10$var$updateFuelTypes(event) {
    $(event.target).toggleClass("btn-green").toggleClass("btn-primary");
    event.preventDefault();
    window.updateCarCO2Results();
}
function $41f3be02cf03cd10$var$buildUpQueryString(data) {
    let queryString = "";
    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) queryString += "CarType=" + data.CarType;
    else queryString += "CarType=";
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.Manufacturer;
    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.Model;
    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.Page;
    }
    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;
    if (queryString.length > 0) queryString += "&";
    queryString += "MpgFrom=" + data.MpgFrom;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;
    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;
    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;
    return "?" + queryString;
}
function $41f3be02cf03cd10$var$getData(page) {
    const vehicleGroupId = $("#VehicleGroupId").val();
    const manufacturerId = $("#ManufacturerId").val();
    const modelGroupId = $("#ModelGroupId").val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const carType = $("#CarType").val();
    const co2To = $("#CO2To").val();
    const mpgFrom = $("#MpgFrom").val();
    const sortBy = $("#SortBy").val();
    const sortDesc = $("#SortDesc").val();
    const fuelType = $41f3be02cf03cd10$var$getActiveFuelTypes();
    return {
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Manufacturer: manufacturerName,
        Model: modelName,
        CarType: carType,
        MpgFrom: mpgFrom,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}
function $41f3be02cf03cd10$var$updateResultsLogic(page) {
    const data = $41f3be02cf03cd10$var$getData(page);
    $41f3be02cf03cd10$var$History.pushState(data, $("title").html(), location.pathname + $41f3be02cf03cd10$var$buildUpQueryString(data));
}
function $41f3be02cf03cd10$var$getPage(href) {
    const querystring = href.split("?")[1];
    const parts = querystring.split("&");
    return $.grep(parts, function(el, index) {
        return el.split("=")[0] == "p";
    })[0].split("=")[1];
}
function $41f3be02cf03cd10$var$pageData(event) {
    event.preventDefault();
    if ($(this).attr("href") === undefined) return;
    const page = $41f3be02cf03cd10$var$getPage($(this).attr("href"));
    $41f3be02cf03cd10$var$updateResultsLogic(page);
}
function $41f3be02cf03cd10$var$applyResultsSortArrows() {
    const sortBy = $("#SortBy").val();
    $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $("#SortDesc").val();
    if (sortDesc.toLowerCase() === "true") $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Content/Images/top-desc.png') no-repeat right center;");
}
function $41f3be02cf03cd10$var$sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data("co2-sort");
    const sortByEl = $("#SortBy");
    const sortDescEl = $("#SortDesc");
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() === "true") sortDescEl.val("false");
    else sortDescEl.val("true");
    window.updateCarCO2Results();
}
function $41f3be02cf03cd10$var$showHideDetail() {
    const $this = $(this);
    const currentText = $.trim($this.text());
    const row = $this.parents("tr");
    let alreadyExist = row.next("tr.spacer");
    if (window.isViewportLessThan("md")) alreadyExist = row.parent().parent().next("tr.spacer");
    const rowHeight = row.height();
    if (currentText == "View data") {
        $this.text("Hide data");
        if (alreadyExist.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo("xl")) row.after('<tr class="spacer"><td colspan="6" height="140"></td></tr>');
            else if (window.getViewportSize() == "lg") {
                if (rowHeight > 40) row.after('<tr class="spacer"><td colspan="6" height="110"></td></tr>');
                else row.after('<tr class="spacer"><td colspan="6" height="140"></td></tr>');
            } else if (window.getViewportSize() == "md") row.after('<tr class="spacer"><td colspan="6" height="155"></td></tr>');
            else row.after('<tr class="spacer"><td colspan="6" height="220"></td></tr>');
        }
    } else {
        $this.text("View data");
        if (alreadyExist.length > 0) row.next("tr.spacer").remove();
        if (window.isViewportLessThan("md")) $("#car-co2-table_wrapper tr.spacer").remove();
    }
}
function $41f3be02cf03cd10$var$markAsLoading() {
    $("#co2-calculator-results-container").text("").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}
function $41f3be02cf03cd10$var$reloadQuery() {
    const State = $41f3be02cf03cd10$var$History.getState();
    $.ajaxSetup({
        cache: false
    });
    $.get("/car-co2-calculator/query", State.data, function(response) {
        $("#co2-calculator-query-container").replaceWith(response);
        $41f3be02cf03cd10$var$handleBodyCopyToggle();
    });
}
function $41f3be02cf03cd10$var$updateState() {
    $41f3be02cf03cd10$var$markAsLoading();
    $41f3be02cf03cd10$var$reloadQuery();
    const State = $41f3be02cf03cd10$var$History.getState();
    $.get("/car-co2-calculator/results", State.data, function(response) {
        $("#co2-calculator-results-container").replaceWith(response);
        $("html, body").animate({
            scrollTop: $("#co2-calculator-results-container").offset().top - 90
        }, 100);
        $41f3be02cf03cd10$var$loadAsDataTable();
        $41f3be02cf03cd10$var$applyResultsSortArrows();
        if ($41f3be02cf03cd10$var$reset) {
            $("[data-no-results]").hide();
            $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
            $41f3be02cf03cd10$var$reset = false;
        }
    });
}
function $41f3be02cf03cd10$export$d1979b506d91f67d() {
    const page = $("[data-co2-calculator]").length;
    if (!page) return;
    const currentUrl = window.location.href;
    $41f3be02cf03cd10$var$setManufacturer(currentUrl);
    $41f3be02cf03cd10$var$setCarType(currentUrl);
    $41f3be02cf03cd10$var$setModel(currentUrl);
    $("#initial-result").html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
    $("[data-no-results]").hide();
    $41f3be02cf03cd10$var$loadAsDataTable();
    $(document).on("click", "[data-view-detail]", $41f3be02cf03cd10$var$showHideDetail);
    $(document).on("keypress", "[data-digits-only]", $41f3be02cf03cd10$var$checkIsDigitsOnly);
    $(document).on("change", "[data-co2-calculator] input, [data-co2-calculator] select", $41f3be02cf03cd10$var$onChangeFilters);
    $(document).on("keypress", "[data-co2-calculator] input", function(e) {
        if (e.keyCode === 13) {
            $41f3be02cf03cd10$var$onChangeFilters();
            return false;
        }
    });
    $(document).on("click", "[data-derivative]", function(e) {
        e.preventDefault();
        $(this).parents("tr").find("[data-view-detail]").trigger("click");
    });
    $(document).on("click", "[data-fuel-type] a", $41f3be02cf03cd10$var$updateFuelTypes);
    $(document).on("click", "#co2-calculator-results-container .pagination a", $41f3be02cf03cd10$var$pageData);
    $41f3be02cf03cd10$var$applyResultsSortArrows();
    $(document).on("click", "[data-co2-sort]", $41f3be02cf03cd10$var$sortResults);
    $(document).on("click", "[data-reset-button]", function(event) {
        event.preventDefault();
        $41f3be02cf03cd10$var$History.pushState({}, $("title").html(), location.pathname);
        $41f3be02cf03cd10$var$reset = true;
    });
    window.updateCarCO2Results = function() {
        $41f3be02cf03cd10$var$updateResultsLogic(1);
    };
    $41f3be02cf03cd10$var$History.Adapter.bind(window, "statechange", $41f3be02cf03cd10$var$updateState);
}


function $c80792d02f0f6a54$export$f80078829203ea32() {
    var startState = $("[name='Input.IsFleetDecisionMaker']:checked").val();
    if (startState == "true") $("[data-fleet-options]").show();
    else $("[data-fleet-options]").hide();
    $(function() {
        $("[name='Input.IsFleetDecisionMaker']").click(function() {
            if ($(this).is(":checked")) $("[data-fleet-options]").show();
            else $("[data-fleet-options]").hide();
        });
    });
}


function $6d5c05cfba139cb5$var$changeManufacturer() {
    var manufacturerName = $("#ManufacturerId").val();
    $.get("/vans/landing-page/query?ManufacturerName=" + manufacturerName, function(response) {
        $("[data-van-landing-page-query]").replaceWith(response);
    });
//window.location = $("#ManufacturerId").val();
}
function $6d5c05cfba139cb5$var$changeModel() {
    var modelName = $("#ModelId").val();
    $("#ModelName").val(modelName);
}
function $6d5c05cfba139cb5$export$561d62cccb15fe01() {
    if ($("[data-vans-landing-page]").length) {
        $(document).on("change", "#ManufacturerId", $6d5c05cfba139cb5$var$changeManufacturer);
        $(document).on("change", "#ModelId", $6d5c05cfba139cb5$var$changeModel);
    }
}


function $f673f4e358290dfb$var$onChangeFilters(event) {
    const costValue = $(this).val();
    if (costValue === "4") {
        $(".threeyear").hide();
        $(".fouryear").show();
    } else {
        $(".threeyear").show();
        $(".fouryear").hide();
    }
}
function $f673f4e358290dfb$export$ed89fd68baaffc46() {
    //dropdown changes
    $(document).on("change", "[data-running-costs-dropdown]", $f673f4e358290dfb$var$onChangeFilters);
}


const $94ae081d16a9769f$var$history = window.History;
function $94ae081d16a9769f$var$buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data, function(value, key) {
        if (key === "isPageChange") return;
        if (value) queryStringData[key] = value;
    });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}
function $94ae081d16a9769f$var$getData() {
    const dataArray = $("[data-fuel-cost-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function(item) {
        if (data[item.name]) {
            if (typeof data[item.name] === "string") data[item.name] = [
                data[item.name]
            ];
            data[item.name].push(item.value);
        } else data[item.name] = item.value;
    });
    return data;
}
function $94ae081d16a9769f$var$updateResultsLogic(isPageChange) {
    const data = $94ae081d16a9769f$var$getData();
    if (isPageChange) data.isPageChange = true;
    $94ae081d16a9769f$var$history.pushState(data, $("title").html(), location.pathname + "?" + $94ae081d16a9769f$var$buildUpQueryString(data));
    return data;
}
function $94ae081d16a9769f$var$triggerUpdateResults(event) {
    const mpg = $("#Mpg");
    const currentMpg = mpg.val();
    if ($(event.target).data("autocomplete") != null) return;
    if (event.target.name === "FuelType") $("#PencePerLitre").val("");
    if (event.target.name === "Mileage") {
        if (currentMpg === "") return;
    }
    const derivativeId = $("#DerivativeId");
    if (event.target.name === "ManufacturerId") {
        if (currentMpg !== "") mpg.val("");
        const modelGroupId = $("#ModelGroupId");
        if (modelGroupId.val() != null) {
            modelGroupId.val("");
            derivativeId.val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if (currentMpg !== "") mpg.val("");
        if (derivativeId.val() != null) derivativeId.val("");
    }
    window.updateVanFuelCostCalculator();
}
function $94ae081d16a9769f$var$calculateExtraMpg(event) {
    event.preventDefault();
    const mpg = $("#Mpg");
    const currentMpg = parseFloat(mpg.val());
    mpg.val(currentMpg + 5);
    window.updateVanFuelCostCalculator();
}
//function calculateExtra1P(event) {
//    event.preventDefault();
//    var currentPrice = parseFloat($("#PencePerLitre").val());;
//    $("#PencePerLitre").val(currentPrice + 1);
//    window.updateResults();
//}
function $94ae081d16a9769f$var$calculateExtra3P(event) {
    event.preventDefault();
    const pencePerLitre = $("#PencePerLitre");
    const currentPrice = parseFloat(pencePerLitre.val());
    pencePerLitre.val(currentPrice + 3);
    window.updateVanFuelCostCalculator();
}
function $94ae081d16a9769f$var$scrollToResult(event) {
    const penceperlitre = $("#PencePerLitre").val();
    const mileage = $("#Mileage").val();
    const mpg = $("#Mpg").val();
    let headerHeight = 300;
    if (window.isViewportLessThan("md")) headerHeight = 120;
    if (penceperlitre !== "" && mileage !== "" && mpg !== "") $("html, body").animate({
        scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
    }, 2000);
    if (penceperlitre !== "" && mileage !== "" && mpg === "") {
        $("[data-mpg-message]").append("<div class='alert alert-danger margin-bottom-15'>Please enter mpg or choose the make, model and version for us to find it for you.</div>");
        $("html, body").animate({
            scrollTop: $("[data-mpg-section]").offset().top - headerHeight
        }, 2000);
    }
}
function $94ae081d16a9769f$var$reloadQuery() {
    const state = $94ae081d16a9769f$var$history.getState();
    $.get("/diesel-cost-calculator/query", state.data, function(response) {
        $("[data-fuel-cost-query-attributes]").replaceWith(response);
    });
}
function $94ae081d16a9769f$var$updateState() {
    $94ae081d16a9769f$var$reloadQuery();
    const state = $94ae081d16a9769f$var$history.getState();
    $.get("/diesel-cost-calculator/results", state.data, function(response) {
        $("[data-fuel-cost-results-container]").replaceWith(response);
        if (response.indexOf("fuel-cost-calculator-result") !== -1) {
            let headerHeight = 300;
            if (window.isViewportLessThan("md")) headerHeight = 120;
            $("html, body").animate({
                scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
            }, 2000);
        }
    });
}
function $94ae081d16a9769f$export$922c8c7f19660105() {
    if (!$("[data-diesel-cost-calculator]").length) return;
    $(document).on("change", "[data-fuel-cost-query-attributes] input, [data-fuel-cost-query-attributes] select", $94ae081d16a9769f$var$triggerUpdateResults);
    $(document).on("click", "[data-recalculate-extra-mpg]", $94ae081d16a9769f$var$calculateExtraMpg);
    //$(document).on("click", "[data-recalculate-extra-1p]", calculateExtra1P);
    $(document).on("click", "[data-recalculate-extra-3p]", $94ae081d16a9769f$var$calculateExtra3P);
    $(document).on("click", "[data-view-result-button]", $94ae081d16a9769f$var$scrollToResult);
    // Bind to StateChange Event
    $94ae081d16a9769f$var$history.Adapter.bind(window, "statechange", $94ae081d16a9769f$var$updateState);
    window.updateVanFuelCostCalculator = function() {
        $94ae081d16a9769f$var$updateResultsLogic();
    };
}


var $67f53fcf4925a3cd$var$googleChartsLoaded = false;
function $67f53fcf4925a3cd$var$loadGoogleCharts() {
    return new Promise((resolve)=>{
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
        google.charts.setOnLoadCallback(function() {
            $67f53fcf4925a3cd$var$googleChartsLoaded = true;
            resolve();
        });
    });
}
const $67f53fcf4925a3cd$var$NewVehicles = {
    history: window.History,
    buildUpQueryString: function(nv_data) {
        const queryStringData = {};
        $.map(nv_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getData: function() {
        const dataArray = $("[data-one-link-new-vehicles-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function(item) {
            if (data[item.name]) {
                if (typeof data[item.name] === "string") data[item.name] = [
                    data[item.name]
                ];
                data[item.name].push(item.value);
            } else data[item.name] = item.value;
        });
        // Get the active tab
        var tabValue = $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").filter(".active").attr("id");
        // Add the active tab to the data
        data.tab = tabValue;
        data.FuelType = $("#FuelType").val() || null;
        return data;
    },
    updateResultsLogic: function(isPageChange) {
        const self = this;
        const data = self.getData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    reloadQuery: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-new-vehicles/query", state.data, function(response) {
            $("[data-one-link-new-vehicles-query-attributes]").replaceWith(response);
        });
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-new-vehicles/table-results", state.data, function(response) {
            $("[data-one-link-new-vehicles-table-results]").replaceWith(response);
        });
    },
    getChartData: function(state) {
        const self = this;
        $.get("/one-link-new-vehicles/get-chart-data", state.data, function(response) {
            console.log("Inside getChartData of NewVehicles");
            console.log("new vehicles: " + response);
            self.drawChartForMonths(state.data.tab, response);
        });
    },
    updateState: function() {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get("/one-link-new-vehicles/table-results", state.data, function(response) {
            $("[data-one-link-new-vehicles-table-results]").replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    drawChartForMonths: function(tab, rawDataNewVehicles) {
        console.log("chart loaded: " + $67f53fcf4925a3cd$var$googleChartsLoaded);
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var newVehiclesChartId = "curve_chart-" + tab;
                self.drawChart(newVehiclesChartId, rawDataNewVehicles);
            }
        } else // Set a timeout or some other method to wait until googleChartsLoaded becomes true
        setTimeout(()=>this.drawChartForMonths(tab, rawDataNewVehicles), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawChart: function(newVehiclesChartId, rawDataNewVehicles) {
        const self = this;
        var columnNames = [
            "Month",
            "Electric %",
            "Hybrid %",
            "Petrol %",
            "Diesel %"
        ];
        var selectedFuelType = (self.getParameterByName("FuelType") || "all").toLowerCase();
        if (selectedFuelType !== "all") {
            var fuelTypes = [
                "electric",
                "hybrid",
                "petrol",
                "diesel"
            ];
            var index = fuelTypes.indexOf(selectedFuelType);
            columnNames = [
                "Month",
                columnNames[index + 1]
            ];
        }
        var newVehiclesChartData = [
            columnNames
        ];
        for(var i = 0; i < rawDataNewVehicles.length; i++){
            var dateParts = rawDataNewVehicles[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var fuelTypeMapping = {
                "electric": "ev",
                "hybrid": "hyb",
                "petrol": "petrol",
                "diesel": "diesel"
            };
            if (selectedFuelType === "all") newVehiclesChartData.push([
                new Date(year, month),
                rawDataNewVehicles[i].evPercentage ? parseFloat(rawDataNewVehicles[i].evPercentage.toFixed(2)) : null,
                rawDataNewVehicles[i].hybPercentage ? parseFloat(rawDataNewVehicles[i].hybPercentage.toFixed(2)) : null,
                rawDataNewVehicles[i].petrolPercentage ? parseFloat(rawDataNewVehicles[i].petrolPercentage.toFixed(2)) : null,
                rawDataNewVehicles[i].dieselPercentage ? parseFloat(rawDataNewVehicles[i].dieselPercentage.toFixed(2)) : null
            ]);
            else if (rawDataNewVehicles[i].hasOwnProperty(fuelTypeMapping[selectedFuelType] + "Percentage")) newVehiclesChartData.push([
                new Date(year, month),
                rawDataNewVehicles[i][fuelTypeMapping[selectedFuelType] + "Percentage"] ? parseFloat(rawDataNewVehicles[i][fuelTypeMapping[selectedFuelType] + "Percentage"].toFixed(2)) : null
            ]);
        }
        var newVehiclesData = google.visualization.arrayToDataTable(newVehiclesChartData);
        var options = {
            curveType: "none",
            vAxis: {
                format: "#'%'"
            },
            hAxis: {
                format: "MMM yyyy",
                slantedText: true,
                slantedTextAngle: 45,
                ticks: newVehiclesData.getNumberOfRows() ? newVehiclesData.getDistinctValues(0) : []
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "5%",
                right: "5%",
                top: "10%",
                bottom: "15%",
                width: "100%",
                height: "82%"
            }
        };
        var newVehiclesChartDiv = document.getElementById(newVehiclesChartId);
        if (newVehiclesChartDiv) {
            // Create a chart instance
            var newVehiclesChart = new google.visualization.LineChart(newVehiclesChartDiv);
            // Clear the chart
            newVehiclesChart.clearChart();
            // Draw the chart with options and data.
            newVehiclesChart.draw(newVehiclesData, options);
        }
    },
    setupOneLinkNewVehicles: function() {
        const self = this;
        const FuelType = self.getParameterByName("FuelType");
        $(document).on("change", "[data-one-link-new-vehicles-query-attributes] input, [data-one-link-new-vehicles-query-attributes] select", function() {
            self.updateResultsLogic();
        });
        $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        // Pass FuelType and VehicleType to getChartData
        self.getChartData({
            data: {
                tab: "new-vehicles-tab1",
                FuelType: FuelType
            }
        });
        History.Adapter.bind(window, "statechange", function() {
            self.updateState();
        });
        window.updateResults = function() {
            self.updateResultsLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab");
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "new-vehicles-tab1";
            $("#" + tab).tab("show");
        }
        $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data and reload the table after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab,
                        FuelType: self.getParameterByName("FuelType")
                    }
                }; // Fetch FuelType from the URL
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show"); // <-- Move here
        // Explicitly call getChartData and reloadTable for the initial tab
        const state = {
            data: {
                tab: tab,
                FuelType: self.getParameterByName("FuelType")
            }
        }; // Fetch FuelType from the URL
        self.getChartData(state);
        self.reloadTable(state); // Update to pass full state
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// average lead times
const $67f53fcf4925a3cd$var$AverageLeadTimes = {
    history: window.History,
    buildUpQueryString: function(alt_data) {
        const queryStringData = {};
        $.map(alt_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageLeadTimesData: function() {
        // Get the active tab
        var tabValue = $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").filter(".active").attr("id");
        // Return a data object with the active tab
        return {
            tab: tabValue
        };
    },
    updateResultsAverageLeadTimesLogic: function(isPageChange) {
        const self = this;
        const data = self.getAverageLeadTimesData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function(state) {
        const self = this;
        $.get("/one-link-average-lead-times/get-chart-data", state.data, function(response) {
            self.drawAverageLeadTimesChartForMonths(state.data.tab, response);
        });
    },
    updateAverageLeadTimeState: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-average-lead-times/table-results", state.data, function(response) {
            $("[data-one-link-average-lead-times-table-results]").replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-average-lead-times/table-results", state.data, function(response) {
            $("[data-one-link-average-lead-times-table-results]").replaceWith(response);
        });
    },
    drawAverageLeadTimesChartForMonths: function(tab, rawData) {
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var chartId = "curve_chart-" + tab;
                self.drawAverageLeadTimesChart(chartId, rawData);
            }
        } else setTimeout(()=>this.drawAverageLeadTimesChartForMonths(tab, rawData), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawAverageLeadTimesChart: function(chartId, rawData) {
        var columnNames = [
            "Month",
            "Lead time (days)"
        ];
        var chartData = [
            columnNames
        ];
        for(var i = 0; i < rawData.length; i++){
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var leadTime = rawData[i].averageLeadTime ? parseFloat(rawData[i].averageLeadTime.toFixed(2)) : null;
            chartData.push([
                new Date(year, month),
                leadTime
            ]); // Add lead time data
        }
        var data = google.visualization.arrayToDataTable(chartData);
        var options = {
            curveType: "none",
            vAxis: {
                format: "#' day(s)'"
            },
            hAxis: {
                format: "MMM yyyy",
                slantedText: true,
                slantedTextAngle: 45,
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : [] // return distinct values from the first column (0 index) of the data
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "7%",
                right: "5%",
                top: "10%",
                bottom: "15%",
                width: "100%",
                height: "82%"
            }
        };
        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);
            // Clear the chart
            chart.clearChart();
            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAverageLeadTimes: function() {
        const self = this;
        $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        self.getChartData({
            data: {
                tab: "average-lead-times-tab1"
            }
        });
        History.Adapter.bind(window, "statechange", self.updateAverageLeadTimeState());
        window.updateResults = function() {
            self.updateResultsAverageLeadTimesLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab") || "average-lead-times-tab1";
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "average-lead-times-tab1";
            $("#" + tab).tab("show");
        }
        $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab
                    }
                };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show");
        const state = {
            data: {
                tab: tab
            }
        };
        self.getChartData(state);
        setTimeout(function() {
            self.reloadTable(state);
        }, 200); // delay of 200ms
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// Average age of fleet
const $67f53fcf4925a3cd$var$AverageAgeOfFleet = {
    history: window.History,
    buildUpQueryString: function(nv_data) {
        const queryStringData = {};
        $.map(nv_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageAgeOfFleetData: function() {
        const dataArray = $("[data-one-link-average-age-of-fleet-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function(item) {
            if (data[item.name]) {
                if (typeof data[item.name] === "string") data[item.name] = [
                    data[item.name]
                ];
                data[item.name].push(item.value);
            } else data[item.name] = item.value;
        });
        // Get the active tab
        var tabValue = $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").filter(".active").attr("id");
        // Add the active tab to the data
        data.tab = tabValue;
        data.VehicleType = $("#VehicleType").val() || null;
        return data;
    },
    updateResultsAverageAgeOfFleetLogic: function(isPageChange) {
        const self = this;
        const data = self.getAverageAgeOfFleetData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    reloadQuery: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-average-age-of-fleet-entering-workshop/query", state.data, function(response) {
            $("[data-one-link-average-age-of-fleet-query-attributes]").replaceWith(response);
        });
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-average-age-of-fleet-entering-workshop/table-results", state.data, function(response) {
            $("[data-one-link-average-age-of-fleet-table-results]").replaceWith(response);
        });
    },
    getAverageAgeOfFleetChartData: function(state) {
        const self = this;
        $.get("/one-link-average-age-of-fleet-entering-workshop/get-chart-data", state.data, function(response) {
            console.log("Inside getAverageAgeOfFleetChartData of AverageAgeOfFleet");
            console.log("age: " + response);
            self.drawAverageAgeOfFleetChartForMonths(state.data.tab, response);
        });
    },
    updateAverageAgeOfFleetState: function() {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get("/one-link-average-age-of-fleet-entering-workshop/table-results", state.data, function(response) {
            $("[data-one-link-average-age-of-fleet-table-results]").replaceWith(response);
        });
        self.getAverageAgeOfFleetChartData(self.history.getState());
    },
    drawAverageAgeOfFleetChartForMonths: function(tab, drawAverageAgeOfFleetChart) {
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var ageOfFleetChartId = "curve_chart-" + tab;
                self.drawAverageAgeOfFleetChart(ageOfFleetChartId, drawAverageAgeOfFleetChart);
            }
        } else setTimeout(()=>this.drawAverageAgeOfFleetChartForMonths(tab, drawAverageAgeOfFleetChart), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawAverageAgeOfFleetChart: function(ageOfFleetChartId, rawDataAverageAgeOfFleet) {
        const self = this;
        var columnNames = [
            "Month",
            "Cars (years)",
            "Vans (years)"
        ];
        var selectedVehicleType = (self.getParameterByName("VehicleType") || "all").toLowerCase();
        if (selectedVehicleType !== "all") {
            var vehicleTypes = [
                "cars",
                "vans"
            ];
            var index = vehicleTypes.indexOf(selectedVehicleType);
            columnNames = [
                "Month",
                columnNames[index + 1]
            ];
        }
        var chartData = [
            columnNames
        ];
        for(var i = 0; i < rawDataAverageAgeOfFleet.length; i++){
            var dateParts = rawDataAverageAgeOfFleet[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var vehicleTypeMapping = {
                "cars": "averageCarAge",
                "vans": "averageVanAge"
            };
            if (selectedVehicleType === "all") chartData.push([
                new Date(year, month),
                rawDataAverageAgeOfFleet[i].averageCarAge ? parseFloat(rawDataAverageAgeOfFleet[i].averageCarAge.toFixed(2)) : null,
                rawDataAverageAgeOfFleet[i].averageVanAge ? parseFloat(rawDataAverageAgeOfFleet[i].averageVanAge.toFixed(2)) : null
            ]);
            else if (rawDataAverageAgeOfFleet[i].hasOwnProperty(vehicleTypeMapping[selectedVehicleType])) chartData.push([
                new Date(year, month),
                rawDataAverageAgeOfFleet[i][vehicleTypeMapping[selectedVehicleType]] ? parseFloat(rawDataAverageAgeOfFleet[i][vehicleTypeMapping[selectedVehicleType]].toFixed(2)) : null
            ]);
        }
        var data = google.visualization.arrayToDataTable(chartData);
        var options = {
            curveType: "none",
            vAxis: {
                format: "#' year(s)'"
            },
            hAxis: {
                format: "MMM yyyy",
                slantedText: true,
                slantedTextAngle: 45,
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "7%",
                right: "5%",
                top: "10%",
                bottom: "15%",
                width: "100%",
                height: "82%"
            }
        };
        var ageOfFleetChartDiv = document.getElementById(ageOfFleetChartId);
        if (ageOfFleetChartDiv) {
            // Create a chart instance
            var ageOfFleetChart = new google.visualization.LineChart(ageOfFleetChartDiv);
            // Clear the chart
            ageOfFleetChart.clearChart();
            // Draw the chart with options and data.
            ageOfFleetChart.draw(data, options);
        }
    },
    setupOneLinkAverageAgeOfFleet: function() {
        const self = this;
        const VehicleType = self.getParameterByName("VehicleType");
        $(document).on("change", "[data-one-link-average-age-of-fleet-query-attributes] input, [data-one-link-average-age-of-fleet-query-attributes] select", ()=>self.updateResultsAverageAgeOfFleetLogic());
        $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        self.getAverageAgeOfFleetChartData({
            data: {
                tab: "average-age-of-fleet-tab1"
            },
            VehicleType: VehicleType
        });
        History.Adapter.bind(window, "statechange", ()=>self.updateAverageAgeOfFleetState());
        window.updateResults = function() {
            self.updateResultsAverageAgeOfFleetLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab");
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "average-age-of-fleet-tab1";
            $("#" + tab).tab("show");
        }
        $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab,
                        VehicleType: self.getParameterByName("VehicleType")
                    }
                }; // Fetch FuelType from the URL
                self.getAverageAgeOfFleetChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show");
        // Explicitly call getChartData and reloadTable for the initial tab
        const state = {
            data: {
                tab: tab,
                VehicleType: self.getParameterByName("VehicleType")
            }
        }; // Fetch FuelType from the URL
        self.getAverageAgeOfFleetChartData(state);
        self.reloadTable(state); // Update to pass full state
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// average fleet vehicle downtime
const $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime = {
    history: window.History,
    buildUpQueryString: function(alt_data) {
        const queryStringData = {};
        $.map(alt_data, function(value, key) {
            if (key === "isPageChange") return;
            if (value) queryStringData[key] = value;
        });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageFleetVehicleDowntimeData: function() {
        // Get the active tab
        var tabValue = $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").filter(".active").attr("id");
        // Return a data object with the active tab
        return {
            tab: tabValue
        };
    },
    updateResultsAverageFleetVehicleDowntimeLogic: function(isPageChange) {
        const self = this;
        const data = self.getAverageFleetVehicleDowntimeData();
        if (isPageChange) data.isPageChange = true;
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function(state) {
        const self = this;
        $.get("/one-link-average-fleet-vehicle-downtime/get-chart-data", state.data, function(response) {
            self.drawAverageFleetVehicleDowntimeChartForMonths(state.data.tab, response);
        });
    },
    reloadTable: function(state) {
        const self = this;
        $.get("/one-link-average-fleet-vehicle-downtime/table-results", state.data, function(response) {
            $("[data-one-link-average-fleet-vehicle-downtime-table-results]").replaceWith(response);
        });
    },
    updateAverageFleetVehicleDowntimeState: function() {
        const self = this;
        const state = self.history.getState();
        $.get("/one-link-average-fleet-vehicle-downtime/table-results", state.data, function(response) {
            $("[data-one-link-average-fleet-vehicle-downtime-table-results]").replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    drawAverageFleetVehicleDowntimeChartForMonths: function(tab, rawData) {
        if ($67f53fcf4925a3cd$var$googleChartsLoaded) {
            if ($("#" + tab).hasClass("active")) {
                const self = this;
                var chartId = "curve_chart-" + tab;
                self.drawAverageFleetVehicleDowntimeChart(chartId, rawData);
            }
        } else setTimeout(()=>this.drawAverageFleetVehicleDowntimeChartForMonths(tab, rawData), 1000);
    },
    getParameterByName: function(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    drawAverageFleetVehicleDowntimeChart: function(chartId, rawData) {
        var columnNames = [
            "Month",
            "Avg days vehicle taken off road (days)"
        ];
        var chartData = [
            columnNames
        ];
        for(var i = 0; i < rawData.length; i++){
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = {
                Jan: 0,
                Feb: 1,
                Mar: 2,
                Apr: 3,
                May: 4,
                Jun: 5,
                Jul: 6,
                Aug: 7,
                Sep: 8,
                Oct: 9,
                Nov: 10,
                Dec: 11
            };
            var month = monthMapping[dateParts[0]];
            var vor = rawData[i].averageVOR ? parseFloat(rawData[i].averageVOR.toFixed(2)) : null;
            chartData.push([
                new Date(year, month),
                vor
            ]); // Add 
        }
        var data = google.visualization.arrayToDataTable(chartData);
        var options = {
            curveType: "none",
            vAxis: {
                minValue: 1.50,
                maxValue: 2.00,
                format: "#.00' day(s)'" // Added '.00' to display two decimal places
            },
            hAxis: {
                format: "MMM yyyy",
                slantedText: true,
                slantedTextAngle: 45,
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: "top",
                alignment: "start"
            },
            series: {
                0: {
                    lineWidth: 1,
                    pointSize: 5
                },
                1: {
                    lineWidth: 1,
                    pointSize: 5
                },
                2: {
                    lineWidth: 1,
                    pointSize: 5
                },
                3: {
                    lineWidth: 1,
                    pointSize: 5
                }
            },
            chartArea: {
                left: "10%",
                right: "5%",
                top: "10%",
                bottom: "15%",
                width: "100%",
                height: "82%"
            }
        };
        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);
            // Clear the chart
            chart.clearChart();
            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAverageFleetVehicleDowntime: function() {
        const self = this;
        $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").on("click", function(e) {
            // Stop the browser from following the link
            e.preventDefault();
            // Show the tab
            $(this).tab("show");
            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set("tab", $(this).attr("id"));
            window.history.replaceState({}, "", url);
        });
        self.getChartData({
            data: {
                tab: "average-fleet-vehicle-downtime-tab1"
            }
        });
        History.Adapter.bind(window, "statechange", self.updateAverageFleetVehicleDowntimeState());
        window.updateResults = function() {
            self.updateResultsAverageFleetVehicleDowntimeLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get("tab") || "average-fleet-vehicle-downtime-tab1";
        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) $("#" + tab).tab("show");
        else {
            tab = "average-fleet-vehicle-downtime-tab1";
            $("#" + tab).tab("show");
        }
        $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").on("shown.bs.tab", function(e) {
            const tab = $(this).attr("id");
            // Only fetch the chart data after the tab has been shown
            if ($("#" + tab).hasClass("active")) {
                const state = {
                    data: {
                        tab: tab
                    }
                };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });
        $("#" + tab).tab("show"); // <-- Move here
        const state = {
            data: {
                tab: tab
            }
        };
        self.getChartData(state);
        setTimeout(function() {
            self.reloadTable(state);
        }, 200); // delay of 200ms
        google.charts.load("current", {
            "packages": [
                "corechart"
            ]
        });
    }
};
// Main entry point
$(function() {
    $67f53fcf4925a3cd$var$loadGoogleCharts().then(()=>{
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === "OneLinkNewVehicles") $67f53fcf4925a3cd$var$NewVehicles.setupOneLinkNewVehicles();
        else if (pageType === "OneLinkAverageVehicleWorkshopLeadTime") $67f53fcf4925a3cd$var$AverageLeadTimes.setupOneLinkAverageLeadTimes();
        else if (pageType === "OneLinkAverageAgeOfFleetEnteringWorkshop") $67f53fcf4925a3cd$var$AverageAgeOfFleet.setupOneLinkAverageAgeOfFleet();
        else if (pageType === "OneLinkAverageFleetVehicleDowntime") $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime.setupOneLinkAverageFleetVehicleDowntime();
    });
});
$(window).resize(function() {
    const pageType = $("#PageType").val();
    if (pageType === "OneLinkNewVehicles") {
        const activeTab = $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$NewVehicles.getChartData({
            data: {
                tab: activeTab
            }
        });
    } else if (pageType === "OneLinkAverageVehicleWorkshopLeadTime") {
        const activeTab = $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$AverageLeadTimes.getChartData({
            data: {
                tab: activeTab
            }
        });
    } else if (pageType === "OneLinkAverageAgeOfFleetEnteringWorkshop") {
        const activeTab = $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$AverageAgeOfFleet.getAverageAgeOfFleetChartData({
            data: {
                tab: activeTab
            }
        });
    } else if (pageType === "OneLinkAverageFleetVehicleDowntime") {
        const activeTab = $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").filter(".active").attr("id");
        $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime.getChartData({
            data: {
                tab: activeTab
            }
        });
    }
});
function $67f53fcf4925a3cd$export$2fc82e8c97ef8c9() {
    $67f53fcf4925a3cd$var$NewVehicles.setupOneLinkNewVehicles();
}
function $67f53fcf4925a3cd$export$a2019de311dd36b1() {
    $67f53fcf4925a3cd$var$AverageLeadTimes.setupOneLinkAverageLeadTimes();
}
function $67f53fcf4925a3cd$export$fdfdd5222f7281c9() {
    $67f53fcf4925a3cd$var$AverageAgeOfFleet.setupOneLinkAverageAgeOfFleet();
}
function $67f53fcf4925a3cd$export$ef7c49e4953bcf45() {
    $67f53fcf4925a3cd$var$AverageFleetVehicleDowntime.setupOneLinkAverageFleetVehicleDowntime();
}




function $6ea470b57a43d375$export$166b3207e907464c() {
    const $slider = $(".ewif-testimonials-slider");
    if (!$slider.length) {
        console.warn("Slider element .ewif-testimonials-slider not found");
        return;
    }
    // Calculate the maximum height of all slides
    const $slides = $slider.find(".swiper-slide");
    let maxHeight = 0;
    $slides.each(function() {
        const slideHeight = $(this).outerHeight();
        if (slideHeight > maxHeight) maxHeight = slideHeight;
    });
    // Apply the maximum height to all slides
    if (maxHeight > 0) $slides.css("min-height", `${maxHeight}px`);
    new (0, $f564a415f4d19b8d$export$25ce5a424b770e84)(".ewif-testimonials-slider", {
        modules: [
            (0, $eaaaf8b39da376c0$export$2e2bcd8739ae039),
            (0, $eaf75da0b716a547$export$2e2bcd8739ae039)
        ],
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        loop: false,
        // Remove autoHeight to prevent dynamic resizing
        // autoHeight: true,
        speed: 1000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    });
}


(0, $2892d4b3a4bd7b1c$export$5d0cc2edc113f064)();
function $cbbf978695a69611$var$needsGoogleCharts() {
    const pageType = $("#PageType").val();
    const chartPages = [
        "OneLinkNewVehicles",
        "OneLinkAverageVehicleWorkshopLeadTime",
        "OneLinkAverageAgeOfFleetEnteringWorkshop",
        "OneLinkAverageFleetVehicleDowntime"
    ];
    return chartPages.includes(pageType);
}
$(()=>{
    //Ignore datatable alert messages (errors)
    $.fn.dataTable.ext.errMode = "none";
    (0, $c80792d02f0f6a54$export$f80078829203ea32)();
    (0, $6ba8f3756a604e1e$export$a391e9e11dfa825a)();
    (0, $02ccdfd5868f53aa$export$b2bb814f390b8ca1)();
    (0, $41f3be02cf03cd10$export$d1979b506d91f67d)();
    (0, $c26879fdf7f36150$export$a6a4a29a790aae85)();
    (0, $0931948934220f52$export$30c8b39afd1a4d2b)();
    (0, $06aa7a5ca72b8734$export$4480b153ba60206d)();
    (0, $c0e2aeb39b8be769$export$d0990ca26e3a22f3)();
    (0, $593cd257706de00c$export$53c248b281253aba)();
    (0, $728b06aeb66604b2$export$a09f327970c84284)();
    (0, $aca60e5b2e026969$export$ce72890db155540c)();
    (0, $94302a5ffb81bfa2$export$a364db890d354a0c)();
    (0, $d700ac7e948a3f2e$export$d9879cc485083cbe)();
    (0, $fee793ddf9b673e0$export$c95db721723386e7)();
    (0, $a14a535463e27110$export$2d8fba0164856121)();
    (0, $7ef9cb8dc2b7724c$export$55fbd5f0890cdf7e)();
    (0, $165cb073955e137a$export$94d83d887297dd2)();
    (0, $82264929ebb8a49e$export$10b45b794006d1d0)();
    (0, $4c3677df652e2937$export$7b633cd5cf57daa2)();
    (0, $3e663d5dbb36a26e$export$124a9858458e53dc)();
    (0, $9e13b2ad467bb145$export$54941c72d7452803)();
    (0, $a83f24934579ebaa$export$85500d64d8b96a12)();
    (0, $0223437a5c85c95b$export$b62efe4e2fbde874)();
    (0, $87b693ffb012c6f5$export$a7425bd496405417)();
    (0, $6ea470b57a43d375$export$166b3207e907464c)();
    // setupFuelCostCalculator();
    // setupFuelTypeButtons();
    (0, $935dae51dafb9406$export$f0c7f3aad087f331)();
    (0, $1681bada7f12e93a$export$8ffecd3ecbf5a7bf)();
    (0, $1062b41150fcb383$export$2b2ccfd71dd67323)();
    (0, $99ad575d7443e4d6$export$7689f9df4f599197)();
    (0, $fe07b9887899a8fb$export$7c7fd016d0e808fe)();
    (0, $1e7dc984495afd55$export$536c895956e6bdad)();
    (0, $c4df93a4feca97f3$export$332cf1f44c0656c1)();
    (0, $a51221e90ccfb5f2$export$1254953e51e11fff)();
    (0, $3bc885c99072932d$export$e09e8541d6e6379b)();
    (0, $ff2e9cac1156f2ea$export$376e40bec80c21a)();
    (0, $a8340321fe089932$export$ae69331b624aa7a)();
    (0, $86f87e45f0071f3a$export$6f277b52b642b4f9)();
    (0, $b9c76af634f3d75b$export$af46fff3f8bb6cb0)();
    (0, $cb041d180d1b1b5e$export$b16f720339b8b3cd)();
    (0, $29b334ac16b2381b$export$953e2b044b74bd66)();
    (0, $b0c1205ab438e8b5$export$abf0c736cc0404e4)();
    (0, $a45552c76e7ee752$export$b4ebbdbd9d8b89a1)();
    (0, $de5410f3f786fb03$export$ea92669c2bcde238)();
    (0, $631d9a7494b6c619$export$9ef30b34c240b3e6)();
    (0, $a44a9adb885e4949$export$5a34e6870ef2f82e)();
    (0, $57a44814a6005e07$export$29a95a623dfab103)();
    (0, $6d5c05cfba139cb5$export$561d62cccb15fe01)();
    (0, $f673f4e358290dfb$export$ed89fd68baaffc46)();
    (0, $94ae081d16a9769f$export$922c8c7f19660105)();
    if ($cbbf978695a69611$var$needsGoogleCharts()) {
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === "OneLinkNewVehicles") (0, $67f53fcf4925a3cd$export$2fc82e8c97ef8c9)();
        else if (pageType === "OneLinkAverageVehicleWorkshopLeadTime") setupOneLinkAverageLeadTimes();
        else if (pageType === "OneLinkAverageAgeOfFleetEnteringWorkshop") setupOneLinkAverageAgeOfFleet();
        else if (pageType === "OneLinkAverageFleetVehicleDowntime") setupOneLinkAverageFleetVehicleDowntime();
    }
    const qrCodeDataElement = document.getElementById("qrCodeData");
    if (qrCodeDataElement) {
        const uri = qrCodeDataElement.getAttribute("data-url");
        new QRCode(document.getElementById("qrCode"), {
            text: uri,
            width: 150,
            height: 150
        });
    }
});

})();
//# sourceMappingURL=fleet-news.js.map
